{
  "common": {
    "address": "Adrese",
    "id": "ID",
    "yes": "Jā",
    "no": "Nē",
    "all": "Visi",
    "mixed": "Jaukts",
    "unknown": "Nezināms",
    "read_more_button": "Uzzināt vairāk",
    "click_to_learn_more": "Noklikšķiniet, lai uzzinātu vairāk",
    "none": "Nav",
    "other": "Cits",
    "edit": "Rediģēt",
    "date": "Datums: {date}",
    "kw": "kW",
    "kwh": "kWh",
    "mwh": "MWh",
    "gwh": "GWh",
    "eur": "€",
    "months_abbrev": {
      "1": "Janv",
      "2": "Febr",
      "3": "Marts",
      "4": "Apr",
      "5": "Maijs",
      "6": "Jūnijs",
      "7": "Jūlijs",
      "8": "Aug",
      "9": "Sept",
      "10": "Okt",
      "11": "Nov",
      "12": "Dec"
    },
    "next": "Tālāk",
    "back": "Atpakaļ",
    "save": "Saglabāt",
    "saving": "Saglabā",
    "cancel": "Atcelt",
    "confirm": "Apstiprināt",
    "continue": "Turpināt",
    "step": "Solis",
    "optional": "Neobligāti",
    "saved_successfully": "Veiksmīgi saglabāts",
    "unsaved_changes_confirm": "Jums ir nesaglabātas izmaiņas. Pamest šo lapu un tās atmest?",
    "clear": "Notīrīt",
    "filter": "Filtrēt",
    "search": "Meklēt",
    "select": "Izvēlēties",
    "select_all": "Izvēlēties visu",
    "clear_all": "Notīrīt izvēli",
    "pricing_loading_messages": {
      "retrieving_market_levels": "Iegūstam tirgus cenu līmeņus...",
      "applying_sourcing_criteria": "Piemērojam piegādes kritērijus...",
      "calculating_fees": "Aprēķinām maksas..."
    },
    "selected": "izvēlēts",
    "total_volume": "Kopējais apjoms",
    "last_updated": "Pēdējoreiz atjaunināts",
    "certificate": "Sertifikāts",
    "volume": "Apjoms",
    "technology_label": "Tehnoloģija",
    "uploaded": "Augšupielādēts",
    "not_uploaded": "Nav augšupielādēts",
    "any_file_format": "Visi failu formāti ir piemēroti",
    "pdf_file_format": "Augšupielādētajiem failiem jābūt .pdf formātā",
    "invalid_file_error": "Šis fails nav pareizs, lūdzu, augšupielādējiet pareizo failu",
    "invalid_file_contact_support": "Ja uzskatāt, ka tas ir kļūda un šis dokuments patiešām ir derīgs, lūdzu, sazinieties ar mūsu klientu atbalsta dienestu. Lai to izdarītu, lūdzu, noklikšķiniet uz tērzēšanas burbuļa ekrāna apakšējā labajā stūrī vai izvēlieties 'Sazināties ar mums' no augšējās izvēlnes.",
    "coming_soon": "Drīzumā!",
    "contactSupport": "Sazināties ar atbalsta dienestu",
    "loading": "Notiek ielāde",
    "uploading": "Augšupielādē...",
    "pending": "Gaida",
    "rejected": "Noraidīts",
    "active": "Aktīvs",
    "status": "Statuss:",
    "add": "Pievienot",
    "creating": "Veido...",
    "create_device": "Izveidot ierīci",
    "not_specified": "Nav norādīts",
    "page_navigation": "Lappušu navigācija",
    "previous_page": "Iepriekšējā lappuse",
    "next_page": "Nākamā lappuse",
    "remove": "Noņemt",
    "delete": "Dzēst",
    "deleted": "(dzēsts)",
    "add_another_unit": "Pievienot vēl vienu vienību",
    "saved": "Saglabāts",
    "retry": "Atkārtot",
    "download": "Lejupielādēt",
    "close": "Aizvērt",
    "open_pdf": "Atvērt PDF",
    "success": "Veiksmīgi",
    "unexpected_error": "Negaidīta kļūda, mēģiniet vēlreiz vēlāk!",
    "select_option": "Lūdzu izvēlieties...",
    "year": "Gads",
    "years": "Gadi",
    "month": "Mēnesis",
    "months": "Mēneši",
    "day": "Diena",
    "select_month": "Izvēlieties mēnesi",
    "select_day": "Izvēlieties dienu",
    "full_name": "Vārds un uzvārds",
    "name": "Nosaukums",
    "start_date": "Sākuma datums",
    "end_date": "Beigu datums",
    "email": "E-pasts",
    "company_search": {
      "label": "Uzņēmumu meklēšana",
      "description": "Meklēt uzņēmumu pēc nosaukuma, reģistrācijas numura vai PVN numura",
      "placeholder": "Ievadiet uzņēmuma nosaukumu, reģistrācijas numuru vai PVN",
      "ai_extracted": "AI ekstraktēts",
      "custom_entry": "Pielāgots ieraksts",
      "unavailable": "Uzņēmumu meklēšana nav pieejama, ievadiet uzņēmuma datus manuāli"
    },
    "counterparty_picker": {
      "company_label": "Uzņēmuma nosaukums",
      "account_label": "Reģistra konta numurs",
      "account_invalid": "Konta numurs drīkst saturēt tikai burtus un ciparus",
      "account_invalid_aib": "Jābūt derīgam EECS identifikatoram (2 cipari, X un 7 burtcipari)",
      "account_invalid_rego": "Jābūt Ofgem konta numuram (GEN, PAR, SUP vai AGE, kam seko 7 cipari)",
      "account_invalid_rgp": "Jābūt TGE dalībnieka kodam (burti un cipari, piem., RESENENC)",
      "account_unrecognized_warning": "Nav atpazīts konta numura formāts - reģistra valsti nevar noteikt automātiski.",
      "internal_account_label": "Reģistra iekšējā konta numurs",
      "internal_account_help": "Neobligāti. Nepieciešams tikai reģistriem, kas izmanto apakškontus.",
      "internal_account_placeholder": "Neobligāts apakškonta ID"
    },
    "eecs_name_mismatch": {
      "both": "Uzņēmuma nosaukums un EECS nesakrīt. {name} atbilst EECS: {expectedEecs} un {eecs} atbilst uzņēmumam {expectedName}",
      "eecs_only": "Uzņēmuma nosaukums un EECS nesakrīt. Uzņēmumam {name} nav atbilstoša EECS un {eecs} atbilst uzņēmumam {expectedName}",
      "name_only": "Uzņēmuma nosaukums un EECS nesakrīt. {name} atbilst EECS: {expectedEecs} un {eecs} neatbilst nevienam uzņēmumam",
      "unknown_counterparty": "Pārbaudiet uzņēmuma nosaukumu un konta numuru līgumā."
    },
    "no_results": "Nav atrasti rezultāti",
    "partial_results": "Rāda pirmās {shown} no {total} atbilstībām — precizējiet meklēšanu",
    "technology": {
      "solar": "Saules",
      "wind": "Vēja",
      "hydro": "Hidro",
      "biomass": "Biomasa",
      "nuclear": "Kodolenerģija",
      "mixed": "Jaukts"
    },
    "country": {
      "AD": "Andora",
      "AE": "Apvienotie Arābu Emirāti",
      "AF": "Afganistāna",
      "AG": "Antigva un Barbuda",
      "AI": "Angilja",
      "AL": "Albānija",
      "AM": "Armēnija",
      "AO": "Angola",
      "AQ": "Antarktika",
      "AR": "Argentīna",
      "AS": "ASV Samoa",
      "AT": "Austrija",
      "AU": "Austrālija",
      "AW": "Aruba",
      "AX": "Olandes salas",
      "AZ": "Azerbaidžāna",
      "BA": "Bosnija un Hercegovina",
      "BB": "Barbadosa",
      "BD": "Bangladeša",
      "BE": "Beļģija",
      "BF": "Burkinafaso",
      "BG": "Bulgārija",
      "BH": "Bahreina",
      "BI": "Burundija",
      "BJ": "Benina",
      "BL": "Senbartelmī",
      "BM": "Bermudu salas",
      "BN": "Bruneja",
      "BO": "Bolīvija",
      "BQ": "Nīderlandes Karību salas",
      "BR": "Brazīlija",
      "BS": "Bahamu salas",
      "BT": "Butāna",
      "BV": "Buvē sala",
      "BW": "Botsvāna",
      "BY": "Baltkrievija",
      "BZ": "Beliza",
      "CA": "Kanāda",
      "CC": "Kokosu (Kīlinga) salas",
      "CD": "Kongo (Kinšasa)",
      "CF": "Centrālāfrikas Republika",
      "CG": "Kongo (Brazavila)",
      "CH": "Šveice",
      "CI": "Kotdivuāra",
      "CK": "Kuka salas",
      "CL": "Čīle",
      "CM": "Kamerūna",
      "CN": "Ķīna",
      "CO": "Kolumbija",
      "CR": "Kostarika",
      "CU": "Kuba",
      "CV": "Kaboverde",
      "CW": "Kirasao",
      "CX": "Ziemsvētku sala",
      "CY": "Kipra",
      "CZ": "Čehija",
      "DE": "Vācija",
      "DJ": "Džibutija",
      "DK": "Dānija",
      "DM": "Dominika",
      "DO": "Dominikāna",
      "DZ": "Alžīrija",
      "EC": "Ekvadora",
      "EE": "Igaunija",
      "EG": "Ēģipte",
      "EH": "Rietumsahāra",
      "ER": "Eritreja",
      "ES": "Spānija",
      "ET": "Etiopija",
      "FI": "Somija",
      "FJ": "Fidži",
      "FK": "Folklenda salas",
      "FM": "Mikronēzija",
      "FO": "Fēru salas",
      "FR": "Francija",
      "GA": "Gabona",
      "GB": "Apvienotā Karaliste",
      "GD": "Grenāda",
      "GE": "Gruzija",
      "GF": "Francijas Gviāna",
      "GG": "Gērnsija",
      "GH": "Gana",
      "GI": "Gibraltārs",
      "GL": "Grenlande",
      "GM": "Gambija",
      "GN": "Gvineja",
      "GP": "Gvadelupa",
      "GQ": "Ekvatoriālā Gvineja",
      "GR": "Grieķija",
      "GS": "Dienviddžordžija un Dienvidsendviču salas",
      "GT": "Gvatemala",
      "GU": "Guama",
      "GW": "Gvineja-Bisava",
      "GY": "Gajāna",
      "HK": "Ķīnas īpašās pārvaldes apgabals Honkonga",
      "HM": "Hērda sala un Makdonalda salas",
      "HN": "Hondurasa",
      "HR": "Horvātija",
      "HT": "Haiti",
      "HU": "Ungārija",
      "ID": "Indonēzija",
      "IE": "Īrija",
      "IL": "Izraēla",
      "IM": "Menas sala",
      "IN": "Indija",
      "IO": "Indijas okeāna Britu teritorija",
      "IQ": "Irāka",
      "IR": "Irāna",
      "IS": "Islande",
      "IT": "Itālija",
      "JE": "Džērsija",
      "JM": "Jamaika",
      "JO": "Jordānija",
      "JP": "Japāna",
      "KE": "Kenija",
      "KG": "Kirgizstāna",
      "KH": "Kambodža",
      "KI": "Kiribati",
      "KM": "Komoru salas",
      "KN": "Sentkitsa un Nevisa",
      "KP": "Ziemeļkoreja",
      "KR": "Dienvidkoreja",
      "KW": "Kuveita",
      "KY": "Kaimanu salas",
      "KZ": "Kazahstāna",
      "LA": "Laosa",
      "LB": "Libāna",
      "LC": "Sentlūsija",
      "LI": "Lihtenšteina",
      "LK": "Šrilanka",
      "LR": "Libērija",
      "LS": "Lesoto",
      "LT": "Lietuva",
      "LU": "Luksemburga",
      "LV": "Latvija",
      "LY": "Lībija",
      "MA": "Maroka",
      "MC": "Monako",
      "MD": "Moldova",
      "ME": "Melnkalne",
      "MF": "Senmartēna",
      "MG": "Madagaskara",
      "MH": "Māršala salas",
      "MK": "Ziemeļmaķedonija",
      "ML": "Mali",
      "MM": "Mjanma (Birma)",
      "MN": "Mongolija",
      "MO": "ĶTR īpašais administratīvais reģions Makao",
      "MP": "Ziemeļu Marianas salas",
      "MQ": "Martinika",
      "MR": "Mauritānija",
      "MS": "Montserrata",
      "MT": "Malta",
      "MU": "Maurīcija",
      "MV": "Maldīvija",
      "MW": "Malāvija",
      "MX": "Meksika",
      "MY": "Malaizija",
      "MZ": "Mozambika",
      "NA": "Namībija",
      "NC": "Jaunkaledonija",
      "NE": "Nigēra",
      "NF": "Norfolkas sala",
      "NG": "Nigērija",
      "NI": "Nikaragva",
      "NL": "Nīderlande",
      "NO": "Norvēģija",
      "NP": "Nepāla",
      "NR": "Nauru",
      "NU": "Niue",
      "NZ": "Jaunzēlande",
      "OM": "Omāna",
      "PA": "Panama",
      "PE": "Peru",
      "PF": "Francijas Polinēzija",
      "PG": "Papua-Jaungvineja",
      "PH": "Filipīnas",
      "PK": "Pakistāna",
      "PL": "Polija",
      "PM": "Senpjēra un Mikelona",
      "PN": "Pitkērnas salas",
      "PR": "Puertoriko",
      "PS": "Palestīnas teritorijas",
      "PT": "Portugāle",
      "PW": "Palau",
      "PY": "Paragvaja",
      "QA": "Katara",
      "RE": "Reinjona",
      "RO": "Rumānija",
      "RS": "Serbija",
      "RU": "Krievija",
      "RW": "Ruanda",
      "SA": "Saūda Arābija",
      "SB": "Zālamana salas",
      "SC": "Seišelu salas",
      "SD": "Sudāna",
      "SE": "Zviedrija",
      "SG": "Singapūra",
      "SH": "Sv.Helēnas sala",
      "SI": "Slovēnija",
      "SJ": "Svalbāra un Jana Majena sala",
      "SK": "Slovākija",
      "SL": "Sjerraleone",
      "SM": "Sanmarīno",
      "SN": "Senegāla",
      "SO": "Somālija",
      "SR": "Surinama",
      "SS": "Dienvidsudāna",
      "ST": "Santome un Prinsipi",
      "SV": "Salvadora",
      "SX": "Sintmārtena",
      "SY": "Sīrija",
      "SZ": "Svatini",
      "TC": "Tērksas un Kaikosas salas",
      "TD": "Čada",
      "TF": "Francijas Dienvidjūru teritorija",
      "TG": "Togo",
      "TH": "Taizeme",
      "TJ": "Tadžikistāna",
      "TK": "Tokelau",
      "TL": "Austrumtimora",
      "TM": "Turkmenistāna",
      "TN": "Tunisija",
      "TO": "Tonga",
      "TR": "Turcija",
      "TT": "Trinidāda un Tobāgo",
      "TV": "Tuvalu",
      "TW": "Taivāna",
      "TZ": "Tanzānija",
      "UA": "Ukraina",
      "UG": "Uganda",
      "UM": "ASV Mazās Aizjūras salas",
      "US": "Amerikas Savienotās Valstis",
      "UY": "Urugvaja",
      "UZ": "Uzbekistāna",
      "VA": "Vatikāns",
      "VC": "Sentvinsenta un Grenadīnas",
      "VE": "Venecuēla",
      "VG": "Britu Virdžīnas",
      "VI": "ASV Virdžīnas",
      "VN": "Vjetnama",
      "VU": "Vanuatu",
      "WF": "Volisa un Futunas salas",
      "WS": "Samoa",
      "XK": "Kosova",
      "YE": "Jemena",
      "YT": "Majota",
      "ZA": "Dienvidāfrikas Republika",
      "ZM": "Zambija",
      "ZW": "Zimbabve",
      "BE_BRU": "Beļģija (Brisele)",
      "BE_FED": "Beļģija (Federālā)",
      "BE_FLA": "Beļģija (Flandrija)",
      "BE_WAL": "Beļģija (Valonija)",
      "other": "Citas"
    },
    "done": "Paveikts",
    "company": "Uzņēmums",
    "companies": "Uzņēmumi",
    "search_companies": "Meklēt uzņēmumus",
    "select_companies": "Izvēlēties uzņēmumus",
    "documents": "Dokumenti",
    "contracts": "Līgumi",
    "devices": "Ierīces",
    "hide_admin_options": "Slēpt administratora opcijas",
    "show_admin_options": "Rādīt administratora opcijas",
    "actions": {
      "title": "Darbības",
      "send": "Sūtīt",
      "receive": "Saņemt",
      "portfolios": "Portfeļi",
      "buy": "Pirkt",
      "buy_and_cancel": "Pirkt un atcelt",
      "sell": "Pārdot",
      "cancel": "@:common.cancel",
      "confirm_send": "Apstiprināt sūtīšanas pasūtījumu",
      "confirm_sell": "Apstiprināt pārdošanas iestatīšanu",
      "accept": "Apstiprināt"
    },
    "eacs_in_inventory": "izcelsmes apliecinājumi krājumā",
    "settings": "Iestatījumi",
    "action_items": "Nepieciešama rīcība",
    "type_here": "Rakstiet savu ziņu šeit...",
    "placeholderText": "Rezervvietas teksts - lūdzu, sniedziet konkrētāku kontekstu, ja iespējams.",
    "production_period": "Ražošanas periods",
    "production_year": "Ražošanas gads"
  },
  "primevue": {
    "startsWith": "Sākas ar",
    "contains": "Satur",
    "notContains": "Nesatur",
    "endsWith": "Beidzas ar",
    "equals": "Vienāds ar",
    "notEquals": "Nav vienāds ar",
    "noFilter": "Bez filtra",
    "lt": "Mazāks par",
    "lte": "Mazāks vai vienāds ar",
    "gt": "Lielāks par",
    "gte": "Lielāks vai vienāds ar",
    "dateIs": "Datums ir",
    "dateIsNot": "Datums nav",
    "dateBefore": "Datums pirms",
    "dateAfter": "Datums pēc",
    "clear": "Notīrīt",
    "apply": "Pielietot",
    "matchAll": "Atbilst visiem",
    "matchAny": "Atbilst jebkuram",
    "addRule": "Pievienot noteikumu",
    "removeRule": "Noņemt noteikumu",
    "today": "Šodien"
  },
  "language": {
    "en": "Angļu",
    "et": "Igauņu",
    "lv": "Latviešu",
    "lt": "Lietuviešu",
    "sv": "Zviedru"
  },
  "settings": {
    "title": "Iestatījumi",
    "select_language": "Izvēlieties valodu",
    "name": "Vārds",
    "email": "E-pasts",
    "phone": "Tālruņa numurs",
    "email_cannot_be_changed": "Lai mainītu konta e-pastu, uzaiciniet jaunu komandas locekli no Uzņēmuma iestatījumu lapas",
    "receive_transaction_emails": "Saņemt pārdošanas paziņojumu e-pastus",
    "receive_transaction_emails_hint": "E-pasti par jūsu izcelsmes apliecinājumu pārdošanu ar pievienotiem komisijas maksas rēķiniem. Norādiet rēķinu e-pastu uzņēmuma iestatījumos, lai jūsu grāmatvedis saņemtu rēķinus arī tad, ja tas ir izslēgts."
  },
  "app": {
    "development_environment": "Šī ir izstrādes vide",
    "staging_environment": "Šī ir iestudējuma vide",
    "managing_client_account": "Pārvaldāt klienta kontu: {email}",
    "stop_managing": "Beigt pārvaldīt",
    "log_in": "Pieslēgties",
    "log_out": "Atslēgties",
    "error_occurred": "Radās kļūda",
    "error_message_code": "Kļūdas kods: {errorCode}",
    "contact_support": "Lūdzu, sazinieties ar atbalsta dienestu, lai atrisinātu problēmu. Noklikšķiniet uz tērzēšanas burbuļa ekrāna labajā apakšējā stūrī vai atlasiet 'Sazinieties ar mums' augšējā izvēlnē."
  },
  "signup": {
    "choose_company_country": "Jūsu uzņēmuma valsts",
    "select_country_placeholder": "Izvēlieties valsti",
    "legal": {
      "byJoining": "Reģistrējoties jūs piekrītat",
      "membershipAgreement": "Soldera Platformas Līgumam.",
      "personalDataNote": "Jūsu personas dati tiks apstrādāti saskaņā ar mūsu",
      "privacyPolicy": "privātuma politiku."
    },
    "modal": {
      "hello_button": "Sākt reģistrāciju",
      "hello": "👋 Laipni lūdzam!",
      "soldera_faq": "Soldera BUJ",
      "lv": {
        "section1": "Prieks redzēt, ka esat nolēmis pievienoties Solderai. Ja Jums ir kādi jautājumi, atbildes uz galvenajiem jautājumiem var atrast",
        "section2": "Aizpildot zemāk esošo informāciju, jūs piešķirat piekļuvi Soldera jūsu izcelsmes sertifikātu pārvaldībai AST informācijas sistēmā. Mēs arī lūgsim jūs parakstīt dokumentu kopu Dokobit sistēmā. Šie dokumenti tiek automātiski ģenerēti, pamatojoties uz jūsu sniegtajiem datiem. Ja rodas kādas problēmas, lūdzu, rakstiet mums apakšējā labajā stūrī vai zvaniet mūsu Latvijas pārstāvim +371 26417883"
      },
      "ee": {
        "section1": "Sveicināti",
        "section2": "Mēs priecājamies, ka esat nolēmis pievienoties Soldera. Ja Jums ir papildu jautājumi, galvenās atbildes varat atrast šeit:",
        "section3": "Ja vēl nesaņemat izcelsmes sertifikātus",
        "section4": "Mēs palīdzēsim sagatavot un iesniegt visus nepieciešamos dokumentus izcelsmes sertifikātu iegūšanai. Pirmais solis ir tīkla līguma augšupielāde. Šis dokuments, ko pieprasa Elering, satur lielāko daļu datu, kas nepieciešami izcelsmes sertifikātiem.",
        "section5": "Pēc tīkla līguma augšupielādes mēs sniegsim pārskatu par jūsu datiem un jautāsim trūkstošo informāciju. Pēc visu datu apstiprināšanas mēs sagatavosim nepieciešamos dokumentus (ieskaitot starp mums noslēgto līgumu), lūgsim tos parakstīt un pēc tam iesniegsim tos Eleringam.",
        "section6": "Ja jau saņemat izcelsmes sertifikātus",
        "section7": "Ja vēlaties, lai mēs pārvaldām jūsu izcelsmes sertifikātu pārdošanu, lūdzu, noklikšķiniet šeit vai uz saites tīkla līguma lapā. Mums ir nepieciešama ražošanas ierīces īpašnieka un parakstītāja informācija. Pamatojoties uz šiem datiem, mēs sagatavosim attiecīgās pilnvaras un noslēgsim līgumu ar jums."
      }
    },
    "message_rate_limited_title": "Pārāk daudz ziņu",
    "message_rate_limited": "Īsā laikā esat nosūtījis vairākas ziņas. Lūdzu, pagaidiet stundu pirms nākamās ziņas nosūtīšanas vai rakstiet uz support@soldera.org.",
    "new_country": {
      "ask_for_message": "Mēs apsveram paplašināšanos uz šo valsti.",
      "ask_for_message_2": "Optimizējiet savu izcelsmes apliecinājumu procesu - no izsniegšanas un pārskatu sagatavošanas līdz pārdošanai. Sazinieties ar mums, sniedzot īsu savas elektroenerģijas ražošanas iekārtas aprakstu, un mēs parādīsim, kā automatizēt šos uzdevumus.",
      "send_message": "Nosūtīt ziņu",
      "message_sent": "Ziņa nosūtīta",
      "success_message": "Jūsu ziņa ir veiksmīgi nosūtīta!",
      "error_message": "Ziņas nosūtīšana neizdevās, lūdzu, mēģiniet vēlāk!",
      "placeholder": "Ievadiet savu ziņu šeit"
    },
    "grid_contract_upload": {
      "title": "Tīkla līguma augšupielāde",
      "description": "Mums ir nepieciešams jūsu ražošanas ierīces derīgais tīkla līgums, lai aizpildītu un iesniegtu nepieciešamos dokumentus reģistrācijai.",
      "link_text": "Ja jūsu ražošanas ierīce jau saņem izcelsmes sertifikātus no Elering, lūdzu, noklikšķiniet šeit.",
      "upload_prompt": "Noklikšķiniet šeit, lai augšupielādētu tīkla līgumu.",
      "supported_formats": "Pašlaik mēs atbalstām tikai dokumentus .pdf formātā.",
      "existing_contract_error": "Ierīce {eic} jau ir reģistrēta. {link}",
      "manage_devices_link": "Pārvaldīt ierīces šeit.",
      "wrong_file_error": "Šķiet, ka esat augšupielādējis failu, kas nav tīkla līgums. Papildinformāciju par to, kā atrast tīkla līgumu, varat atrast zemāk.",
      "contact_support": "Ja uzskatāt, ka tas ir kļūda un iesniegtais dokuments patiešām ir tīkla līgums, lūdzu, sazinieties ar mūsu klientu atbalstu. Lai to izdarītu, lūdzu, noklikšķiniet uz burbuļa ekrāna apakšējā labajā stūrī vai izvēlieties 'Sazinieties ar mums' izvēlnē augšpusē.",
      "finding_contract_title": "Kur atrast tīkla līgumu?",
      "elektrilevi_contract_info": "Lai atrastu Elektrilevi tīkla līgumu",
      "elektrilevi_contract_link_text": "noklikšķiniet šeit, lai ievadītu to e-pakalpojumu.",
      "vkg_contract_info": "Lai atrastu VKG Elektrivõrkude tīkla līgumu",
      "vkg_contract_link_text": "noklikšķiniet šeit, lai ievadītu to e-pakalpojumu."
    },
    "multiple_upload": {
      "title": "Dokumentu augšupielāde",
      "description": "Lūdzu, augšupielādējiet šādus dokumentus, lai turpinātu reģistrāciju.",
      "lt_inspection_report": "Pēdējais tehniskās inspekcijas ziņojums",
      "lt_inspection_report_where_to_find": "Lūdzu, atrodiet šo dokumentu <a href=\"https://www.epaslaugos.lt/portal/service/92420/16020\" target=\"_blank\"> valsts e-pakalpojumu portālā </a>",
      "lt_property_limit_scheme": "Ražošanas ierīces atrašanās vietas robežu shēma",
      "lt_property_limit_scheme_where_to_find": "Lūdzu, meklējiet šo dokumentu starp ražošanas ierīces uzstādīšanas dokumentiem",
      "lt_power_of_attorney": "Pilnvara (piem., JAR ESI)",
      "lt_power_of_attorney_where_to_find": "Jebkurš dokuments, kas apliecina jūsu pilnvaras pārstāvēt attiecīgo uzņēmumu. Ja ražošanas ierīcei ir vairāki īpašnieki, pilnvarā jābūt visu īpašnieku parakstiem.",
      "where_to_find_this_document": "Kur atrast šo dokumentu?",
      "lt_invalid_power_of_attorney": "Lūdzu, augšupielādējiet derīgu pilnvaru",
      "UF_lv_document_of_device_auxiliaries": "Iekārtas palīgsistēmu dokuments",
      "UF_lv_document_of_device_auxiliaries_where_to_find": "Šim dokumentam jāsatur informācija par visām palīgsistēmām vai iekārtām, kas atbalsta jūsu ražošanas iekārtas darbību",
      "UF_lv_grid_connection_scheme": "Tīkla pieslēguma shēma",
      "UF_lv_grid_connection_scheme_where_to_find": "Šis dokuments jāsaņem no jūsu tīkla operatora (PSO vai SSO). Tas parāda, kā jūsu ražošanas iekārta ir pieslēgta tīklam un ietver attiecīgos mērīšanas punktus",
      "UF_lv_power_of_attorney": "Pilnvara",
      "UF_lv_power_of_attorney_where_to_find": "Ražošanas iekārtas īpašnieka(-u) parakstīta pilnvara (gadījumā, ja Konta turētājs nav īpašnieks vai nav vienīgais ražošanas iekārtas īpašnieks)"
    },
    "add_generator_component": {
      "title": "Ražošanas iekārtas dati",
      "subsidy_title": "Ražošanas iekārtas valsts atbalsts",
      "subsidy_question": "Vai šī ražošanas iekārta ir saņēmusi valsts atbalstu?",
      "elering_support": "Elering ražošanas atbalsts",
      "battery_section_title": "Uzglabāšanas ierīce (baterija)",
      "battery_question": "Vai ražošanas iekārta ir saistīta ar uzglabāšanas ierīci?",
      "battery_details": "Ievadiet uzglabāšanas ierīces datus",
      "unit_power": "Vienības jauda (kW)",
      "capacity": "Ietilpība (kWh)",
      "ppa_section_title": "Tiešās pārdošanas līgums (PPA)",
      "ppa_question": "Vai ražošanas iekārtas elektrību pārdod ilgtermiņa tiešās pārdošanas līgumā (PPA)?",
      "ppa_include_certificates_question": "Vai šī PPA ietver izcelsmes sertifikātu tirdzniecību?",
      "ppa_details": "Ievadiet PPA datus",
      "ppa_start_date": "Sākuma datums",
      "ppa_mwh": "@:common.mwh",
      "ppa_client_name": "Klienta uzņēmuma nosaukums",
      "ppa_country": "Valsts",
      "enter_subsidies": "Ievadiet atbalstus",
      "add_subsidy": "Pievienot atbalstu",
      "device_technology_title": "Iekārtas tehnoloģija",
      "device_technology_description": "Lūdzu, izvēlieties iekārtas tehnoloģiju",
      "device_technology_solar": "Saules enerģija",
      "device_technology_wind": "Vēja enerģija",
      "device_technology_hydro": "Hidroenerģija",
      "device_technology_mixed": "Dažādas tehnoloģijas aiz viena mērījumu punkta"
    },
    "add_subsidy_component": {
      "subsidy_provider": "Atbalsta sniedzējs",
      "decision_date": "Lēmuma datums",
      "subsidy_plan": "Atbalsta plāns",
      "amount": "Summa",
      "placeholder_provider": "Pi.: Kredex, PRIA",
      "placeholder_plan": "Pi.: Daudzveidības atbalsts",
      "investment": "Investīciju atbalsts",
      "objective": "Valsts atbalsta mērķis",
      "placeholder_number": "Piemēram: 1234567890",
      "placeholder_objective": "Piemēram: Atjaunojamā enerģija",
      "production": "Ražošanas atbalsts",
      "select_type": "Izvēlieties atbalsta veidu",
      "subsidy_number": "Atbalsta shēmas numurs",
      "subsidy_type": "Atbalsta shēmas veids"
    },
    "contact_review_component": {
      "signer_title": "Parakstītāja personas dati",
      "generator_owner_title": "Ražošanas iekārtas īpašnieka dati",
      "generator_owner_subtext": "Lūdzu, ievadiet ražošanas iekārtas īpašnieka datus. Īpašnieks var būt Jūs vai Jūsu uzņēmums.",
      "select_company": "Izvēlēties īpašnieku",
      "add_new_company": "Jauns īpašnieks"
    },
    "role_selection": {
      "title": "Izvēlieties savu lomu",
      "subtitle": "Lai sāktu, lūdzu, izvēlieties, kurš ceļš vislabāk apraksta jūsu vajadzības",
      "corporate_title": "Esmu uzņēmums",
      "corporate_perfect_if": "Ideāli, ja:",
      "corporate_benefit1": "Nepieciešama ar AI darbināta ESG/CBAM/CSRD un SBTi atskaišu automatizācija",
      "corporate_benefit2": "Vēlaties iegādāties atjaunojamo enerģiju (EAC) tieši no ražotājiem par labākajām cenām",
      "corporate_benefit3": "Vēlaties samazināt atbilstības izmaksas vairāk nekā par 50%",
      "corporate_benefit4": "Nepieciešami centralizēti starpvalstu audita ziņojumi",
      "producer_title": "Esmu enerģijas ražotājs",
      "producer_perfect_if": "Ideāli, ja:",
      "producer_benefit1": "Jums pieder vai pārvaldāt vēja, saules, hidro vai biomasas iekārtas",
      "producer_benefit2": "Vēlaties maksimizēt ieņēmumus no Izcelsmes apliecinājumiem (IA)",
      "producer_benefit3": "Nepieciešama automatizēta reģistra pārvaldība un tirdzniecība",
      "producer_benefit4": "Vēlaties stabilizēt ieņēmumus ar forward pārdošanu",
      "help_title": "Neesat pārliecināts, kurš ceļš ir piemērots jums?",
      "help_description": "Vai jums ir jaukts gadījums? Uzņēmums ar nelielu ražošanu? Vienkārši pastāstiet mums par savu uzņēmumu, un mēs palīdzēsim izvēlēties pareizo ceļu.",
      "help_button": "Palīdziet man izlemt",
      "help_form_label": "Pastāstiet par savu uzņēmumu",
      "help_form_placeholder": "Piemēram: 'Mēs esam ražošanas uzņēmums ar 2 MW jumta saules paneļiem. Mums galvenokārt nepieciešama atbilstības palīdzība, bet vēlamies arī pārvaldīt mūsu nelielo ražošanu.'",
      "help_submit": "Nosūtīt pieprasījumu",
      "help_success": "Paldies! Drīzumā sazināsimies ar jums, lai palīdzētu izvēlēties pareizo ceļu."
    },
    "corporate": {
      "title": "Uzņēmuma reģistrācija",
      "rate_limit_error": "Sasniegts uzņēmumu izveides limits. Ja pievienojat lielu portfeli, lūdzu, sazinieties ar {supportEmail}.",
      "description": "Automatizējiet ESG/CBAM/CSRD atbilstību ar AI un iegūstiet EAC tieši no atjaunojamās enerģijas ražotājiem",
      "form_title": "Uzņēmuma informācija",
      "company_name": "Uzņēmuma nosaukums",
      "registry_code": "Reģistrācijas numurs",
      "address": "Adrese",
      "phone_number": "Tālruņa numurs",
      "vat": "PVN reģistrācijas numurs",
      "vat_optional": "Nav obligāts",
      "country": "Valsts",
      "select_country": "Izvēlieties valsti",
      "submit": "Pabeigt reģistrāciju",
      "platform_agreement_checkbox_label": "Noklikšķinot uz Piekrītu, jūs piekrītat {link}."
    },
    "international": {
      "submit": "Iesniegt",
      "confirmation_title": "Paldies, ka reģistrējāties!",
      "confirmation_message": "Mūsu komanda drīz ar jums sazināsies, lai pabeigtu jūsu konta iestatīšanu.",
      "duplicate_company_error": "Uzņēmums ar šo reģistrācijas kodu šajā valstī jau pastāv. Mūsu komanda ar jums sazināsies, lai pabeigtu reģistrāciju."
    },
    "generator_license_review": {
      "title": "Ražošanas ierīces licences numurs",
      "description": "Lūdzu, atrodiet licences numuru, kas saistīts ar jūsu ražošanas ierīces ražošanas vai attīstības atļauju.",
      "directions": "Lai atrastu licences numuru, meklējiet to <a href=\"https://www.licencijavimas.lt/lis-epp-app/public/licenceSearch\" target=\"_blank\"> Lietuvas licencēšanas informācijas sistēmā.</a>.",
      "licenseHints": "Iespējamie licences numuri no Litgrid"
    },
    "user_type": {
      "select_title": "Izvēlieties īpašnieka veidu",
      "select_description": "Lūdzu, izvēlieties, vai reģistrējat ierīces īpašnieku kā privātpersonu vai uzņēmumu.",
      "private": {
        "button": "Reģistrēties kā privātpersonai",
        "description": "Izvēlieties šo, ja reģistrējat savas mājas saules paneļus vai citas personīgās atjaunojamās enerģijas ierīces."
      },
      "company": {
        "button": "Reģistrēties kā uzņēmums",
        "description": "Izvēlieties šo, ja reģistrējaties uzņēmuma vai organizācijas vārdā, kurai pieder atjaunojamās enerģijas ierīces."
      },
      "selection_prefix": "Jūs izvēlējāties:",
      "selected_private": "Reģistrēties kā privātpersonai",
      "selected_company": "Reģistrēties kā uzņēmums"
    },
    "contract_review_component": {
      "data_review_title": "Datu pārskats",
      "data_review_subtext": "Lūdzu, pārbaudiet vēlreiz, vai visi dati ir ievadīti pareizi",
      "data_signer_title": "Parakstītāja personas dati",
      "data_company_title": "Ražošanas iekārtas īpašnieka dati",
      "data_generator_title": "Ražošanas iekārtas dati",
      "documents_review_title": "Dokumentu pārskats",
      "documents_review_subtext": "Nākamajā lapā lūdzam Jums parakstīt dokumentu kopumu sistēmā Dokobit. Dokumenti ir automātiski izveidoti, balstoties uz Jūsu datiem. Šeit ir pārskats par dokumentiem, kas gaida parakstu:",
      "self_uploaded_file_text": "Šis ir dokuments, kuru jūs iepriekš esat augšupielādējis. Tas tiks iekļauts parakstāmajā aploksnē.",
      "documents_signed": "Dokuments parakstīts",
      "documents_remaining": "Atlicis parakstīt {count} dokumenti",
      "ee": {
        "origin_certificate_account_application_title": "Pieteikums izcelsmes sertifikātu konta atvēršanai",
        "origin_certificate_account_application_description": "Dokuments, kas izsaka vēlmi atvērt izcelsmes sertifikātu kontu pie Elering. Šis dokuments arī pilnvaro Soldera pārvaldīt šos sertifikātus.",
        "type_conditions_title": "Izcelsmes sertifikātu lietošanas standarta nosacījumi",
        "type_conditions_description": "Eleringa noteikti standarta nosacījumi un noteikumi darbībām izcelsmes sertifikātu tirgū.",
        "authorization_application_title": "Pieteikums izcelsmes sertifikātu konta pilnvarojumam",
        "authorization_application_description": "Dokuments, kas izsaka vēlmi pilnvarot Soldera pārvaldīt izcelsmes sertifikātus Elering informācijas sistēmā.",
        "investment_support_confirmation_title": "Apstiprinājuma vēstule par investīciju atbalsta saņemšanu/nosaņemšanu",
        "investment_support_confirmation_description": "Dokuments, kas apstiprina Elering par jūsu ražošanas ierīcei piešķirtajiem atbalstiem.",
        "network_contract_title": "Tīkla līgums",
        "network_contract_description": "Jūsu augšupielādētais tīkla līgums, kas ir nepieciešams Elering, lai reģistrētu jūsu ražošanas ierīci.",
        "device_registration_form_title": "Ierīces reģistrācijas forma",
        "device_registration_form_description": "Eleringa prasīta forma jūsu ražošanas ierīces datu iesniegšanai.",
        "soldera_membership_agreement_title": "Soldera platformas līgums",
        "soldera_membership_agreement_description": "Līgums starp jums un Soldera, kas nosaka sadarbības nosacījumus.",
        "elering_data_title": "Eleringa dati",
        "elering_data_description": "Dokuments jūsu datu iesniegšanai Elering, lai atvieglotu ražošanas ierīces reģistrāciju."
      },
      "lv": {
        "lv_account_authorization_form_title": "Iesniegums izcelsmes sertifikātu konta pilnvarojuma piešķiršanai",
        "lv_account_authorization_form_text": "Dokuments, kas pauž vēlmi piešķirt Solderai pilnvarojumu pārvaldīt izcelsmes sertifikātus. Šis dokuments ļauj Solderai piekļūt Jūsu izcelsmes sertifikātiem AST informācijas sistēmā.",
        "lv_soldera_membership_agreement_title": "Soldera platformas līgums",
        "lv_soldera_membership_agreement_text": "Līgums starp Jums un Solderu, kas nosaka sadarbības nosacījumus. Nepieciešams, ja iepriekš nav noslēgts līgums. Ietver atsauces uz Soldera privātuma politiku, tirdzniecības kārtību un galvenajiem noteikumiem, kas ir pieejami Soldera tīmekļa vietnē.",
        "lv_new_device_application_text": "Ražošanas iekārtas reģistrācijas veidlapa ar neatkarīga akreditēta ražošanas auditora pārbaudītu informāciju",
        "lv_new_device_application_title": "Ražošanas iekārtas reģistrācijas veidlapa",
        "lv_ast_terms_and_service_title": "AST noteikumi un pakalpojumi",
        "lv_ast_terms_and_service_text": "AST informācijas sistēmas noteikumi un nosacījumi.",
        "lv_soldera_account_holder_registration_form_title": "Grexel konta turētāja reģistrācijas veidlapa",
        "lv_soldera_account_holder_registration_form_text": "Dokuments, kas pauž vēlmi reģistrēties kā konta turētājam Grexel sistēmā. Šis dokuments ļauj Solderai piekļūt Jūsu izcelsmes sertifikātiem AST informācijas sistēmā."
      },
      "lt": {
        "lt_request_for_go_contract_title": "Pieteikums izcelsmes sertifikātu pakalpojuma līguma slēgšanai",
        "lt_request_for_go_contract_description": "Dokuments, kas izsaka vēlmi noslēgt līgumu ar Litgrid, lai atvērtu izcelsmes sertifikātu kontu.",
        "lt_soldera_membership_agreement_title": "Soldera platformas līgums",
        "lt_soldera_membership_agreement_text": "Līgums starp Jums un Solderu, kas nosaka sadarbības nosacījumus. Nepieciešams, ja iepriekš nav noslēgts līgums. Ietver atsauces uz Soldera privātuma politiku, tirdzniecības kārtību un galvenajiem noteikumiem, kas ir pieejami Soldera tīmekļa vietnē.",
        "lt_authotization_application_title": "Pieteikums izcelsmes apliecinājumu konta pilnvarojumam",
        "lt_authorization_application_text": "Dokuments, kas izsaka vēlmi pilnvarot Soldera pārvaldīt izcelsmes apliecinājumus Litgrid informācijas sistēmā.",
        "lt_litgrid_terms_service_title": "Litgrid pakalpojumu sniegšanas noteikumi",
        "lt_litgrid_terms_service_description": "Litgrid informācijas sistēmas lietošanas noteikumi.",
        "lt_device_registration_title": "Litgrid ierīces reģistrācijas veidlapa",
        "lt_device_registration_description": "Dokuments, ko Litgrid pieprasa, lai reģistrētu jaunu ierīci."
      },
      "se": {
        "se_account_authorization_form_title": "Energimyndigheten pilnvaras veidlapa",
        "se_account_authorization_form_text": "Šī veidlapa pilnvaro Soldera reģistrēt jūsu kontu Energimyndigheten (Zviedrijas Enerģētikas aģentūra) un pārvaldīt jūsu izcelsmes apliecinājumus.",
        "se_access_cesar_freja_eid_authorization_application_title": "Energimyndigheten'i Cesar konto pilnvaras veidlapa",
        "se_access_cesar_freja_eid_authorization_application_text": "Šī veidlapa pilnvaro Soldera prieigos prie jūsų Cesar konto Energimyndigheten (Zviedrijas Enerģētikas aģentūra) un pārvaldīt jūsu izcelsmes apliecinājumus.",
        "se_soldera_membership_agreement_title": "Soldera platformas līgums",
        "se_soldera_membership_agreement_text": "Šis līgums nodibina jūsu dalību Soldera un nosaka mūsu platformas un pakalpojumu lietošanas noteikumus.",
        "se_application_for_go_title": "Izcelsmes apliecinājumu pieteikums",
        "se_application_for_go_text": "Pieteikuma veidlapa ražošanas iekārtas reģistrēšanai izcelsmes apliecinājumu saņemšanai Zviedrijas Enerģētikas aģentūrā.",
        "se_appendix_production_units_title": "Ražošanas vienību pielikums",
        "se_appendix_production_units_text": "Detalizēta informācija par jūsu ražošanas vienībām, kas tiks reģistrētas izcelsmes apliecinājumu saņemšanai.",
        "se_application_for_eecs_go_title": "EECS izcelsmes apliecinājumu pieteikums",
        "se_application_for_eecs_go_text": "Pieteikums Eiropas Enerģijas sertifikātu sistēmas (EECS) izcelsmes apliecinājumu reģistrācijai.",
        "se_application_for_special_account_title": "Speciālā konta pieteikums",
        "se_application_for_special_account_text": "Pieteikums speciālā konta atvēršanai Zviedrijas Enerģētikas aģentūras izcelsmes apliecinājumu pārvaldības sistēmā.",
        "se_application_for_cesar_access_title": "Cesar sistēmas piekļuves pieteikums",
        "se_application_for_cesar_access_text": "Pieteikums piekļuvei Cesar sistēmai, ko izmanto izcelsmes apliecinājumu pārvaldībai Zviedrijā."
      },
      "fi": {
        "fi_soldera_membership_agreement_title": "Soldera platformas līgums",
        "fi_soldera_membership_agreement_text": "Šis līgums nodibina jūsu dalību Soldera un nosaka mūsu platformas un pakalpojumu lietošanas noteikumus.",
        "fi_authorization_application_title": "Pieteikums izcelsmes apliecinājumu konta pilnvarojumam",
        "fi_authorization_application_text": "Dokuments, kurā pausta vēlme pilnvarot Solderu pārvaldīt izcelsmes apliecinājumus.",
        "fi_transfer_application_title": "Päritolutunnistuste konto üleandmise taotlus",
        "fi_transfer_application_text": "See dokument üleandab teie tootmisüksuste Solderale, et haldada teie päritolutunnistusi ja säästa registri konto tasu."
      },
      "generic": {
        "soldera_membership_agreement_title": "Soldera platformas līgums",
        "soldera_membership_agreement_text": "Šis līgums nodibina jūsu dalību Soldera un nosaka mūsu platformas un pakalpojumu lietošanas noteikumus.",
        "authorization_application_title": "Pieteikums izcelsmes apliecinājumu konta pilnvarojumam",
        "authorization_application_text": "Dokuments, kurā pausta vēlme pilnvarot Solderu pārvaldīt izcelsmes apliecinājumus."
      },
      "es": {
        "es_soldera_membership_agreement_title": "Soldera Platformas Līgums",
        "es_soldera_membership_agreement_text": "Šis līgums nosaka jūsu dalību Soldera un izklāsta mūsu platformas un pakalpojumu lietošanas noteikumus.",
        "es_account_authorization_form_title": "Autorizācijas Pieteikums",
        "es_account_authorization_form_text": "Šis dokuments pilnvaro Soldera pārvaldīt jūsu izcelsmes apliecinājumus."
      },
      "pl": {
        "pl_authorization_application_title": "Pilnvarojuma pieteikums",
        "pl_authorization_application_text": "Šis dokuments pilnvaro Solderu pārvaldīt jūsu izcelsmes apliecinājumus Polijā.",
        "pl_soldera_membership_agreement_title": "Soldera platformas līgums",
        "pl_soldera_membership_agreement_text": "Šis līgums nosaka jūsu dalību Soldera un apraksta noteikumus un nosacījumus mūsu platformas un pakalpojumu izmantošanai Polijā."
      }
    },
    "navsteps": {
      "next": "Tālāk",
      "back": "Atpakaļ",
      "to_signature_page": "Pārbaudiet dokumentus",
      "ee": {
        "authorization": {
          "1": "Sākums",
          "2": "Kontaktdati",
          "3": "Līguma pārskats"
        },
        "new_device": {
          "1": "Tīkla līgums",
          "2": "Ražošanas ierīce",
          "3": "Kontaktdati",
          "4": "Līguma pārskats"
        }
      },
      "lv": {
        "new_device": {
          "1": "Sākums",
          "2": "Konta dati",
          "3": "Iekārtas dokumenti",
          "4": "Iekārtas dati",
          "5": "Uzņēmuma informācija",
          "6": "Parakstīšana"
        },
        "authorization": {
          "1": "Konta dati",
          "2": "Parakstīšana",
          "3": "Parakstīšana"
        },
        "step1": "Sveicināti",
        "step2": "Kontaktinformācija"
      },
      "lt": {
        "choose_onboarding": "Reģistrācijas veids",
        "contact_review": "Konta dati",
        "multiple_upload": "@:common.documents",
        "generator_license": "Licences numurs",
        "contract_review": "Parakstīšana"
      },
      "se": {
        "step1": "Sākums",
        "authorization": {
          "contact_review": "Kontaktinformācija",
          "contract_review": "Līguma pārskats"
        },
        "new_device": {
          "contact_review": "Kontaktinformācija",
          "generator_review": "Ģeneratora dati",
          "contract_review": "Līguma pārskats",
          "grid_review": "Tīkla īpašnieka dati"
        },
        "contract_review": "Līguma pārskats"
      },
      "fi": {
        "flow_selection": "Plūsmas izvēle",
        "contact_details": "Kontaktinformācija",
        "contract_review": "Līguma pārskats"
      },
      "default": {
        "contact_review": "Kontaktinformācija",
        "contract_review": "Līguma pārskats"
      },
      "es": {
        "step1": "Sākums",
        "step2": "Kontaktinformācija",
        "step3": "Līguma Pārskats",
        "authorization": {
          "1": "Sākums",
          "2": "Konta dati",
          "3": "Parakstīšana"
        }
      },
      "pl": {
        "step1": "Laipni lūdzam",
        "step2": "Kontaktinformācija",
        "step3": "Līguma pārskats",
        "authorization": {
          "1": "Sākt",
          "2": "Konta dati",
          "3": "Parakstīšana"
        }
      }
    },
    "lv": {
      "authorization": {
        "title": "Vai Jūs jau iepriekš esat ražojuši izcelsmes sertifikātus?",
        "description": "Soldera ir automatizēts izcelsmes sertifikātu pārdošanas aģents. Lai sāktu maksimizēt savu izcelsmes sertifikātu ieņēmumus ar Solderu, izdariet zemāk norādīto izvēli",
        "add_authorization": "Esmu iepriekš ražojis izcelsmes sertifikātus",
        "create_new_account": "Atvērt jaunu izcelsmes apliecinājumu kontu AST",
        "create_new_account_description": "Izvēlieties šo opciju, ja jūs nesaņemat izcelsmes apliecinājumus un vēlaties reģistrēt jaunu iekārtu AST informācijas sistēmā.",
        "add_authorization_description": "Izvēlieties šo opciju, ja jūs jau saņemat izcelsmes apliecinājumus un vēlaties pilnvarot Soldera tos pārvaldīt. Mēs varam palīdzēt jums vēlāk reģistrēt papildu iekārtas AST.",
        "not_sure": "Neesat pārliecināts?",
        "contact_support": "Sazinieties ar mūsu atbalsta komandu",
        "existing_account_title": "Reģistrēt jaunu iekārtu esošam īpašniekam",
        "alternative_instructions": "Ja vēlaties atvērt jaunu kontu iekārtas īpašniekam, kuru vēl neesat reģistrējis Soldera, lūdzu, sekojiet zemāk esošajām instrukcijām."
      },
      "do_you_have_subsidy": "Vai esat saņēmis vai saņemat valsts atbalstu?",
      "generator_review": {
        "device_address": {
          "title": "Ražošanas iekārtas adrese"
        },
        "device_eic": {
          "title": "Skaitītāja ID (EIC kods)"
        },
        "device_grid_operator": {
          "options": {
            "grid_operator_dso": "SSO tīkls",
            "grid_operator_tso": "PSO tīkls"
          },
          "title": "Tīkla pieslēgums"
        },
        "device_name": {
          "title": "Ražošanas iekārtas nosaukums"
        },
        "device_power": {
          "title": "Uzstādītā jauda (kW)"
        },
        "device_power_in_permit": {
          "title": "Sistēmas operatora atļaujā norādītā jauda (kW)"
        },
        "device_technology": {
          "options": {
            "device_technology_hydro": "Hidro",
            "device_technology_solar": "Saules",
            "device_technology_wind": "Vēja"
          },
          "title": "Tehnoloģija"
        },
        "grid_contract_start_date": {
          "title": "Pirmā ekspluatācijas uzsākšanas datums"
        },
        "lat": {
          "title": "@:ecolabels.table.latitude"
        },
        "lng": {
          "title": "@:ecolabels.table.longitude"
        },
        "only_device_output": {
          "title": "Skaitītājs atbilst tīrās elektroenerģijas izlaidei"
        }
      }
    },
    "lt": {
      "authorization": {
        "title": "Vai jums jau ir izcelsmes sertifikāti?",
        "description": "Lai pielāgotu jūsu pieredzi, mums jāzina, vai jūs jau saņemat izcelsmes sertifikātus. Tas palīdzēs mums noteikt jums piemērotākos nākamos soļus.",
        "add_authorization": "Jā, man ir izcelsmes sertifikāti.",
        "add_authorization_description": "Izvēlieties šo opciju, ja jūs jau saņemat izcelsmes sertifikātus un vēlaties pilnvarot Soldera tos pārvaldīt. Vēlāk mēs varam palīdzēt jums reģistrēt vairāk ierīču Litgrid.",
        "create_new_account": "Nē, man nav izcelsmes sertifikātu.",
        "create_new_account_description": "Izvēlieties šo opciju, ja jūs nesaņemat izcelsmes sertifikātus un vēlaties reģistrēt jaunu ierīci Litgrid informācijas sistēmā.",
        "not_sure": "Neesat pārliecināts?",
        "contact_support": "Sazinieties ar mūsu atbalsta komandu, lai saņemtu palīdzību",
        "existing_account_title": "Reģistrēt jaunu ierīci esošam īpašniekam",
        "alternative_instructions": "Ja vēlaties atvērt jaunu kontu ierīces īpašniekam, kuru vēl neesat reģistrējis Soldera sistēmā, lūdzu, sekojiet zemāk esošajām instrukcijām."
      },
      "extra_info": {
        "title": "Papildu informācija par uzņēmumu",
        "description": "Lūdzu, sniedziet šādu Litgrid pieprasīto informāciju."
      }
    },
    "se": {
      "generator_review": {
        "basic_information": "Pamatinformācija",
        "metering_information": "Mērīšanas informācija",
        "investment_support": "Investīciju atbalsts",
        "grid_area_id": {
          "title": "Tīkla zonas ID",
          "description": "Ievadiet tīkla zonas ID (trīs burti vai 'IKN')"
        },
        "grid_production_device_id": {
          "title": "Ražošanas iekārtas ID",
          "description": "Ievadiet unikālo 18 rakstzīmju ražošanas iekārtas ID"
        },
        "grid_eidel_id": {
          "title": "Ediel ID",
          "description": "Ievadiet ID numuru, kas piešķirts saziņai ar Svenska Kraftnät"
        },
        "device_name": {
          "title": "Ražošanas iekārtas nosaukums"
        },
        "device_power": {
          "title": "Uzstādītā jauda (kW)",
          "description": "Įveskite įrengtą galią kW"
        },
        "device_power_in_permit": {
          "title": "Sistēmas operatora atļaujā norādītā jauda (kW)"
        },
        "device_eic": {
          "title": "Skaitītāja ID (EIC kods)"
        },
        "only_device_output": {
          "title": "Skaitītājs atbilst tīrās elektroenerģijas izlaidei"
        },
        "device_address": {
          "title": "Ražošanas iekārtas adrese"
        },
        "lat": {
          "title": "@:ecolabels.table.latitude"
        },
        "lng": {
          "title": "@:ecolabels.table.longitude"
        },
        "device_grid_operator": {
          "title": "Tīkla pieslēgums",
          "grid_operator_tso": "PSO tīkls",
          "grid_operator_dso": "SSO tīkls"
        },
        "grid_contract_start_date": {
          "title": "Pirmā ekspluatācijas uzsākšanas datums"
        },
        "postal_address": {
          "title": "Pasta adrese",
          "description": "Ievadiet pilnu ielas adresi"
        },
        "postal_code": {
          "title": "Pasta indekss",
          "description": "Ievadiet pasta indeksu"
        },
        "city": {
          "title": "Pilsēta",
          "description": "Ievadiet pilsētas nosaukumu"
        },
        "metering_location": {
          "title": "Mērīšanas vieta",
          "description": "Izvēlieties, kur notiek ražošanas mērīšana",
          "options": {
            "Directly_after_generator": "Tieši pēc ģeneratora",
            "After_auxiliary_equipment": "Pēc palīgiekārtām",
            "After_net_pumping_equipment": "Pēc tīrās sūknēšanas iekārtām",
            "Directly_before_grid_connection": "Tieši pirms tīkla pieslēguma"
          }
        },
        "commissioning_date": {
          "title": "Eksploatācijas sākuma datums",
          "description": "Ievadiet eksploatācijas sākuma datuma"
        },
        "correction_factor_info": {
          "title": "Korekcijas faktors",
          "description": "Tiks deklarēts standarta korekcijas faktors. Ja uzstādītā jauda pārsniedz 10 MW, lūdzu, sazinieties ar atbalsta dienestu, lai deklarētu pielāgotu korekcijas faktoru"
        },
        "company_address": "Uzņēmuma adrese",
        "invoice_address": "Rēķina adrese",
        "same_as_company_address": "Rēķina adrese ir tāda pati kā uzņēmuma adrese",
        "production_unit": "Ražošanas vienības informācija",
        "cesar_application": "Cesar pieteikums",
        "go_application": "Izcelsmes apliecinājumu pieteikums",
        "investment_support_question": "Vai šī ražošanas vienība ir saņēmusi investīciju atbalstu?",
        "investment_support_options": {
          "yes": "Jā",
          "no": "Nē",
          "do_not_know": "Nezinu"
        },
        "property_designation": {
          "title": "Īpašuma apzīmējums",
          "description": "Ievadiet īpašuma apzīmējumu"
        },
        "holding_percentage": {
          "title": "Īpašumtiesību procents",
          "description": "Ievadiet savu īpašumtiesību procentuālo daļu"
        },
        "grid_owner_name": {
          "title": "Tīkla īpašnieka nosaukums",
          "description": "Lūdzu, ievadiet tīkla īpašnieka uzņēmuma nosaukumu"
        },
        "grid_owner_corporate_id": {
          "title": "Tīkla īpašnieka reģistrācijas numurs",
          "description": "Lūdzu, ievadiet tīkla īpašnieka uzņēmuma reģistrācijas numuru"
        },
        "invoice_co_address": {
          "title": "C/O Rēķina adresas",
          "description": "Lūdzu, ievadiet rēķina adreses C/O adresi (ja nepieciešams)"
        },
        "invoice_contact_telephone": {
          "title": "Rēķina kontaktpersonas tālruņa numurs",
          "description": "Lūdzu, ievadiet rēķina kontaktpersonas tālruņa numuru"
        },
        "invoice_email": {
          "title": "Rēķina e-pasts",
          "description": "Lūdzu, ievadiet e-pasta adresi, kurā tiks nosūtīts rēķins"
        },
        "specific_name": {
          "title": "Rēķina konkretaus kontaktpersonas vārds",
          "description": "Lūdzu, ievadiet rēķina konkretaus kontaktpersonas vārdu"
        },
        "reference_number": {
          "title": "Rēķina nuorodes numurs",
          "description": "Lūdzu, ievadiet rēķina nuorodes numuru"
        },
        "invoice_country": {
          "title": "Rēķina valsts",
          "description": "Lūdzu, ievadiet rēķina valsts kodu"
        },
        "technology": {
          "title": "Tehnoloģija",
          "description": "Izvēlieties ražošanas tehnoloģiju",
          "options": {
            "BTN_Land based": "Sauszemes vējš",
            "BTN_Ocean based": "Jūras vējš",
            "BTN_Sun": "Saule",
            "BTN_Water": "Hidro",
            "BTN_Thermal": "Siltumenerģija"
          }
        },
        "thermal_subtype": {
          "title": "Siltumenerģijas tehnoloģijas veids",
          "description": "Izvēlieties konkrēto siltumenerģijas tehnoloģijas veidu",
          "options": {
            "BTN_Industrial back pressure": "Rūpnieciskais pretspiediens",
            "BTN_Condensing power": "Kondensācijas jauda",
            "BTN_Gas engine": "Gāzes dzinējs"
          }
        },
        "thermal_is_chp": {
          "title": "Vai šī ir CHP iekārta?",
          "description": "Atzīmējiet, ja šī ir kombinēta siltuma un elektroenerģijas ražošanas (CHP) iekārta"
        },
        "investment_support_amount": {
          "title": "Investīciju atbalsta summa",
          "description": "Ievadiet saņemto investīciju atbalsta summu"
        },
        "investment_support_date": {
          "title": "Investīciju atbalsta datums",
          "description": "Ievadiet datumu, kad saņemts investīciju atbalsts"
        },
        "grid_metered_by_hour": {
          "title": "Tīkls mērīts stundā",
          "description": "Izvēlieties, vai tīkls tiek mērīts stundā"
        },
        "grid_concession": {
          "title": "Tīkla koncesija",
          "description": "Izvēlieties, vai tīkla koncesija ir spēkā"
        }
      },
      "authorization": {
        "title": "Vai Jūs jau iepriekš esat ražojuši izcelsmes sertifikātus?",
        "description": "Soldera ir automatizēts izcelsmes sertifikātu pārdošanas aģents. Lai sāktu maksimizēt savu izcelsmes sertifikātu ieņēmumus ar Solderu, izdariet zemāk norādīto izvēli",
        "add_authorization": "Es saņemu EECS izcelsmes apliecinājumus",
        "create_new_account": "Atvērt jaunu izcelsmes apliecinājumu kontu Zviedrijas Enerģētikas aģentūrā",
        "create_new_account_description": "Izvēlieties šo opciju, ja jūs nesaņemat izcelsmes apliecinājumus un vēlaties reģistrēt jaunu iekārtu Zviedrijas Enerģētikas aģentūras informācijas sistēmā.",
        "add_authorization_description": "Izvēlieties šo opciju, ja jūs saņemat EECS izcelsmes apliecinājumus un vēlaties pilnvarot Soldera tos pārvaldīt. Mēs varam palīdzēt jums vēlāk reģistrēt papildu iekārtas Zviedrijas Enerģētikas aģentūrā.",
        "not_sure": "Neesat pārliecināts?",
        "contact_support": "Sazinieties ar mūsu atbalsta komandu",
        "existing_account_title": "Reģistrēt jaunu iekārtu esošam īpašniekam",
        "alternative_instructions": "Ja vēlaties atvērt jaunu kontu iekārtas īpašniekam, kuru vēl neesat reģistrējis Soldera, lūdzu, sekojiet zemāk esošajām instrukcijām.",
        "add_eecs_conversion": "Es saņemu nacionālos izcelsmes apliecinājumus",
        "add_eecs_conversion_description": "Izvēlieties šo opciju, ja saņemat nacionālos izcelsmes apliecinājumus un vēlaties turpmāk saņemt EECS izcelsmes apliecinājumus (Eiropas pārvedamos izcelsmes apliecinājumus) tā vietā."
      }
    },
    "fi": {
      "flow_selection": {
        "title": "Pievienot jaunu uzņēmumu",
        "choose_onboarding": "Izvēlieties onboarding",
        "description": "Izvēlieties pārsūtīšanas opciju, ja reģistrā jau ir ražošanas ierīces. Ja jums nav reģistrētu ierīču, sazinieties ar mums, lai apspriestu jūsu iespējas.",
        "not_sure": "Nepieciešama palīdzība?",
        "contact_support": "Lai saņemtu palīdzību, sazinieties ar mūsu atbalsta komandu",
        "transfer": {
          "title": "Ražošanas ierīču nodošana uzņēmumam Soldera",
          "description": "Mēs pārnesīsim jūsu ražošanas ierīces uz mūsu reģistra kontu un pārvaldīsim tās jūsu vietā."
        },
        "authorization": {
          "title": "Piešķiriet Solderai piekļuvi savam kontam reģistrā",
          "description": "Mums būs piekļuve jūsu kontam reģistrā un pārvaldīsim sertifikātus jūsu vietā. Sertifikāti paliek jūsu kontā."
        }
      },
      "quickfill": {
        "search": "Fingrid jau reģistrēta uzņēmuma meklēšana",
        "search_placeholder": "Meklēt uzņēmumu Fingrid",
        "error": "Neizdevās ielādēt uzņēmumus",
        "quickfill_helper": "Ātrā aizpildīšana ar Fingrid jau reģistrētu uzņēmumu",
        "manual_entry": "Ievadiet informāciju manuāli"
      }
    },
    "fallback": {
      "flow_selection": {
        "title": "Pievienot jaunu uzņēmumu",
        "intro": "Soldera ir Nr. 1 platforma izcelsmes garantiju pārvaldībai. Optimizējiet rentabilitāti, vienlaikus samazinot administratīvā darba slodzi. Apkalpo nozares līderus un tūkstošiem atjaunojamās enerģijas ražošanas vienību visā Eiropā.",
        "description": "Izvēlieties autorizācijas opciju, ja reģistrā jau ir ražošanas ierīces. Ja jums nav reģistrētu ierīču, sazinieties ar mums, lai apspriestu jūsu iespējas.",
        "not_sure": "Nepieciešama palīdzība?",
        "contact_support": "Lai saņemtu palīdzību, sazinieties ar mūsu atbalsta komandu",
        "authorization": {
          "title": "Pilnvarojiet Soldera pārvaldīt jūsu ražošanas ierīces",
          "description": "Mēs jūsu vietā pārvaldīsim jūsu ražošanas ierīces."
        }
      }
    },
    "es": {
      "authorization": {
        "title": "Vai jums jau ir izcelsmes apliecinājumi?",
        "description": "Lai pielāgotu jūsu pieredzi, mums jāzina, vai jūs jau saņemat izcelsmes apliecinājumus. Tas palīdz mums noteikt labākos nākamos soļus jums.",
        "add_authorization": "Jā, man ir izcelsmes apliecinājumi.",
        "add_authorization_description": "Izvēlieties šo iespēju, ja jūs jau saņemat izcelsmes apliecinājumus un vēlaties pilnvarot Soldera tos pārvaldīt.",
        "create_new_account": "Nē, man nav izcelsmes apliecinājumu.",
        "create_new_account_description": "Izvēlieties šo iespēju, ja jūs nesaņemat izcelsmes apliecinājumus un vēlaties reģistrēt jaunu ierīci reģistra informācijas sistēmā.",
        "not_sure": "Neesat pārliecināts?",
        "contact_support": "Sazinieties ar mūsu atbalsta komandu, lai saņemtu palīdzību",
        "existing_account_title": "Reģistrēt Jaunu Ierīci Esošam Īpašniekam",
        "alternative_instructions": "Ja vēlaties atvērt jaunu kontu ierīces īpašniekam, kuru vēl neesat reģistrējis Soldera, lūdzu, izpildiet tālāk sniegtos norādījumus."
      },
      "extra_info": {
        "title": "Papildinformācija par uzņēmumu",
        "description": "Lūdzu, sniedziet šādu reģistra pieprasīto informāciju."
      }
    },
    "pl": {
      "authorization": {
        "title": "Vai jums jau ir izcelsmes apliecinājumi?",
        "description": "Lai pielāgotu jūsu pieredzi un nodrošinātu labāko servisu, lūdzu, pastāstiet mums par jūsu pašreizējo statusu ar izcelsmes apliecinājumiem.",
        "add_authorization": "Jā, man ir izcelsmes apliecinājumi.",
        "add_authorization_description": "Jums ir esošie izcelsmes apliecinājumi, un jūs vēlaties piešķirt Solderai pilnvaras tos pārvaldīt.",
        "not_sure": "Neesmu pārliecināts par savu statusu.",
        "contact_support": "Sazināties ar atbalstu"
      }
    }
  },
  "bulk_buy": {
    "upload_description": "Augšupielādējiet dokumentus, lai iegūtu uzņēmuma datus un atcelšanas prasības",
    "upload_description_new": "Augšupielādējiet ilgtspējas ziņojumu un patēriņa datus. AI aizpildīs visus laukus jūsu vietā.",
    "quick_info": "Ātrā informācija",
    "upload_hint": "Augšupielādējiet vienu vai vairākus dokumentus, lai automātiski iegūtu uzņēmuma datus",
    "manual_add_hint": "Vai pievienojiet uzņēmumus manuāli, aizpildot tukšo rindu apakšā",
    "purchase_settings": "Iepirkuma iestatījumi",
    "overview": "Pārskats",
    "purchase_mode": {
      "CHEAPEST": "Lētākais",
      "GHG": "GHG",
      "RE100": "RE100",
      "ADVANCED": "Premium iespējas",
      "OTHER": "Cits"
    },
    "ghg_description": "SBTi, ERI, CDB",
    "re100_description": "Vējš + Saule, COD ≤ 15 gadi",
    "cheapest_description": "Izdevīgākās iespējas",
    "premium_description": "Pielāgotas iepirkuma prasības",
    "go_source": "EAC avots",
    "technology": "Tehnoloģija",
    "ecolabel": "Ekomarķējums",
    "vintage": "Gads",
    "support": "Atbalsta statuss",
    "cod_requirement": "COD prasība",
    "matching_mode": {
      "yearly": "Gada saskaņošana",
      "monthly": "Mēneša saskaņošana",
      "hourly": "24/7 stundu saskaņošana (Premium)"
    },
    "destination_companies": "Saņēmēji",
    "destination_companies_description": "Katra rinda pārstāv uzņēmumu, kas saņems IA atcelšanu tā vārdā.",
    "companies": "@:common.companies",
    "no_companies": "Saņēmēji vēl nav pievienoti. Augšupielādējiet dokumentus vai pievienojiet manuāli.",
    "company_name": "Saņēmējs",
    "country": "Saņēmēja valsts",
    "registry_code": "Uzņēmuma ID",
    "volume": "Patēriņš (MWh)",
    "match_origin": "Atbilst izcelsmei",
    "price": "Indikatīvā cena",
    "tooltip_company_name": "Juridiskā persona, kas tiks norādīta kā atcelšanas paziņojuma saņēmējs — puse, kas pieprasa atjaunojamās enerģijas patēriņu.",
    "tooltip_country": "Valsts, kurā saņēmējs atrodas un patērē elektroenerģiju. Nosaka, kur sertifikāti jāatceļ.",
    "tooltip_registry_code": "Uzņēmuma reģistrācijas numurs — nevis PVN numurs. Parādās atcelšanas paziņojumā.",
    "tooltip_address": "Saņēmēja reģistrētā adrese vai objekta adrese. Izmanto identificēšanai atcelšanas paziņojumā.",
    "tooltip_volume": "Gada elektroenerģijas patēriņš, ko segt ar atjaunojamās enerģijas sertifikātiem, megavatstundās (MWh). 1 MWh = 1 sertifikāts.",
    "tooltip_price": "Indikatīvā cena, pamatojoties uz pašreizējām tirgus cenām un izvēlētajiem iepirkuma parametriem — indikatīvs, nevis saistošs piedāvājums. Nospiediet 'Pieprasīt cenu', lai aprēķinātu.",
    "eac_type": "EAC veids",
    "tooltip_eac_type": "Sertifikātu shēma, ko izmanto saņēmēja valstī. Tiek noteikta automātiski pēc valsts; valstīm ārpus mūsu reģistriem izvēlieties paši.",
    "pricing_idle": "Nav aprēķināts",
    "rfq_notice": "Soldera veiks cenu aptauju (RFQ)",
    "global_cancellation_settings": "Globālie atcelšanas iestatījumi",
    "period_start": "Perioda sākums",
    "period_end": "Perioda beigas",
    "beneficiary_type": "Saņēmēja veids",
    "beneficiary_types": {
      "ELECTRICITY_SELLER": "Elektroenerģijas pārdevējs",
      "CONSUMER": "Patērētājs",
      "CONVERSION_PLANT_OPERATOR": "Pārveidošanas stacijas operators"
    },
    "summary": "Kopsavilkums",
    "total_volume": "Kopējais apjoms",
    "total_price": "Indikatīvā kopējā cena",
    "illiquid_companies": "nevienam uzņēmumam cena netiks noteikta ar RFQ | {count} uzņēmumam cena tiks noteikta ar RFQ | {count} uzņēmumiem cena tiks noteikta ar RFQ",
    "confirm_order": "Apstiprināt pasūtījumu",
    "ask_for_quotes": "Pieprasīt piedāvājumus",
    "cancellation_details_title": "Atcelšanas informācija",
    "beneficiary_name": "Saņēmēja vārds",
    "residency": "Rezidence",
    "company_address": "Uzņēmuma adrese",
    "address": "@:common.address",
    "cancellation_purpose": "Atcelšanas mērķis",
    "cancellation_purpose_text": "Atcelšanas mērķis",
    "operation_notes_placeholder_consumer": "Patēriņa apliecinājums",
    "operation_notes_placeholder_seller": "Elektroapgāde",
    "cancellation_purposes": {
      "DISCLOSURE": "Atklāšana",
      "GRID_LOSSES": "Zudumi tīklā",
      "SELF_CONSUMPTION": "Pašpatēriņš",
      "SUPPORT_SCHEME": "Atbalsta shēma",
      "OTHER": "Citi"
    },
    "operation_notes": "Darbības piezīmes",
    "confirm_title": "Apstiprināt pirkšanas un atcelšanas pasūtījumu",
    "order_summary": "Pasūtījuma kopsavilkums",
    "illiquid_warning": "nevienam uzņēmumam cena netiks noteikta ar cenu aptauju (RFQ) | {count} uzņēmumam cena tiks noteikta ar cenu aptauju (RFQ) | {count} uzņēmumiem cena tiks noteikta ar cenu aptauju (RFQ)",
    "total_known_price": "Kopējā zināmā cena",
    "cancellation_not_supported_title": "Atcelšana tieši netiek atbalstīta",
    "cancellation_not_supported_description": "Šie uzņēmumi atrodas reģistros, kur mēs nevaram veikt atcelšanu tieši. Lūdzu, izvēlieties, kā vēlaties rīkoties:",
    "cancellation_option_agent": "Soldera organizē atcelšanu vietējā reģistrā pilnai atbilstībai",
    "cancellation_option_any_registry": "Atcelt jebkurā AIB reģistrā (standarta atcelšanas cena)",
    "companies_with_pricing": "Uzņēmumi ar zināmu cenu ({count})",
    "confirm_and_submit": "Apstiprināt un iesniegt pasūtījumus",
    "quoted_pricing": "Piedāvātā cena",
    "base_price": "Pamata cena",
    "price_per_mwh": "Cena par MWh",
    "no_pricing_info": "Šim pasūtījumam nav pieejama cenu informācija",
    "cancellation_fee": "Anulēšanas maksa",
    "minimum_cancellation_fee": "Minimālā anulēšanas maksa",
    "brokerage_fee": "Iepirkuma maksa",
    "incl_brokerage": "ieskaitot €{amount}/MWh iepirkuma maksu",
    "incl_cancellation": "ieskaitot €{amount}/MWh anulēšanas maksu",
    "incl_min_cancellation": "ieskaitot €{amount} min. anulēšanas maksu",
    "eac_source": "EAC avots",
    "matching": "Saskaņošana",
    "cancellation_settings": "Atcelšanas iestatījumi",
    "purchase_settings_title": "Iepirkuma iestatījumi",
    "purchase_mode_label": "Iepirkuma režīms",
    "pricing_error": "Neizdevās aprēķināt cenu. Lūdzu, mēģiniet vēlreiz vai sazinieties ar atbalsta dienestu.",
    "volume_required": "Apjomam jābūt vismaz 1 MWh",
    "country_required": "Cenas aprēķinam nepieciešama valsts",
    "intro": "Iegādājieties atjaunojamās enerģijas sertifikātus un anulējiet tos savu labuma guvēju vārdā — vienā solī. Izvēlieties, kā sertifikāti tiks iegūti, pievienojiet katru labuma guvēju zemāk un apstipriniet.",
    "accelerator_title": "Sāciet no dokumenta",
    "sourcing_preference_description": "Kā mēs iegūstam sertifikātus katram labuma guvējam.",
    "sourcing_cheapest_title": "Lētākais",
    "sourcing_cheapest_desc": "Izmaksu ziņā izdevīgākās pieejamās iespējas",
    "sourcing_ghg_title": "SEG",
    "sourcing_ghg_desc": "Atbilst SBTi, ERI un CDP ziņošanas kritērijiem",
    "sourcing_re100_title": "RE100",
    "sourcing_re100_desc": "Vējš + saule, COD ≤ 15 gadi",
    "sourcing_other_title": "Cits",
    "sourcing_other_desc": "Aprakstiet savu iegādes prasību",
    "custom_requirement_label": "Pielāgota iegādes prasība",
    "custom_requirement_placeholder": "Pastāstiet, kas jums nepieciešams — konkrēta tehnoloģija, valsts, gads, ekomarķējumi vai jebkura cita iegādes prasība. Mūsu komanda sazināsies ar pielāgotu piedāvājumu.",
    "custom_requirement_advisory": "Pielāgotām prasībām cena tiek noteikta ar cenu aptauju (RFQ) — mūsu komanda atbildēs ar indikatīvu piedāvājumu, parasti vienas darba dienas laikā.",
    "shared_cancellation_settings": "Kopīgie anulēšanas iestatījumi",
    "add_beneficiary": "Pievienot labuma guvēju",
    "add_another_beneficiary": "Pievienot vēl vienu labuma guvēju",
    "no_beneficiaries_title": "Labuma guvēji vēl nav pievienoti",
    "no_beneficiaries_description": "Augšupielādējiet dokumentu augstāk, lai tos aizpildītu automātiski, vai pievienojiet pirmo labuma guvēju manuāli.",
    "total_consumption": "Kopējais patēriņš",
    "estimated_cost": "Indikatīvās izmaksas",
    "add_at_least_one_beneficiary": "Pievienojiet vismaz vienu labuma guvēju",
    "ask_for_quote": "Pieprasīt piedāvājumu",
    "fetching_quotes": "Iegūst piedāvājumus…",
    "review": "Pārskatīt",
    "request_custom_quote": "Pieprasīt pielāgotu piedāvājumu",
    "custom_quote_reassurance": "Soldera veiks cenu aptauju (RFQ) un atbildēs ar indikatīvu piedāvājumu, pirms kaut kas tiek nopirkts.",
    "manual_quote": "Cena ar RFQ",
    "by_quote": "Pēc RFQ",
    "priced_subline": "{known} no {total} MWh ar noteiktu cenu · {perMwh}/MWh",
    "rfq_reassurance": "Rindas ar zināmu cenu tiek iesniegtas izpildei par piedāvāto cenu. Pārējiem apjomiem Soldera veiks cenu aptauju (RFQ) mūsu piegādātāju tīklā un atbildēs ar indikatīvu piedāvājumu — parasti vienas darba dienas laikā. RFQ rindām nekas netiek pirkts, kamēr neapstiprināsiet piedāvājumu.",
    "review_order_title": "Pārskatīt pirkšanas un anulēšanas pasūtījumu",
    "average_unit_price": "Vidējā vienības cena",
    "indicative_bid_note": "Visas norādītās cenas ir indikatīvas un balstītas uz pašreizējo tirgus līmeni — tas nav saistošs piedāvājums. Galīgā cena tiek apstiprināta, izpildot pasūtījumu.",
    "quotes_indicative_note": "Visi piedāvājumi ir indikatīvi — galīgā cena tiek apstiprināta darījuma izpildē.",
    "market_levels_as_of": "Tirgus cenu līmeņi uz {date}",
    "quote_reference": "Atsauce {id}",
    "quote_reference_label": "Piedāvājuma atsauce",
    "consumption_period": "Patēriņa periods",
    "cancellation_mode_selection_aria": "Atcelšanas veida izvēle",
    "remove_beneficiary_row_aria": "Noņemt labuma guvēja rindu {index}"
  },
  "dashboard": {
    "issuance_chart": {
      "title": "Izsniegšanas diagramma",
      "description": "Pēdējos 12 mēnešos izsniegtās MWh katrai ražošanas iekārtai.",
      "y_axis": "Izsniegtās MWh",
      "y_axis_log": "Izsniegtās MWh (logaritmiskā skala)",
      "scale_absolute": "Absolūtā",
      "scale_log": "Logaritmiskā skala",
      "zero_marker_note": "Logaritmiskā skala nevar parādīt nulli: mēneši bez izsniegšanas ir atzīmēti ar ✕ uz pamatlīnijas.",
      "no_data": "Nav izsniegšanas datu par pēdējiem 12 mēnešiem",
      "load_failed": "Neizdevās ielādēt izsniegšanas diagrammu. Lūdzu, mēģiniet vēlreiz."
    },
    "devices_in_registry": "Reģistrā pārvaldītās ierīces",
    "no_devices_in_registry": "Reģistrā nav ierīču",
    "add_device_description": "Pievienojiet savu pirmo ierīci, lai sāktu pārvaldīt sertifikātus",
    "add_first_device": "Pievienot pirmo ierīci",
    "add_registry_device": "Pievienot reģistra ierīci",
    "add_registry_device_description": "Manuāli pievienot jaunu ierīci savam reģistram sertifikātu pārvaldīšanai",
    "select_company": "Izvēlēties uzņēmumu",
    "action_required": "Nepieciešama darbība",
    "consolidated_view": "Konsolidēts skats",
    "consolidated_view_description": "Skatīt visus uzņēmumus kopā",
    "company_id_label": "ID: {id}",
    "market": {
      "base_price": "Bāzes cena"
    },
    "consolidated": {
      "overview_for": "Konsolidēts skats kontam {email}",
      "devices_overview": "{count} ierīces ar kopējo jaudu {power} kW",
      "back_to_dashboard": "Atpakaļ uz darblapas",
      "pending_payouts": "Nauda gaida",
      "paid_out_30d": "Izmaksāts (30 dienas)",
      "projected_production": "Projektētā ražošana",
      "projected_production_description": "Ražošanas prognoze, pamatojoties uz ierīces jaudu",
      "projected_production_by_company": "Prognozētā produkcija pa uzņēmumiem",
      "projected_production_by_company_description": "Sakārtots pēc kopējās prognozētās produkcijas",
      "production_volume": "Ražošanas tilpums",
      "production_volume_description": "Summas ir parādītas MWh vienībās",
      "production_volume_table": {
        "quarter": "Ceturksnis",
        "month": "Mēnesis",
        "monthly": "Mēnešis",
        "quarterly": "Kvartāls",
        "total": "Kopā",
        "current": "Praktiski"
      },
      "production_distribution": "Prognozētā ražošanas avotu sadalījums",
      "production_distribution_description": "Pēdējie 12 mēneši",
      "production_devices": "Ražošanas ierīces",
      "production_devices_description": "{deviceCount} ierīces {companyCount} uzņēmumā",
      "production_devices_table": {
        "company_name": "Uzņēmums",
        "device_id": "ID",
        "total": "Kopā",
        "technology": "Tehnoloģija",
        "device_count": "Ierīces",
        "device_name": "Nosaukums",
        "capacity": "Jauda",
        "status": "Statuss",
        "no_devices": "Nav ierīču attēlošanai",
        "more_devices": "Vēl {count} ierīces",
        "view_projection": "Skatīt prognozi",
        "view_breakdown": "Skatīt apkopojumu",
        "scheduled_transactions_tooltip": "reģistrā konfigurēti automātiskie pārvedumi"
      },
      "company_filter_hint": "Izvēlieties uzņēmumus, kuru datus vēlaties redzēt konsolidētajā skatā",
      "selector_no_companies": "Nav uzņēmumu",
      "selector_all_companies": "Visi uzņēmumi",
      "selector_countries_companies": "{countries} valstis · {companies} uzņēmumi",
      "selector_company_count": "Nav uzņēmumu | {count} uzņēmums | {count} uzņēmumi",
      "selector_selected_count": "Izvēlēti {selected}/{total}",
      "selector_only": "tikai",
      "selector_show_only": "Rādīt tikai {country}",
      "selector_remove_country": "Noņemt {country}",
      "no_companies_selected_title": "Nav izvēlēts neviens uzņēmums",
      "no_companies_selected_hint": "Izvēlieties vismaz vienu uzņēmumu vai valsti augšpusē, lai redzētu datus."
    },
    "buyer": {
      "consolidated_view": "Pircēja konsolidētais skats",
      "go_cancelled": "Enerģijas atribūtu sertifikāti atcelti",
      "certificates_this_year": "sertifikāti šogad",
      "membership_agreement": "Platformas līgums",
      "agree_to_terms": "Es piekrītu noteikumiem",
      "terms_accepted": "Noteikumi veiksmīgi apstiprināti",
      "manage_inventory": "Pirkt un atcelt",
      "platform_agreement_clickwrap_intro": "Noklikšķinot uz Piekrītu, jūs piekrītat {link}",
      "platform_agreement_link_text": "Soldera Platformas Līgumam"
    },
    "corporate": {
      "sections": {
        "energy_attribute_certificates": "Enerģijas atribūtu sertifikāti"
      }
    },
    "companies": "@:common.companies",
    "sign_document": "Parakstīt Dokumentu",
    "continue_registration": "Turpināt Reģistrāciju",
    "add_company_or_device": "Pievienot Uzņēmumu vai Ierīci",
    "add_company_access": "Pievienot Uzņēmuma Piekļuvi",
    "company_id": "Uzņēmuma ID",
    "company_ids_placeholder": "Uzņēmuma ID - viens vai ar komatiem atdalīts",
    "add_company": "Pievienot Uzņēmumu",
    "internal_role": "Iekšējā Loma",
    "user": "Lietotājs",
    "super_admin": "Super Administrators",
    "sales_admin": "Pārdošanas administrators",
    "fee_model": "Maksas Modelis",
    "standard": "Standarts",
    "special_free": "Īpašais Bez Maksas",
    "special_5pct": "Īpašais 5%",
    "special_1eur_per_mw": "Īpašais 1€/MW",
    "registry_excluded_devices": "Reģistrā Neiekļautās Ierīces (atdalītas ar komatiem)",
    "allowed_invite_domains_label": "Atļautie uzaicinājumu domēni (atdalīti ar komatiem)",
    "allowed_invite_domains_help": "Komandas uzaicinājumus var nosūtīt tikai uz šo domēnu e-pasta adresēm. Atstājiet tukšu, lai atļautu jebkuru domēnu.",
    "is_test_company": "Vai Testa Uzņēmums?",
    "hosted_account_regions_label": "Mitināto kontu reģioni (IG saņemšana)",
    "hosted_account_regions_help": "Izvēlieties, kuru valstu reģistra kontus šis uzņēmums drīkst izmantot IG saņemšanai uz Soldera mitinātiem kontiem.",
    "save_changes": "Saglabāt Izmaiņas",
    "all_trackings": "Visi Sekošanas Dati",
    "referrer_company_id": "Norādītāja uzņēmuma ID",
    "utm_source": "UTM Avots",
    "utm_medium": "UTM Vide",
    "utm_term": "UTM Termiņš",
    "utm_content": "UTM Saturs",
    "utm_campaign": "UTM Kampaņa",
    "created_at": "Izveidots",
    "admin_only_transfer_and_delete_company": "Tikai Admin: Pārnest visus aktīvus citam uzņēmumam un DZĒST uzņēmumu:",
    "transfer_to": "Pārnest uz: {name} - {id}",
    "transfer": "Pārnest",
    "nda_signed_link": "Saite saiti NDA līgumu, ko parakstījām ar klientu",
    "client_nda_signed_link_title": "Īpašo nosacījumu dokumenti",
    "client_nda_signed_link": "Piekļūt īpašajiem nosacījumiem starp Soldera un {name} var, noklikšķinot šeit",
    "custom_percentage": "Pielāgota procentuālā daļa",
    "custom_percentage_hint": "Tiek atbalstītas pielāgotas procentuālās vērtības no 5 līdz 20",
    "automaticReporting": {
      "title": "Automātiska ražošanas pārskatu sniegšana",
      "requiresAction": "Nepieciešama darbība",
      "lastUpdated": "Pēdējoreiz atjaunināts:",
      "lastDeclaredMonth": "Pēdējais deklarētais ražošanas mēnesis:",
      "lastDeclaredAmount": "Pēdējā deklarētā summa:",
      "helpNeeded": "Mums nepieciešama jūsu palīdzība, lai nodrošinātu, ka pareizā ražošanas ierīce ESO ir saistīta ar pareizo ierīci Litgrid Grexel reģistrā.",
      "missingAssociation": "Trūkst saistības ar mērījumu punktu",
      "automaticallyDeclared": "Automātiski deklarēts",
      "declaredFor": "Deklarēts par:",
      "amount": "Daudzums:",
      "pendingApproval": "Gaida apstiprinājumu"
    },
    "sales_transactions": {
      "title": "Darījumu vēsture",
      "description": "Izcelsmes sertifikātu cenas ir svārstīgas un var mainīties katru dienu. Zemāk jūs atradīsiet pārskatu par visiem jūsu darījumiem.",
      "description_link": "Objektīvai salīdzināšanai starp jūsu darījumiem un tirgus cenām mēs iesakām iepazīties ar mūsu rakstu par izcelsmes sertifikātu publiskajiem cenu signāliem.",
      "no_sales_transactions": "Nākotnē šeit atradīsiet savu darījumu vēsturi ar piedāvājumu informāciju!",
      "notificationInfo": "Mēs jums paziņosim pa e-pastu, kad būs notikuši pārdošanas darījumi.",
      "date": "Darījuma datums",
      "item": "Prece",
      "final_unit_price": "Vienības cena",
      "amount": "Daudzums",
      "offer_range": "Piedāvājumu diapazons",
      "final_country": "Uzvarošā piedāvājuma valsts",
      "status": "Statuss",
      "processing_explanation": "Soldera gaida iegūt naudas no sandorio partneri. Ja naudas ir iegūtas, mēs jums paziņosim par darījumu.",
      "completed": "Pabeigts",
      "processing": "Apstrāde",
      "pending_sales_details": "Pārdošanas informācija gaida",
      "export_xlsx": "Eksportēt uz Excel",
      "view_aggregated": "Kopskats",
      "view_by_company": "Pa uzņēmumiem",
      "view_by_power_plant": "Pa elektrostacijām",
      "power_plant": "Elektrostacija",
      "revenue": "Ieņēmumi",
      "soldera_fees": "Soldera maksas (bez PVN)",
      "registry_fees": "Reģistra maksas (bez PVN)",
      "fees_pending": "Maksas gaida"
    },
    "income_estimate": {
      "view_estimate": "Skatīt ieņēmumu prognozi"
    },
    "companyData": {
      "automatic_sale_with_highest_offer": "Automātiska pārdošana par augstāko piedāvājumu",
      "fresh_production_sale_above_minimum_price": "Svaigas ražošanas pārdošana virs minimālās cenas {price}€/MWh",
      "modify": "Modificēt",
      "money_pending": "Nauda gaida",
      "transaction_history": "Darījumu vēsture",
      "origin_certificates": "Izcelsmes sertifikāti",
      "view_details": "Skatīt detaļas",
      "hide_details": "Slēpt detaļas",
      "submit_invoice": "Iesniegt rēķinu",
      "invoice_history": "Rēķinu vēsture",
      "documents": "@:common.documents",
      "continue_authorization_creation": "Turpināt pieteikumu",
      "thank_you_for_joining": "Paldies, ka pievienojāties Soldera!",
      "thank_you_message": "Mēs jūsu vārdā sazināsimies ar reģistru un nodrošināsim visu tiesvedību. Tagad jums tikai jāgaida, kad reģistrs veiks savas darbības, un mēs pārdosim jūsu sertifikātus. Kad pārdošana būs veikta, mēs jums paziņosim un lūgsim jums izveidot rēķinu, lai mēs varētu pārskaitīt naudu.",
      "add_companies_or_devices_while_waiting": "Kamēr gaidāt, jums ir iespēja pievienot uzņēmumus vai ierīces",
      "add_companies_while_waiting": "Gaidīšanas laikā varat pievienot vēl vienu uzņēmumu",
      "invite_a_friend": "Uzaicini draugu",
      "invite_a_friend_message": "Vai jūs pazīstat kādu, kam arī varētu būt lietderīgi izmantot Soldera? 30% no katras aicinātā drauga pirmā gada maksām tiek jums!",
      "click_to_copy_link": "Noklikšķiniet šeit, lai nokopētu saiti, ko nosūtīt draugam",
      "production_settings": "Ražošanas iestatījumi",
      "measurement_points": "Mērīšanas punkti",
      "documents_signed_with_soldera": "Dalības līgums, kas parakstīts ar Soldera",
      "other_documents": "Citi dokumenti",
      "device_contract": "Ierīces {deviceName} līgums",
      "contract_between_company_and_soldera": "Līgums starp {companyName} un Soldera",
      "company_contract": "Līgums ar {companyName}",
      "link_copied": "Saite ir veiksmīgi nokopēta!",
      "link_copied_fallback": "Saite nokopēta starpliktuvē (rezerves metode).",
      "link_copy_failed": "Neizdevās nokopēt saiti. Lūdzu, kopējiet to manuāli.",
      "update_min_price_success": "Minimālās cenas atjaunināšana bija veiksmīga!",
      "new_min_price_effective_immediately": "Jaunā minimālā cena stājas spēkā nekavējoties",
      "update_min_price_failed": "Neizdevās atjaunināt minimālo cenu",
      "invoice_submission_success": "Rēķina iesniegšana bija veiksmīga!",
      "invoice_paid_within_7_days": "Rēķins veiksmīgi iesniegts un tiks apmaksāts 7 dienu laikā.",
      "fetch_pending_invoice_items_failed": "Neizdevās iegūt gaidāmos rēķinus",
      "fetch_certificates_failed": "Neizdevās iegūt sertifikātus",
      "team": {
        "title": "Komanda",
        "invite_title": "Uzaicināt komandā",
        "not_trusted_tooltip": "Komandas dalībnieku pievienošana ir pieejama pēc konta aktivizēšanas. Sazinieties ar support@soldera.org.",
        "delete": "Dzēst",
        "invite": "Uzaicināt",
        "send_invite_email": "Sūtīt uzaicinājuma e-pastu",
        "invalidName": "Vārdam jābūt vismaz 2 rakstzīmju garam",
        "invalidEmail": "Nepareizs e-pasta formāts",
        "domain_not_allowed": "Var uzaicināt tikai šo e-pasta domēnu adreses: {domains}",
        "allowed_domains_hint": "Uzaicinājumi ir atļauti tikai šiem e-pasta domēniem: {domains}",
        "confirmDelete": "Vai tiešām vēlaties atņemt {account_name} piekļuvi uzņēmumam {company_name}?"
      },
      "available_guarantees_of_origin": "Pieejamie izcelsmes apliecinājumi",
      "manage_inventory": "Pārvaldīt inventāru",
      "projected_production": "Prognozētā ražošana",
      "manage_production_strategy": "Pārvaldīt ražošanas stratēģiju",
      "invoice_management": "Rēķinu pārvaldība",
      "cancellation_documents": "Atcelšanas dokumenti",
      "add_device": "Pievienot ierīci",
      "no_devices": "Nav ierīču",
      "add_device_message": "Pievienojiet ierīci savam uzņēmumam, lai sāktu pārvaldīt ražošanu."
    },
    "devices": "Reģistrētās ierīces",
    "generator": {
      "license_number": "Ierīce ar licences numuru {license_number}",
      "hide_documents": "Paslēpt saistītos dokumentus",
      "show_documents": "Rādīt saistītos dokumentus"
    },
    "documents": {
      "last_updated": "Pēdējoreiz atjaunināts",
      "section_title": "{document_count} dokumenti",
      "expand": "Skatīt visus {document_count} dokumentus",
      "collapse": "Paslēpt dokumentus",
      "hide_details": "Paslēpt dokumentus konteinerā",
      "show_details": "Rādīt dokumentus konteinerā",
      "document_title": "{document_name}",
      "other_document": "Dokuments atjaunināts {updated_at}",
      "show_associated_device": "Rādīt saistīto ierīci",
      "hide_associated_device": "Paslēpt saistīto ierīci",
      "no_documents": "Dokumentu vēl nav",
      "no_documents_message": "Šeit parādīsies jūsu augšupielādētie vai saņemtie dokumenti"
    },
    "portfolio": {
      "no_portfolio_data_title": "Jūsu portfeļa dati vēl nav pieejami",
      "no_portfolio_data_subtitle": "Jūsu portfeļa dati tiks rādīti šeit, kad mēs saņemsim savu reģistrācijas datus.",
      "all_portfolios": "Visi portfeļi",
      "total_volumes": "Kopējie apjomi",
      "available_volumes": "Pieejamie apjomi",
      "expired_volumes": "Termiņa beigušies apjomi",
      "sold_volumes": "Pārdotie apjomi",
      "monthly_technology_breakdown": "Mēneša dalījums pa tehnoloģijām",
      "monthly_sales_status": "Mēneša dalījums pēc pārdošanas statusa",
      "company_breakdown": "Apjomi pa uzņēmumiem",
      "guarantees_of_origin_in_portfolios": "Izcelsmes apliecinājumu portfelis",
      "projected_production": "Prognozētā ražošana",
      "pending_payouts": "Gaidāmie maksājumi",
      "production_devices": "Ražošanas ierīces",
      "documents": "@:common.documents",
      "recipient_eecs_account_number": "Saņēmēja EECS konta numurs",
      "recipient_internal_account_number": "Reģistra iekšējā konta numurs",
      "recipient_internal_account_help": "Ne obligāti. Nepieciešams tikai reģistros, kas izmanto apakškontus.",
      "recipient_internal_account_placeholder": "Ne obligāta apakškonta ID",
      "certificatesTableTitle": "Portfeļa Sertifikāti",
      "sendGoChatWelcome": "Sveiki! Kā es varu jums šodien palīdzēt nosūtīt izcelsmes apliecinājumus?",
      "sendGoChatWelcomeWithCerts": "Sveiki! Redzu, ka esat izvēlējies {count} sertifikātu(s). Kādi ir saņēmēja dati?",
      "sendGoChatAssistant": "GO Sūtīšanas Asistents",
      "sendGoChatPlaceholder": "Jautājiet par GO sūtīšanu, norādiet saņēmēja datus vai nometiet failu...",
      "sendGoChatInputPlaceholder": "Ievadiet saņēmēja datus vai MWh daudzumu...",
      "sendGoOrderSummary": "Sūtīšanas Pasūtījuma Kopsavilkums",
      "selected_certificates": "Izvēlētie Sertifikāti",
      "selected_certificates_summary": "Izvēlēto Sertifikātu Kopsavilkums",
      "disabledReasonPortfolio": "Šo sertifikātu komplektu nevar nosūtīt, jo tas jau ir piešķirts {portfolio} portfelim",
      "disabledReasonStatus": "Šis sertifikāts nav pieejams izvēlētajā statusā.",
      "disabledReasonUnknown": "Šis sertifikāts nav pieejams izvēlētajā portfelī.",
      "recipientRegistryId": "Saņēmēja Reģistra ID",
      "recipientCountry": "Saņēmēja Valsts",
      "recipientCompanyName": "Saņēmēja Uzņēmuma Nosaukums",
      "certificatesToSend": "Nosūtāmie Sertifikāti",
      "noCertificatesSelected": "Nav atlasīti sertifikāti sūtīšanai.",
      "totalMwhToSend": "Kopējais Nosūtāmais MWh Daudzums",
      "totalMwhInTable": "Atlasītie MWh",
      "sendGoDropFile": "Nometiet failu šeit, lai iegūtu datus",
      "sendGoUploadingFile": "Augšupielādē {name}...",
      "sendGoUploadSuccess": "Veiksmīgi augšupielādēts {name}.",
      "sendGoSuccessMessage": "Sūtīšanas pasūtījums veiksmīgi iesniegts!",
      "fileUpload": {
        "title": "Augšupielādēt dokumentu",
        "description": "Augšupielādējiet dokumentu, lai automātiski iegūtu saņēmēja informāciju",
        "dropzone": "Velciet dokumentu šeit vai noklikšķiniet, lai pārlūkotu",
        "supportedFormats": "Atbalstītie formāti: PDF, Word, Excel un citi",
        "analyzing": "Analizē dokumentu...",
        "extractionComplete": "Analīze pabeigta! Atradu saņēmēja informāciju.",
        "apply": "Piemērot iegūto informāciju",
        "reset": "Atiestatīt",
        "uploadPrompt": "Nometiet līgumu šeit vai noklikšķiniet, lai augšupielādētu",
        "drop_prompt": "Nometiet failu, lai augšupielādētu",
        "uploadAnother": "Augšupielādēt citu failu",
        "analysisSuccessTitle": "Līgums veiksmīgi analizēts.",
        "analysisSuccessMessage": "Faila dati ir iegūti un piemēroti formai.",
        "analysisNoMatchTitle": "Nav atbilstošu sertifikātu.",
        "analysisNoMatchMessage": "Dokumenta kritēriji (tehnoloģija, ierīce vai ražošanas periods) neatbilst nevienam no jūsu pieejamajiem sertifikātiem, tāpēc neko nevarēja atlasīt. Lūdzu, pārskatiet pieprasījumu vai filtrus.",
        "analysisShortfallTitle": "Nepietiek atbilstošu sertifikātu.",
        "analysisShortfallMessage": "No atbilstošajiem sertifikātiem varēja atlasīt tikai {selected} MWh no pieprasītajiem {requested} MWh. Pirms apstiprināšanas pārskatiet iztrūkumu."
      },
      "no_certificates_to_display": "Neviens sertifikāts neatbilst pašreizējiem filtriem.",
      "disabled_reason_portfolio": "Sertifikāts ir portfelī '{portfolio}'.",
      "disabled_reason_status_sold": "Šo sertifikātu nevar atlasīt, jo tas ir pārdots.",
      "disabled_reason_status_ongoing_sale": "Šo sertifikātu nevar atlasīt, jo notiek pārdošana.",
      "disabled_reason_status_expired": "Šo sertifikātu nevar atlasīt, jo tam ir beidzies derīguma termiņš.",
      "disabled_reason_status_non_transferrable": "Šo sertifikātu nevar atlasīt, jo tas nav pārvedams.",
      "disabled_reason_status_reserved": "Šo sertifikātu nevar atlasīt, jo tas ir rezervēts citiem uzdevumiem.",
      "disabled_reason_status_waiting_for_sale": "Šo sertifikātu nevar atlasīt, jo tas gaida pārdošanu.",
      "disabled_reason_status_pending": "Šo sertifikātu nevar atlasīt, jo tas gaida sistēmas darbību.",
      "disabled_reason_status_unknown": "Šo sertifikātu nevar atlasīt tā statusa dēļ: {status}.",
      "disabled_reason_unknown": "Nevar atlasīt",
      "recipient_registry_id": "Saņēmēja Reģistra ID",
      "recipient_country": "Saņēmēja Valsts",
      "recipient_company_name": "Saņēmēja Uzņēmuma Nosaukums",
      "certificates_to_send": "Nosūtāmie Sertifikāti",
      "no_certificates_selected": "Nav atlasīti sertifikāti sūtīšanai.",
      "total_mwh_to_send": "Kopējais Nosūtāmais MWh Daudzums",
      "available_certificates_title": "Pieejamie Sertifikāti Pašpārvaldītā Portfelī",
      "table": {
        "more_certificates": "Vēl {count} sertifikāti",
        "select_columns": "Izvēlēties kolonnas",
        "columns_selected": "{count} kolonnas izvēlētas",
        "filters": {
          "search_company": "Meklēt uzņēmumu",
          "search_accounts": "Meklēt kontus",
          "search_portfolio": "Meklēt portfeli / projektu",
          "search_device": "Meklēt ierīci",
          "month_placeholder": "YYYY-MM",
          "cod_age_year_placeholder": "Gads",
          "cod_age_add_condition": "Pievienot nosacījumu",
          "active": "@:common.active"
        },
        "filter_chips": {
          "group_label": "Aktīvie filtri",
          "label": "Filtri",
          "none": "Nav",
          "value": "{column}: {value}",
          "remove": "Noņemt filtru “{column}”",
          "hiding": "slēpti {values}",
          "count_of_total": "{shown} no {total}",
          "contains": "satur “{text}”",
          "cod_age_years": "{conditions} gadi",
          "tag_default": "Noklusējums",
          "tag_document": "No dokumenta",
          "tag_unavailable": "Krājumā nav atbilstības",
          "reset": "Atjaunot noklusējuma filtrus",
          "clear_all": "Notīrīt visu"
        },
        "filtered_total": "Kopā",
        "count_cell": {
          "of": "no {count}",
          "editor": "No šīs rindas izvēlamie MWh",
          "full_title": "Noklikšķiniet, lai izvēlētos tikai daļu no šīs rindas",
          "full_label": "Izvēlēti visi {count} MWh, izvēlēties tikai daļu no šīs rindas",
          "partial_title": "Noklikšķiniet, lai mainītu apjomu",
          "partial_label": "Izvēlēti {selected} no {count} MWh, mainīt apjomu"
        }
      },
      "footer": {
        "action": "Darbības",
        "technology_amount": "Tehnoloģija un apjoms",
        "production_period": "@:common.production_period",
        "production_support": "Ražošanas atbalsts",
        "no_certificates_selected": "Nav izvēlēti sertifikāti",
        "review_send_title": "Sūtīšanas pārskats",
        "review_sell_title": "Pārdošanas pārskats",
        "review_cancel_title": "Atcelšanas pārskats",
        "confirm_send_btn": "Sūtīt tagad",
        "confirm_sell_btn": "Pārdot tagad",
        "confirm_cancel_btn": "Atcelt tagad",
        "cancel_btn": "@:common.cancel",
        "missing": "Trūkst",
        "overselected": "Izvēlēts par daudz",
        "matched": "Sakrīt",
        "strategy_auto_high": "Automātiska augsta likme",
        "strategy_min_price": "Svaiga ražošana virs minimālās cenas",
        "strategy_min_price_detailed": "Minimālā cena €{price}/MWh pirmos {duration} mēnešus, pēc tam automātiska pārdošana par tirgus cenu",
        "risk_flags": "Riski",
        "risk_region_mismatch": "Konstatēta reģiona neatbilstība",
        "risk_insufficient_inventory": "Nepietiekami krājumi",
        "selected_mwh": "{mwh} MWh",
        "of_available": "no {mwh} pieejamiem",
        "rows": "Rindas",
        "rows_selected": "neviena nav izvēlēta | {count} izvēlēta | {count} izvēlētas",
        "rows_partial": "neviena nav daļēja | {count} daļēja | {count} daļējas",
        "rows_hidden": "neviena nav paslēpta ar filtriem | {count} paslēpta ar filtriem | {count} paslēptas ar filtriem",
        "partial_hint": "Noklikšķiniet uz apjoma, lai izvēlētos daļu no rindas"
      },
      "cancelGoChatAssistant": "GO Atcelšanas Palīgs",
      "cancelGoChatPlaceholder": "Apstipriniet sertifikātus atcelšanai vai uzdodiet jautājumus...",
      "cancelGoChatInputPlaceholder": "Ievadiet apstiprinājumu vai iemeslu...",
      "cancelGoOrderSummary": "Atcelšanas Kopsavilkums",
      "certificatesToCancel": "Sertifikāti Atcelšanai / Izņemšanai no Aprites",
      "noCertificatesSelectedCancel": "Nav atlasīti sertifikāti atcelšanai.",
      "totalMwhToCancel": "Kopējais MWh Daudzums Atcelšanai",
      "cancelGoChatIntro": "Jūs esat izvēlējies {count} sertifikātu(s) atcelšanai. Lūdzu, apstipriniet vai norādiet iemeslu.",
      "sellGoChatAssistant": "GO Pārdošanas Palīgs",
      "sellGoChatPlaceholder": "Apstipriniet sertifikātus un pārdošanas stratēģiju...",
      "sellGoChatInputPlaceholder": "Apstipriniet pārdošanas stratēģiju vai uzdodiet jautājumus...",
      "sellGoOrderSummary": "Pārdošanas Kopsavilkums",
      "certificatesToSell": "Pārdodamie Sertifikāti",
      "noCertificatesSelectedSell": "Nav atlasīti sertifikāti pārdošanai.",
      "totalMwhToSell": "Kopējais Pārdodamais MWh Daudzums",
      "sellGoChatIntro": "Jūs esat izvēlējies {count} sertifikātu(s) pārdošanai. Lūdzu, apstipriniet pārdošanas stratēģiju.",
      "receiveGoChatAssistant": "GO Saņemšanas Palīgs",
      "receiveGoChatPlaceholder": "Aprakstiet GO, ko sagaidāt saņemt...",
      "receiveGoChatInputPlaceholder": "Ievadiet sūtītāja datus vai uzdodiet jautājumus...",
      "receiveGoOrderSummary": "Saņemšanas Kopsavilkums",
      "senderRegistryId": "Sūtītāja Reģistra ID",
      "senderCountry": "Sūtītāja Valsts",
      "senderCompanyName": "Sūtītāja Uzņēmuma Nosaukums",
      "expectedMwh": "Gaidāmais MWh",
      "receiveGoTablePlaceholder": "Gaidāmie ienākošie pārskaitījumi tiks uzskaitīti šeit.",
      "buyGoChatAssistant": "GO Pirkšanas Palīgs",
      "buyGoChatPlaceholder": "Kādus GO jūs meklējat? Aprakstiet apjomu, tehnoloģiju, cenu diapazonu utt.",
      "buyGoChatInputPlaceholder": "Norādiet apjomu, tehnoloģiju, cenu diapazonu...",
      "buyGoOrderSummary": "Pirkšanas Pieprasījums / Piedāvājumi",
      "buyVolume": "Apjoms (MWh)",
      "buyTechnology": "Tehnoloģija (Neobligāti)",
      "buyMaxPrice": "Maksimālā Cena (€/MWh, Neobligāti)",
      "buyOffersPlaceholder": "Piedāvājumi, kas atbilst jūsu pieprasījumam, parādīsies šeit.",
      "buyGoTablePlaceholder": "Potenciālie GO pirkšanai tiks uzskaitīti šeit.",
      "sellGoSuccessMessage": "Pārdošanas pasūtījums veiksmīgi iesniegts!",
      "sellGoSuccessTitle": "Pārdošanas iestatīšana pabeigta",
      "confirmSellTitle": "Apstiprināt pārdošanas iestatīšanu",
      "confirmSellMessage": "Jūs gribētu pieprasīt pārdot {mwh} MWh atjaunojamās enerģijas sertifikātus caur Soldera tirgus cenas sistēmu.",
      "confirm_sell_minimum_price_message": "Jūs pieprasāt pārdot {mwh} MWh atjaunojamās enerģijas sertifikātus, izmantojot minimālās cenas stratēģiju. Lūk, kā tas darbojas:",
      "confirm_phase_1_title": "Pirmie {duration} mēneši no ražošanas",
      "confirm_phase_1_description": "Sertifikāti tiks pārdoti tikai tad, ja tirgus cena atbilst vai pārsniedz jūsu minimālo cenu €{price}/MWh.",
      "confirm_phase_2_title": "Pēc {duration} mēnešiem no ražošanas",
      "confirm_phase_2_description": "Visi atlikušie sertifikāti tiks automātiski pārdoti par augstāko pieejamo tirgus cenu, lai tie nezaudētu vērtību.",
      "technologies": "Tehnoloģijas",
      "production_months": "Ražošanas mēneši",
      "spotSalesPortfolio": "Spot pārdošana",
      "spotSalesPortfolioDescription": "Pieejams pārdošanai tirgus cenā",
      "spot_sales_min_price_description": "Vispirms tiek piemērota minimālā cena, pēc tam automātiska pārdošana par tirgus cenu",
      "oldCertificatesWarningTitle": "Sertifikātu vecuma brīdinājums",
      "oldCertificatesWarningMessage": "Jūs esat izvēlējies {count} MWh sertifikātus, kas ir vecāki par {duration} mēnešiem no to izdošanas datuma. Minimālās cenas stratēģija attiecas tikai uz sertifikātiem pirmo {duration} mēnešu laikā pēc izdošanas. Lūdzu, noņemiet šos vecākos sertifikātus, lai turpinātu ar minimālās cenas stratēģiju.",
      "document": {
        "title": "@:common.documents",
        "company": "@:common.company",
        "status": "Statuss",
        "last_updated": "Pēdējā atjaunināšana",
        "actions": "@:common.actions.title",
        "contract_details": "Līguma informācija"
      },
      "disabled_reason_status_own_use": "Šo sertifikātu nevar izvēlēties, jo tas ir atzīmēts pašpatēriņam un nav tirgojams."
    }
  },
  "cancellation": {
    "list_title": "Atcelšanas paziņojumi",
    "add_new_statement": "Pievienot jaunu atcelšanas paziņojumu",
    "not_trusted_tooltip": "Paziņojumu pievienošana ir pieejama pēc konta aktivizēšanas. Sazinieties ar support@soldera.org.",
    "no_cancellations": "Nav atcelšanas paziņojumu",
    "no_cancellations_info": "Jūsu atcelšanas paziņojumi parādīsies šeit pēc to augšupielādes",
    "view_details": "Skatīt detaļas",
    "download_documents": "Lejupielādēt dokumentus",
    "download_shown": "Lejupielādēt redzamos (nav dokumentu) | Lejupielādēt redzamos ({count} dokuments) | Lejupielādēt redzamos ({count} dokumenti)",
    "download_preparing": "Sagatavo {current} / {total}…",
    "download_preparing_documents": "Sagatavo dokumentus…",
    "download_none_selected": "Pašreizējā atlasē nav dokumentu",
    "download_too_many_documents": "Pārāk daudz dokumentu, lai lejupielādētu vienlaikus ({count}). Sašauriniet filtrus līdz ne vairāk kā {max}.",
    "download_too_many_bytes": "Atlasīto dokumentu kopējais apjoms ir {total} MB; ierobežojums ir {max} MB. Sašauriniet filtrus un mēģiniet vēlreiz.",
    "download_too_large_title": "Atlase ir pārāk liela lejupielādei",
    "bulk_download_failed": "Neizdevās lejupielādēt atcelšanas paziņojumus",
    "bulk_download_no_documents_title": "Nav lejupielādējamu dokumentu",
    "bulk_download_no_documents": "Neviens no atlasītajiem dokumentiem vairs nav pieejams. Saraksts ir atjaunināts.",
    "create_statement": "Izveidot paziņojumu",
    "drop_to_create": "Velciet failus šeit, lai izveidotu jaunu atcelšanas paziņojumu",
    "table": {
      "id": "@:common.id",
      "created": "Izveidots",
      "beneficiary_name": "Saņēmēja vārds",
      "period": "Periods",
      "mwh_cancelled": "Atcelti MWh",
      "purpose": "Mērķis",
      "registry": "Reģistrs",
      "registry_code": "Reģistra kods",
      "more_statements": "Vēl {count} paziņojumi"
    },
    "details_title": "Atcelšanas paziņojuma detaļas",
    "details": {
      "basic_info": "Paziņojuma informācija",
      "documents": "Augšupielādētie dokumenti",
      "no_documents": "Nav augšupielādētu dokumentu",
      "period": "@:cancellation.table.period",
      "order_id": "Pasūtījuma ID",
      "load_error": "Neizdevās ielādēt atcelšanas detaļas",
      "download_all": "Lejupielādēt visus dokumentus",
      "registry_document": "Reģistra dokuments",
      "view_registry_document": "Skatīt reģistrā",
      "add_documents": "Pievienot dokumentus",
      "upload_selected": "Augšupielādēt"
    },
    "upload": {
      "drop_files": "Velciet un nometiet failus šeit vai noklikšķiniet, lai pārlūkotu",
      "supported_formats": "Atbalstītie formāti: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, PNG, JPG, JPEG (maks. 25MB katrs)"
    },
    "modal": {
      "upload_documents": "Augšupielādēt dokumentus",
      "uploaded_files": "Augšupielādētie faili",
      "files_required": "Nepieciešams vismaz viens fails",
      "order_selection": "Saistīt ar atcelšanas pasūtījumu",
      "order_selection_description": "Pēc izvēles saistiet šo paziņojumu ar esošu atcelšanas pasūtījumu, lai automātiski aizpildītu formas datus.",
      "linked_order": "Saistītais atcelšanas pasūtījums",
      "no_order_selected": "Neviens (manuāla ievade)",
      "order_option": "Pasūtījums #{id} - {date}",
      "order_help_text": "Izvēlieties pasūtījumu, lai automātiski aizpildītu formu ar esošajiem datiem, vai izvēlieties 'Neviens', lai ievadītu manuāli.",
      "statement_selection": "Izvēlēties paziņojumu",
      "no_statement_selected": "Lūdzu, izvēlieties paziņojumu",
      "statement_help_text": "Izvēlieties konkrētu paziņojumu no izvēlētā pasūtījuma, lai automātiski aizpildītu formas datus.",
      "statement_details": "Paziņojuma detaļas",
      "auto_fill_from_statement_notice": "Formas dati ir automātiski aizpildīti no izvēlētā paziņojuma. Jūs varat modificēt jebkuru lauku pēc nepieciešamības.",
      "select_statement_notice": "Lūdzu, izvēlieties paziņojumu no iepriekš esošā saraksta, lai automātiski aizpildītu formu.",
      "upload_description_with_ai": "Augšupielādējiet atcelšanas līgumus vai atbilstības dokumentus, lai automātiski aizpildītu formas laukus, vai pievienojiet papildu dokumentāciju.",
      "analyzing_document": "Dokumenta analīze ar AI...",
      "ai_analysis_applied": "AI analīze ir piemērota formai",
      "ai_populated": "AI aizpildīts",
      "clear_ai_data": "Notīrīt AI datus",
      "confirm_override_ai_data": "Tas aizstās AI aizpildītos datus ar pasūtījuma datiem. Vai esat pārliecināts, ka vēlaties turpināt?",
      "analysis_complete_title": "Analīze pabeigta",
      "analysis_success_with_fields": "Dokuments veiksmīgi analizēts un atjaunināti {count} lauki.",
      "analysis_success_no_fields": "Dokuments veiksmīgi analizēts, taču netika atrasta jauna informācija formas atjaunināšanai.",
      "analysis_success_multiple_statements_with_fields": "Dokumentā atrasti {total_statements} paziņojumi. Pielietots pirmais paziņojums un atjaunināti {count} lauki. Lūdzu, pārskatiet atlikušos paziņojumus manuāli.",
      "analysis_success_multiple_statements_no_fields": "Dokumentā atrasti {total_statements} paziņojumi, taču netika atrasta jauna informācija formas atjaunināšanai.",
      "multiple_statements_warning": "Dokumentā konstatēti vairāki paziņojumi ({total_statements}). Formas aizpildīšanai izmantots tikai pirmais paziņojums. Lūdzu, pārskatiet atlikušos paziņojumus manuāli.",
      "field": {
        "operation_notes": "Darbības piezīmes"
      }
    },
    "purpose": {
      "DISCLOSURE": "Atklāšana",
      "GRID_LOSSES": "Tīkla zudumi",
      "SELF_CONSUMPTION": "Pašpatēriņš",
      "SUPPORT_SCHEME": "Atbalsta shēma",
      "OTHER": "Cits"
    },
    "success": {
      "title": "Paziņojums izveidots!",
      "message": "Jūsu atcelšanas paziņojums ir veiksmīgi izveidots."
    }
  },
  "followup": {
    "international_self_signup": {
      "title": "Mēs drīz ar jums sazināsimies!",
      "message": "Paldies, ka reģistrējāties! Mūsu komanda ar jums sazināsies, lai pabeigtu reģistrāciju un palīdzētu parakstīt nepieciešamos dokumentus."
    },
    "latvia_manual_auth": {
      "title": "Pilnvarot Soldera Grexel sistēmā, lai pabeigtu reģistrāciju",
      "message": "Lai Soldera varētu sākt pārvaldīt jūsu izcelsmes apliecinājumus, jums nepieciešams manuāli pilnvarot mūs Grexel sistēmā. Lūdzu, sekojiet instrukcijām zemāk esošajā dokumentā, lai pabeigtu šo procesu.",
      "button": "Skatīt pilnvarošanas instrukcijas"
    },
    "latvia_sales_followup": {
      "title": "Mēs drīz sazināsimies!",
      "message": "Jūsu jaunajām ierīcēm būs nepieciešams neatkarīgs audits, pirms AST tās akceptēs. Mēs drīz sazināsimies, lai apspriestu nākamos soļus. Tikmēr jūs varat pievienot citu uzņēmumu vai ierīci.",
      "button": "Pievienot uzņēmumus vai ierīces"
    }
  },
  "document": {
    "document_container": "Parakstīšanas komplekts",
    "send_elering_email": "Sūtīt Elering e-pastu",
    "resend_email": "Sūtīt e-pastu",
    "signed": "Parakstīts",
    "awaiting_signature": "Gaida parakstu",
    "download": "Lejupielādēt dokumentu",
    "sign_document": "Parakstīt dokumentu",
    "delete_document": "Dzēst dokumentu",
    "admin_delete_document": "Admin dzēš dokumentu",
    "confirm_delete": "Vai esat pārliecināts, ka vēlaties dzēst šo dokumentu?",
    "confirm_admin_delete": "Vai esat pārliecināts, ka vēlaties dzēst šo dokumentu kā admins?",
    "unfinished_document": "Nepabeigta reģistrācija",
    "forward_service_appendix": {
      "title": "Nākotnes pārdošanas līgums",
      "description": "Nosaka noklusējuma noteikumus visiem nākotnes pārdošanas darījumiem, ko noslēdz Biedrs un Soldera, un sniedz ietvaru, kurā Puses vienojas par nākotnes pārdošanas instrukcijām."
    }
  },
  "validations": {
    "required": "Šis lauks ir obligāts.",
    "maxValue": "Maksimali reikšmē ir {max}.",
    "required_and_min": "Šis lauks ir obligāts un jābūt vismaz {min}.",
    "required_and_range": "Šis lauks ir obligāts un jābūt tarp {min} un {max}.",
    "exactStringLength": "Šis lauks ir jābūt tikai {length} rakstzīmju garumā.",
    "exactDigitLength": "Šis lauks ir jābūt tikai {length} ciparu garumā.",
    "minLength": "Šobrīd šis lauks ir '{model}' rakstzīmju garš, bet tam jābūt vismaz {min} rakstzīmju garumā.",
    "maxLength": "Šim laukam jābūt ne garākam par {max} rakstzīmēm.",
    "estonianPersonalID": "Šis lauks ir jāsatur derīgs personas kods.",
    "estonianCompanyCode": "Šis lauks ir jāsatur derīgs uzņēmuma reģistrācijas kods.",
    "estonianIDorCompanyCode": "Šis lauks ir jābūt vai nu uzņēmuma reģistrācijas kodam, vai īpašnieka personas kodam.",
    "estonianYourPersonalIDifID": "Personas kods ir jāsakrīt ar īpašnieka personas kodu.",
    "estonianDeviceEIC": "Šis lauks ir jāsatur derīgs ierīces EIC kods (piemēram, 38ZEE-12345678-X).",
    "estonianVATNumber": "Lūdzu ievadiet derīgu PVN numuru.",
    "latvianCompanyNumber": "Šis lauks ir jāsatur derīgs uzņēmuma reģistrācijas kods.",
    "latvianIDorVATNumber": "Šajā laukā jānorāda uzņēmuma PVN kods vai privātpersonu personas kods",
    "latvianYourPersonalIDifID": "Personas kodam jāatbilst īpašnieka personas kodam.",
    "latvianIDorRegistryCode": "Šim laukam jāsatur reģistrācijas kods uzņēmumiem vai personas kods fiziskām personām",
    "lithuanianCompanyNumber": "Šis lauks ir jāsatur derīgs uzņēmuma reģistrācijas kods.",
    "notExampleEIC": "EIC nedrīkst būt piemērā norādītais kods, bet gan jābūt ierīces īstajam EIC kodam.",
    "alpha": "Šis lauks var saturēt tikai burtus.",
    "personalName": "Lūdzu, ievadiet vārdu tādā pašā formā, kā tas ir norādīts personu apliecinošā dokumentā.",
    "phoneNumber": "Šis lauks ir jāsatur derīgs tālruņa numurs.",
    "someSubsidies": "Ja ražošanas ierīce ir saņēmusi subsīdijas, šeit jānorāda tās.",
    "generatorExists": "Lūdzu, augšupielādējiet Jūsu ražošanas ierīces tīkla līgumu, lai turpinātu.",
    "reasonableDate": "Lūdzu, pārliecinieties, ka datums ir pareizs.",
    "iban": "Lūdzu, ievadiet derīgu IBAN numuru.",
    "fileRequired": "Lūdzu, augšupielādējiet nepieciešamo dokumentu.",
    "swedishPersonalID": "Šim laukam jāsatur derīgs Zviedrijas personas kods.",
    "swedishCompanyCode": "Šim laukam jāsatur derīgs Zviedrijas organizācijas numurs.",
    "swedishIDorCompanyCode": "Šim laukam jāsatur vai nu derīgs Zviedrijas personas kods, vai organizācijas numurs.",
    "finnishPersonalID": "Šiame lauke turi būti nurodytas galiojantis Suomijos asmens kodas.",
    "finnishBusinessID": "Šiame lauke turi būti nurodytas galiojantis Suomijos įmonės ID (Y-tunnus).",
    "finnishIDorBusinessID": "Šiame lauke turi būti nurodytas galiojantis Suomijos asmens kodas arba įmonės kodas.",
    "integer": "Šajā laukā jābūt veselam skaitlim.",
    "required_and_integer": "Šis lauks ir obligāts un jābūt veselam skaitlim.",
    "required_integer_and_min": "Šis lauks ir obligāts, jābūt veselam skaitlim un vismaz {min}.",
    "required_integer_and_range": "Šis lauks ir obligāts, jābūt veselam skaitlim un starp {min} un {max}.",
    "selection_required": "Vismaz viens izvēles elements ir nepieciešams.",
    "between": "Vērtībai jābūt starp {min} un {max}.",
    "validRegistryCode": "Reģistrācijas kodam jābūt 3-20 burtciparu rakstzīmēm (burti, cipari, defises atļautas).",
    "validAddress": "Adresei jābūt no 5 līdz 200 rakstzīmēm garai.",
    "validVATNumber": "Lūdzu, ievadiet derīgu PVN numuru (formāts: XX123456789 vai CHE123456789).",
    "swedishVATNumber": "Lūdzu, ievadiet derīgu Zviedrijas PVN numuru (formāts: SE + 10 cipari + 01, piemēram, SE556229657301).",
    "validRepresentativeName": "Vārdam jābūt 2-100 rakstzīmju garam un jāietver gan vārds, gan uzvārds.",
    "validRepresentativePhone": "Tālruņa numuram jābūt 6-25 rakstzīmju garam un derīgā formātā.",
    "minValue": "Minimālā vērtība ir {min}.",
    "polishVATNumber": "Šajā laukā jāiekļauj derīgs Polijas PVN numurs (PL + 10 cipari).",
    "polishRegistryCode": "Šajā laukā jāiekļauj derīgs Polijas uzņēmuma reģistrācijas kods (10 cipari KRS).",
    "productionValue": "Ražošanas vērtībai jābūt lielākai par nulli.",
    "dateCannotBeFuture": "Datums nevar būt nākotnē.",
    "email": "Lūdzu, ievadiet derīgu e-pasta adresi.",
    "eecs_account_format": "Nederīgs EECS konta numura formāts",
    "unit_price_pln_format": "Jābūt pozitīvai summai ar ne vairāk kā 2 zīmēm aiz komata"
  },
  "validation": {
    "pl": {
      "invalid_vat_number": "Lūdzu, ievadiet derīgu Polijas PVN numuru (PL + 10 cipari).",
      "invalid_registry_code": "Lūdzu, ievadiet derīgu Polijas uzņēmuma reģistrācijas kodu (10 cipari KRS)."
    }
  },
  "registry_device": {
    "device_name": "Ierīces nosaukums",
    "device_power": "Ierīces jauda",
    "supported_device": "Ierīce ar atbalstu",
    "fetch_failed": "Neizdevās iegūt ierīces",
    "device_code": "Ierīce ar kodu {code}",
    "technology_code": "Tehnoloģijas kods",
    "commercial_operation_date": "Komerciālās darbības datums",
    "ecolabel_approved": "Ekomarķējums apstiprināts",
    "address": "@:common.address",
    "device_eic_placeholder": "Ievadiet ierīces identifikācijas kodu",
    "device_name_placeholder": "Ievadiet ierīces nosaukumu",
    "device_power_placeholder": "Ievadiet jaudu kW",
    "device_eic_description": "Unikāls ierīces identifikators reģistrā",
    "commercial_operation_date_description": "Datums, kad ierīce sāka komerciālo darbību",
    "polish_fields": {
      "title": "Papildu informācija, kas nepieciešama izdošanas datu pilnvarai",
      "installation_address": "Instalācijas adrese",
      "installation_address_placeholder": "Ievadiet ierīces uzstādīšanas fizisko adresi",
      "installation_address_description": "Fiziskā adrese, kur uzstādīta atjaunojamās enerģijas iekārta",
      "metering_system_number": "Mērīšanas sistēmas numurs",
      "metering_system_number_placeholder": "Ievadiet mērīšanas sistēmas identifikatoru",
      "metering_system_number_description": "Unikāls mērīšanas sistēmas identifikators",
      "metering_system_multiplier": "Mērīšanas sistēmas reizinātājs",
      "metering_system_multiplier_placeholder": "Ievadiet reizinātāja vērtību",
      "metering_system_multiplier_description": "Reizinātājs, ko piemēro skaitītāja rādījumiem",
      "osd_name": "Sadalīšanas sistēmas operatora (OSD) nosaukums",
      "osd_name_placeholder": "Ievadiet OSD nosaukumu un filiāli (ja piemērojams), piem., PGE Dystrybucja S.A. Oddział Łódź",
      "osd_name_description": "Sadalīšanas sistēmas operatora un konkrētās filiāles nosaukums, kas savienota ar jūsu ierīci",
      "osd_address": "OSD adrese",
      "osd_address_placeholder": "Ievadiet OSD adresi (ja piemērojams, filiāles adresi), piem., ul. Tuwima 58, 90-021 Łódź",
      "osd_address_description": "Jūsu ierīcei pievienotās sadalīšanas sistēmas operatora filiāles adrese"
    },
    "poa": {
      "generate": "Ģenerēt pilnvaru",
      "generating": "Ģenerē pilnvaru...",
      "generated_successfully": "Pilnvara veiksmīgi ģenerēta",
      "description": "Ģenerējiet pilnvaras dokumentu, lai atļautu Soldera piekļūt jūsu ierīces izdošanas datiem",
      "missing_polish_data_error": "Šai ierīcei trūkst nepieciešamās informācijas pilnvaras ģenerēšanai",
      "required_for_issuance": "Šī informācija ir nepieciešama, lai ģenerētu pilnvaru piekļuvei izdošanas datiem."
    },
    "production_estimate_override": {
      "title": "Ražošanas prognozes pārrakstīšana",
      "save": "Saglabāt",
      "saving": "Saglabā...",
      "use_manual_estimates": "Izmantot manuālās prognozes",
      "use_automatic_estimates": "Izmantot automātiskās prognozes",
      "monthly_production_estimates": "Ikmēneša ražošanas prognozes",
      "automatic_vs_manual": "Automātiskais pret manuālo",
      "automatic_calculated": "Automātiskais (aprēķināts)",
      "automatic": "Automātiskais",
      "manual": "Manuāls",
      "override_button": "Pārrakstīt prognozes",
      "projected_production": "Prognozētā ražošana",
      "configured_values": "Konfigurētās vērtības",
      "calculated_values": "Aprēķināts no vēsturiskajiem datiem",
      "feasibility_warning": "Pamatojoties uz jaunajām prognozēm, jūsu nākotnes pārdošanas mandāti, iespējams, vairs nesedz savas saistības: periodā {period} ir saistības {demand} MWh, bet prognozei pietrūkst {shortfall} MWh. Lūdzu, pārskatiet savus nākotnes apjomus.",
      "feasibility_warning_title": "Iepriekšējās pārdošanas stratēģijas brīdinājums"
    }
  },
  "account": {
    "name": "Vārds",
    "email": "E-pasts",
    "phone_number": "Telefona numurs",
    "registry_code": "Personas kods",
    "comment": "Komentēt"
  },
  "company": {
    "payout_currency": "Izmaksas valūta",
    "payout_currency_hint": "Izmaksas citās valūtās iespējo Soldera atbalsts.",
    "name": "@:common.name",
    "registry_code": "Reģistrācijas vai personas kods",
    "address": "@:common.address",
    "vat": "PVN kods",
    "vat_or_personal_id": "PVN kods vai personas kods",
    "bank_account": "Bankas konta IBAN",
    "bank_name": "Bankas nosaukums",
    "bank_swift": "Bankas SWIFT/BIC kods",
    "invalid_vat": "PVN numuram jābūt tukšam vai formātā XX999999999 (valsts kods + 8-12 cipari)",
    "contact_email": "Kontakta e-pasts",
    "invoice_email": "Rēķina e-pasts",
    "billing_email": "Norēķinu e-pasta adrese",
    "billing_email_tooltip": "Rēķini tiks nosūtīti arī uz šo adresi papildus jūsu konta e-pastam. Noderīgi pārsūtīšanai grāmatvedim vai finanšu nodaļai.",
    "monthly_rollup": "Izlaist pārdošanas paziņojumus — saņemt vienu ikmēneša e-pastu 1. datumā",
    "monthly_rollup_tooltip": "Jūs nesaņemsiet e-pastu par katru pārdošanu. Tā vietā katra mēneša 1. datumā saņemsiet vienu e-pastu ar iepriekšējā mēneša pārdošanas darījumiem un komisijas maksas rēķinu. Izmaksas rēķini joprojām tiek sūtīti, kad pieprasāt izmaksu."
  },
  "generator": {
    "device_name": "Invertora modelis",
    "device_eic": "Ierīces EIC",
    "device_power": "Kopējā jauda (KW)",
    "device_address": "Ierīces adrese",
    "grid_contract_start_date": "Ražošanas sākuma datums",
    "subsidies": "Valsts atbalsts",
    "battery": "Uzglabāšanas ierīce",
    "ppa": "Tiešās pārdošanas līgums",
    "no_subsidies": "Nav valsts atbalsta",
    "no_storage_device": "Nav uzglabāšanas ierīces",
    "no_ppa": "Nav Tiešās pārdošanas līguma",
    "no_battery": "Nav uzglabāšanas ierīces",
    "subsidy_provider": "Atbalsta sniedzējs: {provider}",
    "subsidy_plan": "Atbalsta plāns: {plan}",
    "unit_power": "Vienības jauda: {power}",
    "capacity": "Ietilpība: {capacity}",
    "ppa_start_date": "Sākuma datums: {date}",
    "ppa_mwh": "MWh: {mwh}",
    "ppa_client_name": "Klienta uzņēmuma nosaukums: {name}",
    "ppa_country": "Klienta valsts: {country}",
    "EIC": "EIC",
    "status": {
      "1": "Nereģistrēts",
      "2": "Dokuments jāparaksta",
      "3": "Ierīce reģistrēta"
    },
    "continue_registration": "Turpināt reģistrāciju",
    "sign_document": "Parakstīt dokumentu",
    "edit": "Rediģēt",
    "properties": {
      "device_name": "Invertera modelis",
      "solar_panel_model": "Saules paneļu modelis",
      "device_address": "Adrese",
      "device_power": "Jauda",
      "battery": "Uzglabāšanas ierīce",
      "subsidies": "Subsīdijas"
    },
    "unspecified": "Nenoteikts",
    "documents": "@:common.documents",
    "document_title": "Līgums par ierīces EIC: {eic}",
    "license_number": "Licences numurs"
  },
  "invoice": {
    "status": {
      "paid": "Apmaksāts",
      "canceled": "Atcelts",
      "requested": "Pieprasīts",
      "drafting": "Izstrādē"
    },
    "regenerate_confirmation": "Vai tiešām vēlaties ģenerēt rēķinu no jauna?",
    "regenerate": "Ģenerēt no jauna",
    "cancel_fee_only": "Atcelt",
    "cancel_fee_only_confirmation": "Vai tiešām vēlaties atcelt šo tikai-maksas rēķinu? Rēķina pozīcijas atgriezīsies gaidīšanas statusā un gan maksas, gan norēķinu rēķini tiks dzēsti.",
    "cancel_mixed_types_disabled": "Vienā partijā nevar atcelt izdevumu un tikai-maksas rēķinus kopā — izvēlieties tikai vienu tipu vienlaikus.",
    "send_to_merit": "Sūtīt uz Merit",
    "send_to_merit_confirmation": "Vai tiešām vēlaties nosūtīt šo rēķinu uz Merit?",
    "already_in_merit": "Rēķins jau ir reģistrēts Merit.",
    "error_downloading": "Kļūda, lejupielādējot rēķinu",
    "number": "Rēķina numurs",
    "status_label": "Statuss",
    "requested_date": "Pieprasīts datums",
    "amount": "Summa"
  },
  "invoiceHistory": {
    "title": "Rēķinu vēsture",
    "noInvoices": "Nākotnē šeit atradīsiet visus savus rēķinus!",
    "notificationInfo": "Paziņosim jums pa e-pastu, kad notiks pārdošanas darījumi.",
    "export_xlsx": "Eksportēt uz Excel"
  },
  "setPriceTerms": {
    "modifyStrategyTitle": "Mainīt pārdošanas stratēģiju",
    "selectStrategyLabel": "Izvēlēties pārdošanas stratēģiju",
    "automaticHighBid": "Automātiska pārdošana par augstāko piedāvājumu",
    "fresh_prod_above_min_price": "Iestatīt laika ierobežotu minimālo cenu",
    "minimumPriceDuration": "Minimālā cena pirmajiem {duration} mēnešiem",
    "minimumPriceLabel": "Minimālā cena",
    "enterPrice": "Ievadiet cenu",
    "saveChanges": "Saglabāt izmaiņas",
    "readMore": "Lasīt vairāk",
    "duration": {
      "minimum_price_window": "Minimālās cenas logs",
      "default_hint": "Noklusējuma vērtība ir 6 mēneši no ražošanas datuma",
      "limit_active_for": "Ierobežojums aktīvs {duration} mēnešus no izdošanas"
    },
    "warning": {
      "depreciation": "Brīdinājums: Sertifikāti, kas vecāki par 6 mēnešiem, mēdz ātri zaudēt vērtību, tuvojoties 12 mēnešu nodošanas termiņam.",
      "noSaleAt12": "Kritisks brīdinājums: Izvēloties 10-12 mēnešus, jūsu izcelsmes apliecinājumi var zaudēt vērtību līdz nullei, jo sertifikātus nevar pārsūtīt pēc 12 mēnešiem no izdošanas. Jau pie 10 mēnešu atzīmes paliek maz laika, padarot šos sertifikātus grūti pārdodamus."
    },
    "phases": {
      "title": "Kā šī stratēģija darbojas",
      "phase_1_badge": "1. fāze",
      "phase_1_title": "Pirmie {duration} mēneši no ražošanas",
      "phase_1_description": "Sertifikāti tiek turēti, līdz tirgus cena atbilst vai pārsniedz jūsu minimālo cenu €{price}/MWh. Ja cena ir zemāka par jūsu minimumu, sertifikāti netiek pārdoti.",
      "phase_2_badge": "2. fāze",
      "phase_2_title": "Pēc {duration} mēnešiem no ražošanas",
      "phase_2_description": "Visi nepārdotie sertifikāti tiek automātiski pārdoti par augstāko pieejamo tirgus cenu. Tas nodrošina, ka jūsu sertifikāti vienmēr tiek pārdoti pirms to derīguma termiņa beigām.",
      "readonly_summary": "Minimālā cena pirmos {duration} mēnešus, pēc tam automātiska pārdošana par tirgus cenu"
    },
    "howMinimumPriceWorks": "Kā darbojas Solderas minimālā cena",
    "contentParagraph1": "Automātiskā pārdošana par tirgus cenu nodrošina drošu veidu, kā pārdot izcelsmes sertifikātus, izkliedējot risku un nodrošinot, ka tie tiek pārdoti, kad to svaigums ir visvairāk vērtēts.",
    "content_paragraph_2": "Mēs saprotam, ka daudzi mūsu dalībnieki vēlas plānot sava izcelsmes sertifikātu pārdošanu. Tomēr vienmēr pastāv risks, ka sertifikātu cena nesasniedz vēlamo minimumu. Tāpēc pārdošana par tirgus cenu ir labāka iespēja nekā ļaut sertifikātiem izbeigties un tādējādi palikt nepārdotiem.",
    "content_paragraph_3": "Tāpēc mēs piedāvājam iespēju iestatīt minimālās cenas stratēģiju. Pirmajiem {duration} mēnešiem pēc jūsu sertifikātu izdošanas, mēs tos pārdosim tikai tad, ja tirgus cena atbilst vai pārsniedz jūsu minimālo cenu. Pēc šī {duration} mēnešu perioda beigām, mēs automātiski pārdosim visus atlikušos sertifikātus par pašreizējo tirgus cenu, lai novērstu to vērtības zaudēšanu. Šī stratēģija dod jums iespēju gūt labumu no cenu pieauguma, vienlaikus nodrošinot, ka jūsu sertifikāti vienmēr tiek pārdoti pirms to termiņa beigām.",
    "howMarketPriceWorks": "Kā darbojas Solderas tirgus cena",
    "marketPriceContentParagraph1": "Soldera agregē izcelsmes sertifikātus no daudziem dalībniekiem lielākos pārdošanas darījumos, apvienojot mūsu kolektīvo apjomu, lai sasniegtu stiprāku tirgus pozīciju un labākas cenas. Mēs veicam regulārus pārdošanas darījumus, izmantojot viedas stratēģijas un laiku, kas palielina darījumu biežumu. Šī procesa veicināšanai mēs pārnesam jūsu izcelsmes sertifikātus uz mūsu reģistra kontu, kur mūsu programmatūra visu pārvalda automātiski - jums nekad nav jāsarunā ar pircējiem vai jāpārvalda pārskaitījumi pašiem.",
    "marketPriceContentParagraph2": "Pirms katra pārdošanas darījuma Soldera iegūst cenas piedāvājumus no mūsu plašā starptautisko pircēju tīkla, nodrošinot konkurētspējīgas cenas ar mūsu tirgus attiecību starpniecību. Mēs izvēlamies labāko piedāvāto cenu un pabeidzam pārdošanas darījumu visu dalībniku vārdā. Mūsu automatizētā sistēma pārvalda visu sarežģītību, vienlaikus saglabājot cenu noteikšanas procesa caurspīdīgumu.",
    "marketPriceContentParagraph3": "5 dienu laikā pēc maksājuma saņemšanas no pircēja mēs paziņosim jums pa e-pastu par darījuma detaļām, ieskaitot jūsu daļu no ieņēmumiem pēc mūsu maksas un darījuma izmaksu (parasti reģistra eksporta maksas) atskaitīšanas. Pēc tam jūs varēsiet ar vienu klikšķi caur Soldera platformu pieprasīt izmaksu - ja nevēlaties tūlīt izrakstīt rēķinu, varat to darīt vēlāk jebkurā laikā. Soldera pārskaita maksājumu uz jūsu kontu 7 dienu laikā pēc jūsu rēķina saņemšanas."
  },
  "requestInvoice": {
    "indicative_payout_explainer": "Pēc ECB kursa {rate} ({date}). Orientējoši: izmaksa tiek konvertēta pēc tās datuma kursa.",
    "submit_invoice": "Iesniegt rēķinu",
    "money_pending": "Gaidāmā nauda",
    "sales_revenue": "Pārdošanas ieņēmumi",
    "sales_vat": "Pārdošanas PVN",
    "state_income_tax": "Valsts ienākuma nodoklis",
    "service_fees_vat": "Pakalpojumu maksas (ar PVN)",
    "detailed_overview": "Detalizēts pārskats",
    "view_details": "Skatīt sīkāk",
    "invoice_items": "Rēķina vienības",
    "item": "Vienība",
    "quantity": "Daudzums",
    "unit_price": "Vienības cena",
    "total_excl_vat": "Kopā (bez PVN)",
    "vat": "PVN",
    "offset_service_fees": "Pakalpojumu maksas kompensācija",
    "invoice_details": "Rēķina informācija",
    "invoice_number": "Rēķina numurs",
    "invoice_number_placeholder": "Rēķina numurs",
    "vat_number": "PVN numurs",
    "vat_number_placeholder": "LV12345678901",
    "bank_account_iban": "Bankas konts (IBAN)",
    "bank_account_placeholder": "LV1234567890123456789",
    "contact_block_on_invoice": "Kontaktinformācija uz rēķina",
    "contact_block_placeholder": "Uzņēmuma nosaukums, \nAdrese, \nReģistrācijas numurs",
    "reference": "Atsauce (neobligāti)",
    "reference_placeholder": "Atsauces numurs",
    "monthly_rollup_label": "Izlaist pārdošanas paziņojumus — saņemt 1. datumā vienu ikmēneša e-pastu ar komisijas maksas rēķinu",
    "month_split_label": "Datēt iepriekšējā mēneša pārdošanas darījumus (datums: {date})",
    "month_split_tooltip": "Iepriekšējā mēneša pārdošanas darījumi ({month}) tiek iekļauti atsevišķā izmaksas rēķinā, kura datums ir {date}, tāpat kā komisijas maksas rēķinam. Pašreizējā mēneša pārdošanas darījumi ({current_month}) tiek iekļauti otrā rēķinā ar šodienas datumu.",
    "month_split_tooltip_pending": "Iepriekšējā mēneša pārdošanas darījumi ({month}) tiek iekļauti izmaksas rēķinā, kura datums ir {date}, tāpat kā komisijas maksas rēķinam. Pašreizējā mēneša pārdošanas darījumi ({current_month}) paliek gaidīšanā nākamajai izmaksai.",
    "month_split_previous_heading": "Pārdošanas darījumi: {month} — rēķina datums: {date}",
    "month_split_current_heading": "Pārdošanas darījumi: {current_month} — rēķina datums: šodien",
    "month_split_pending_heading": "Pārdošanas darījumi: {current_month} — paliek gaidīšanā nākamajai izmaksai",
    "month_split_current_number": "Rēķina numurs — pārdošanas darījumi: {current_month}",
    "month_split_number_must_differ": "Jāatšķiras no iepriekš norādītā rēķina numura"
  },
  "certificateHistory": {
    "overview": "Sertifikātu pārskats",
    "productionPeriod": "@:common.production_period",
    "certificateCount": "Sertifikātu skaits",
    "expired": "Derīguma termiņš beidzies",
    "sold": "Pārdots",
    "awaitingSale": "Gaida pārdošanu"
  },
  "chooseCompany": {
    "select_company": "Izvēlieties uzņēmumu, kuram piešķirt pilnvaru",
    "choose_company": "Izvēlieties uzņēmumu",
    "create_new_company": "Izveidot jaunu uzņēmumu"
  },
  "invoiceItem": {
    "quantity": "Daudzums",
    "unit_price": "Vienības cena",
    "total_excl_vat": "Kopā (bez PVN)",
    "vat": "PVN"
  },
  "tradingCenter": {
    "tradingStrategy": "Tirdzniecības stratēģija",
    "title": "Ražošanas stratēģija",
    "tabs": {
      "overview": "Pārskats",
      "strategyCustomisation": "Tirdzniecības stratēģijas kohandināšana",
      "issuance_reporting": {
        "title": "Izsniegšanas atskaite"
      }
    },
    "customization": {
      "forwardSales": "Nākotnes pārdošana",
      "spotSales": "Spot pārdošana",
      "ppaReserve": "PPA rezerve",
      "holdPortfolio": "Pašpārvaldība"
    },
    "overview": {
      "projectedProduction": {
        "title": "Prognozētā produkcija",
        "noData": "Jūsņu prognozētā gada ražošana būs šeit redzama, pēc tam, kad mēs saņemsim jūsu iekārtu informāciju no reģistra."
      },
      "spot": {
        "title": "Spot pārdošana",
        "visualization": {
          "minimumPrice": {
            "title": "Mēģinājums pārdot virs {cenas}€/MWh",
            "description": "Ražošana iekļauta piedāvājumos, ja paredzamā cena ir lietotāja noteiktā minimālā cena",
            "firstMonths": "Pirmie {duration} mēneši"
          },
          "highestBid": {
            "title": "Pārdot pēc augstākās cenas",
            "description": "Produkcija automātiski tiek pārdota augstākās cenas solītājam.",
            "lastMonths": "Pēdējie {duration} mēneši"
          }
        }
      }
    }
  },
  "market_insights": {
    "title": "Tirgus ieskati",
    "description": "Tirgus informācija un analītika atjaunojamās enerģijas nozarē",
    "sections": {
      "reports": "Tirgus ziņojumi",
      "charts": "Tirgus dati un grafiki"
    },
    "forward_outlook": {
      "title": "Soldera Forward Outlook",
      "description": "Ikmēneša analīze par GO tirgus tendencēm un svarīgākajām ziņām, kas ietekmē tirgu"
    },
    "consulting_services": {
      "title": "2. tvēruma atbilstības atbalsts",
      "description": "Soldera pēc pieprasījuma sniedz atbilstības pakalpojumus. Lūdzu, sazinieties ar mums, lai saņemtu vairāk informācijas.",
      "button_text": "Sazināties ar mums"
    },
    "norway_reservoir": {
      "title": "Norvēģijas ūdenskrātuvju līmeņi",
      "description": "Iknedēļas ūdenskrātuvju līmeņi ar vēsturisko salīdzinājumu un prognozēm",
      "zone_label": "Tirdzniecības zona",
      "y_axis_label": "% no kapacitātes",
      "loading": "Ielādē ūdenskrātuves datus...",
      "error": "Neizdevās ielādēt ūdenskrātuves datus",
      "no_data": "Nav pieejami dati izvēlētajai zonai",
      "locked_zones_hint": "Atbloķējiet visas rezervuāru zonas — sazinieties ar mums, lai iespējotu detalizētus reģionālos datus",
      "info_text": "Norvēģija ir galvenā izcelsmes apliecinājumu (IA) eksportētāja uz citām AIB dalībvalstīm, pateicoties ievērojamai hidroenerģijas ražošanai. Iekšējā politika neveicina IA izmantošanu vietējā tirgū un rada būtisku eksporta pārpalikumu. Tādēļ Norvēģijas hidroenerģijas jaudas vai iekšējā patēriņa izmaiņas nesamērīgi ietekmē plašāku Eiropas IA tirgu.\n\nDati tiek atjaunināti reizi nedēļā. Faktiskie ūdenskrātuvju līmeņi parasti tiek apstiprināti ievērojami vēlāk, tāpēc sniedzam savas aplēses, lai labāk prognozētu tirgus dinamiku.",
      "zones": {
        "norway_total": "Norvēģija kopā"
      },
      "legend": {
        "historical_max": "Vēsturiskais maks.",
        "historical_median": "Vēsturiskā mediāna",
        "historical_min": "Vēsturiskais min.",
        "last_year": "Pagājušais gads",
        "this_year": "Šis gads",
        "predicted": "Prognozēts"
      }
    },
    "cumulative_re": {
      "title": "Kumulatīvā atjaunojamās enerģijas ražošana",
      "description": "Gadu salīdzinājums atjaunojamās enerģijas ražošanā",
      "country_label": "Valsts",
      "eu_aggregate": "Eiropas Savienība (Apkopots)",
      "y_axis_label": "GWh",
      "loading": "Ielādē grafika datus...",
      "error": "Neizdevās ielādēt grafika datus",
      "info_text": "Gada atjaunojamās enerģijas ražošana ir spēcīgs cenu virziena rādītājs — ja ražošana būtiski pieaug, IA cenas parasti krītas, jo palielinās IA piedāvājums.\n\nDati tiek atjaunināti reizi nedēļā un neietver valstis, kas nav AIB dalībvalstis vai nav kontinentālajā Eiropā."
    }
  },
  "charts": {
    "xAxisLabel": "X-Asis",
    "stackByLabel": "Stilizēt pēc",
    "fields": {
      "portfolio_type": "Portfelja tips",
      "production_month": "Ražošanas mēnesis",
      "status": "Status",
      "technology_type": "Tehnoloģija",
      "company_name": "Uzņēmuma nosaukums",
      "portfolio_name": "Portfeļa Nosaukums",
      "production_device_name": "Ražošanas Ierīce",
      "production_support": "Ražošanas Atbalsts",
      "ecolabel_tags": "Ecolabel",
      "transfer_deadline": "Pārsūtīšanas Termiņš",
      "count": "Skaits",
      "certificate_id": "Sertifikāta ID",
      "registration_authority": "Reģistrācijas iestāde",
      "registry_region": "Pašreizējais reģistrs",
      "issuing_region": "Izsniegšanas reģistrs",
      "cod_age": "COD vecums",
      "limit_price": "Minimālā cena",
      "sale_price": "Pārdošanas cena",
      "account_emails": "Konti",
      "registry_id": "Reģistra ID",
      "bundle_start": "Komplekta sākums",
      "bundle_end": "Komplekta beigas"
    },
    "values": {
      "production_support": {
        "true": "Ar atbalstu",
        "false": "Bez atbalsta",
        "null": "Nezināms"
      },
      "portfolio_type": {
        "FORWARD": "Forward pardavumi",
        "SPOT_MARKET_PRICE": "Spot pardavumi",
        "SPOT_MIN_PRICE": "Spot pardavumi ar minimālām cenām",
        "HOLD": "Pašpārvaldīts",
        "UNALLOCATED": "Gaida darbību",
        "VIRTUAL": "Mitinātie konti",
        "PPA": "PPA rezerve",
        "OWN_USE": "Pašpatēriņam"
      },
      "certificate_status": {
        "ONGOING_SALE": "Notiek pārdošana",
        "SOLD": "Pārdots",
        "EXPIRED": "Beidzies derīguma termiņš",
        "NON_TRANSFERRABLE": "Nepārvedams",
        "RESERVED": "Rezervēts",
        "WAITING_FOR_SALE": "Gaida pārdošanu",
        "AVAILABLE": "Pieejams",
        "PENDING": "@:common.pending",
        "CANCELLED": "Atcelts",
        "TRANSFERRED": "Pārvietots",
        "REVOKED": "Reģistra atsaukts",
        "OWN_USE": "Pašpatēriņam"
      }
    },
    "noDataMessage": "Nekas nav redzams. Lūdzu, pielāgojiet filtra izvēli.",
    "panel": {
      "title": "Diagramma",
      "region_label": "Tabulā esošo sertifikātu diagramma",
      "mwh": "{mwh} MWh",
      "summary_rows": "nevienā rindā · pieejami {available} MWh | {count} rindā · pieejami {available} MWh | {count} rindās · pieejami {available} MWh",
      "hide": "Paslēpt diagrammu",
      "show": "Rādīt diagrammu",
      "break_down_by": "Sadalīt pēc",
      "segment_label": "Filtrēt tabulu pēc {field} {value}, {mwh} MWh",
      "segment_inline": "{label} · {mwh} MWh",
      "segment_hint": "Noklikšķiniet uz segmenta, lai filtrētu tabulu pēc tā"
    }
  },
  "inventory": {
    "actions": {
      "title": "Krājumu Pārvaldība",
      "send": {
        "success": "Sūtīšanas darbība veiksmīgi pabeigta",
        "prompt": "Kur jūs vēlētos nosūtīt šos izcelsmes apliecinājumus? Lūdzu, norādiet valsti, apjomus un saņēmēja reģistra numuru.",
        "simulated_response": "Sapratu! Gatavojos nosūtīt jūsu izcelsmes apliecinājumus."
      },
      "receive": {
        "success": "Saņemšanas darbība veiksmīgi pabeigta",
        "prompt": "No kā jūs gaidāt saņemt izcelsmes apliecinājumus? Lūdzu, norādiet valsti, apjomus un sūtītāja reģistra numuru.",
        "simulated_response": "Sapratu! Mēs jūs informēsim par ierašanos."
      },
      "buy": {
        "success": "Pirkšanas darbība veiksmīgi pabeigta",
        "prompt": "Kādus izcelsmes apliecinājumus jūs šodien vēlaties iegādāties? Lūdzu, norādiet valsti, apjomus un saņēmēja reģistra numuru.",
        "simulated_response": "Lieliski! Meklēju pieejamos izcelsmes apliecinājumus pirkšanai. Šeit ir daži piedāvājumi: 500 MWh no Igaunijas, Vēja enerģija, Ražošanas datums: 2024. gada janvāris, Cena: €2.50/MWh; 1,000 MWh no Latvijas, Saules enerģija, Ražošanas datums: 2024. gada februāris, Cena: €3.00/MWh; 750 MWh no Lietuvas, Hidroenerģija, Ražošanas datums: 2024. gada marts, Cena: €2.75/MWh"
      },
      "sell": {
        "success": "Pārdošanas darbība veiksmīgi pabeigta",
        "prompt": "Kurus izcelsmes apliecinājumus jūs vēlētos piedāvāt pārdošanai? Lūdzu, norādiet valsti, apjomus.",
        "simulated_response": "Perfekti! Lieku jūsu izcelsmes apliecinājumus pārdošanā. Mēs jūs informēsim, kad tiks atrasts pircējs."
      }
    }
  },
  "errors": {
    "genericNetworkError": "Tīkla kļūda. Lūdzu mēģiniet vēlreiz.",
    "missingCompanyId": "Kļūda: Trūkst uzņēmuma konteksta.",
    "unsupportedFileType": "Neatbalstīts faila tips. Lūdzu, augšupielādējiet derīgu failu.",
    "fileTooLarge": "Fails ir pārāk liels. Maksimālais izmērs ir 25MB."
  },
  "go_cancel": {
    "beneficiary_suggestions": {
      "placeholder": "Atlasiet vai ievadiet saņēmēju"
    },
    "statements_title": "Atcelšanas deklarācijas",
    "add_statement_button": "Pievienot atcelšanas deklarāciju",
    "no_statements_yet": "Atcelšanas deklarācijas vēl nav pievienotas. Noklikšķiniet 'Pievienot atcelšanas deklarāciju', lai sāktu.",
    "more_statements": "vēl deklarāciju",
    "statement_number": "Deklarācija #{number}",
    "remove_statement_button": "Noņemt",
    "remove_statement_row_aria": "Noņemt atcelšanas deklarācijas rindu {index}",
    "statement_form_placeholder": "Pilna atcelšanas deklarācijas forma būs šeit.",
    "confirm_order_button": "Pārskatīt atcelšanas pasūtījumu",
    "portfolio_items_title": "Izvēlieties portfeļa vienumus atcelšanai",
    "portfolio_table_placeholder": "PortfolioItemsTable tiks parādīta šeit, lai izvēlētos sertifikātus.",
    "upload_description": "Augšupielādējiet dokumentu, lai automātiski izvilktu atcelšanas deklarācijas un saņēmēja informāciju",
    "analysis_success_with_statements": "No dokumenta izvilktas {count} atcelšanas deklarācijas.",
    "analysis_success_no_statements": "Dokumentā netika atrastas atcelšanas deklarācijas.",
    "analysis_complete_title": "Dokumenta analīze pabeigta",
    "analysis_shared_fields_inconsistent_warning": "Koplietotie lauki starp deklarācijām nesakrīt. Lūdzu, manuāli apstipriniet saņēmēja tipu, periodu un atcelšanas mērķa veidni.",
    "shared_defaults_title": "Koplietotie iestatījumi visām deklarācijām",
    "shared_defaults_incomplete": "Pabeidziet koplietotos iestatījumus pirms atcelšanas pasūtījuma pārskatīšanas.",
    "table_validation_hint": "Dažas rindas ir nepilnīgas vai nederīgas. Izlabojiet iezīmētos laukus, lai turpinātu.",
    "max_statements_reached": "Sasniegts maksimālais {max} atcelšanas deklarāciju skaits. Ja nepieciešams vairāk, sadaliet vairākos pasūtījumos.",
    "analysis_truncated_warning": "Dokuments saturēja {total} deklarācijas, bet tika ielādētas tikai pirmās {max}. Iesniedziet tās kā atsevišķu pasūtījumu, pēc tam augšupielādējiet atlikušās.",
    "form": {
      "prior_year_cutoff_specific": "{year}. gada atcelšanas vairs nav atļautas — termiņš bija {cutoffDate}",
      "beneficiary_details_title": "Saņēmēja informācija",
      "beneficiary_name": {
        "label": "Saņēmēja nosaukums",
        "placeholder": "Ievadiet uzņēmuma vai personas vārdu"
      },
      "beneficiary_type": {
        "label": "Saņēmēja tips",
        "CONSUMER": "Patērētājs",
        "ELECTRICITY_SELLER": "Elektroenerģijas pārdevējs",
        "CONVERSION_PLANT_OPERATOR": "Konversijas iekārtas operators"
      },
      "registry_code": {
        "label": "Reģistrācijas kods (uzņēmuma vai personas)",
        "short_label": "Reģistrācijas kods",
        "placeholder": "Ievadiet uzņēmuma reģistrācijas kodu vai personas kodu"
      },
      "address": {
        "label": "Adrese",
        "placeholder": "Ievadiet pilno adresi",
        "required_help": "Adrese ir obligāta šai valstij"
      },
      "registry_country_region": {
        "label": "Reģistra valsts/reģions",
        "placeholder": "Izvēlieties reģistra valsti vai reģionu",
        "mismatch_warning": "Izvēlētais reģistrs atšķiras no sertifikāta atrašanās vietas"
      },
      "cancellation_details_title": "Atcelšanas informācija",
      "mwh_cancelled": {
        "label": "Atceļamais MWh",
        "short_label": "Atcelti MWh",
        "placeholder": "0.000"
      },
      "period_start": {
        "label": "Patēriņa perioda sākums"
      },
      "period_end": {
        "label": "Patēriņa perioda beigas",
        "invalid_date_range": "Beigu datumam jābūt pēc sākuma datuma",
        "cutoff_help": "{year}. gada patēriņa atcelšanas jāiesniedz pirms {nextYear}. gada 31. marta"
      },
      "cancellation_purpose": {
        "label": "Atcelšanas mērķis",
        "DISCLOSURE": "Informācijas atklāšana",
        "GRID_LOSSES": "Tīkla zudumi",
        "SELF_CONSUMPTION": "Pašpatēriņš",
        "SUPPORT_SCHEME": "Atbalsta shēma",
        "OTHER": "Cits"
      },
      "cancellation_purpose_text": {
        "label": "Atcelšanas mērķis",
        "placeholder": "Ievadiet atcelšanas mērķi",
        "help": "Īsi aprakstiet, kāpēc šie sertifikāti tiek atcelti"
      },
      "global_operation_notes": {
        "label": "Kopējās piezīmes atcelšanas pasūtījumam (neobligāti)",
        "placeholder": "Ievadiet jebkādas kopējās piezīmes visam atcelšanas pasūtījumam..."
      },
      "keep_private": {
        "label": "Saglabāt atcelšanas deklarāciju privātu",
        "hint": "Reģistrs neizveidos publiski pieejamu saiti uz šīs atcelšanas deklarācijas PDF failu.",
        "ppa_hint": "Attiecas tikai uz Grexel platformas reģistriem (LV, LT, DK, HR, HU, BE-FED, SE, FR); citur tiek ignorēts."
      },
      "tge_legal_form": {
        "label": "Juridiskā forma",
        "placeholder": "Izvēlieties saņēmēja juridisko formu",
        "detected_hint": "Noteikta pēc saņēmēja nosaukuma",
        "not_detected_hint": "Nevar noteikt pēc saņēmēja nosaukuma. TGE to pieprasa.",
        "options": {
          "limited_company": "SIA vai akciju sabiedrība (sp. z o.o., S.A.)",
          "partnership": "Pilnsabiedrība vai komandītsabiedrība (sp. j., sp. p., sp. k., S.K.A.)",
          "private_partnership": "Civiltiesiskā sabiedrība (s.c.)",
          "sole_proprietorship": "Individuālais komersants",
          "other": "Cita"
        }
      },
      "tge_vat_number": {
        "label": "PVN numurs (NIP)",
        "short_label": "PVN",
        "placeholder": "PL1234567890",
        "hint": "Nav obligāts"
      }
    },
    "no_portfolio_items_available": "Pašlaik nav pieejami portfeļa vienumi atcelšanai.",
    "tooltip_beneficiary_name": "Juridiskā persona vai fiziska persona, kas tiks norādīta kā atcelšanas paziņojuma saņēmējs.",
    "tooltip_registry_country_region": "Reģistrs, kurā tiks veikta atcelšana.",
    "tooltip_registry_code": "Uzņēmuma reģistrācijas numurs vai personas kods — nevis PVN numurs. Parādās atcelšanas paziņojumā.",
    "tooltip_address": "Saņēmēja reģistrētā adrese vai objekta adrese. Dažiem reģistriem nepieciešama.",
    "tooltip_mwh_cancelled": "Atceļamo sertifikātu daudzums megavatstundās (MWh). 1 MWh = 1 sertifikāts.",
    "auto_select_certificates_checkbox": "Automātiski izvēlēties sertifikātus",
    "order_submitted_successfully": "Atcelšanas pasūtījums veiksmīgi iesniegts!",
    "order_submission_failed": "Neizdevās iesniegt atcelšanas pasūtījumu. Lūdzu, mēģiniet vēlreiz.",
    "buy_missing_request_sent": "Pieprasījums iegādāties trūkstošos izcelsmes sertifikātus ir nosūtīts. Mēs ar jums sazināsimies drīzumā.",
    "buy_missing_request_failed": "Neizdevās nosūtīt pieprasījumu trūkstošajiem izcelsmes sertifikātiem. Lūdzu, mēģiniet vēlreiz vai sazinieties ar atbalstu.",
    "insufficient_inventory_warning": "Brīdinājums: Nepietiek izcelsmes sertifikātu krājumos, lai segtu kopējo deklarācijās norādīto MWh. Jums ir pieejami {availableMwh} MWh, bet nepieciešami {neededMwh} MWh.",
    "buy_missing_gos_button": "Pieprasīt trūkstošos izcelsmes sertifikātus",
    "autoselect_failed": "Sertifikātu automātiskā izvēle neizdevās. Lūdzu, izvēlieties manuāli vai mēģiniet vēlreiz.",
    "review_modal_statement_title": "Atcelšana saņēmējam: {beneficiaryName} reģistrā",
    "region_mismatch_warning": {
      "title": "Reģistra neatbilstība",
      "message": "Daži izvēlētie sertifikāti pašlaik atrodas citā reģistrā nekā atcelšanai izvēlētais mērķa reģistrs. Pirms atcelšanas apstrādes mēs pārvietosim šos sertifikātus uz izvēlēto reģistru."
    },
    "any_aib_option": "Any AIB",
    "any_aib_address_hint": "Pievienojiet {'{'}address{'}'} atcelšanas mērķim kā vietturi, izmantojot Any AIB. Saņēmēja atrašanās vieta paziņojumā tiks norādīta kā \"Europe\".",
    "address_placeholder_missing_warning": "Atcelšanas mērķis izmanto vietturi {'{'}address{'}'}, taču vismaz vienam saņēmējam nav adreses. Šajās rindās teksts {'{'}address{'}'} tiks atstāts nemainīts.",
    "beneficiary_type_conflict_switch": "Visas šīs atcelšanas deklarācijas tiek iesniegtas ar saņēmēja tipu {sharedType}, taču {names} iepriekš izmantoja tipu {rememberedType}. Nomainiet kopīgo saņēmēja tipu uz {rememberedType} vai turpiniet, ja iepriekšējais tips ir novecojis.",
    "beneficiary_type_conflict_mixed": "Visas šīs atcelšanas deklarācijas tiek iesniegtas ar saņēmēja tipu {sharedType}, taču šie saņēmēji iepriekš izmantoja citu tipu: {details}. Turpiniet, ja iepriekšējie tipi ir novecojuši.",
    "accelerator_title": "Sāciet ar dokumentu",
    "summary_order_title": "Atcelšanas pasūtījums",
    "summary_mwh_to_cancel": "MWh atcelšanai",
    "summary_statements": "Deklarācijas",
    "summary_consumption_period": "Patēriņa periods",
    "summary_certificates_selected": "Izvēlētie sertifikāti",
    "summary_mwh_value": "{mwh} MWh",
    "summary_ready": "Gatavs apstiprināšanai",
    "summary_status_incomplete": "Aizpildiet atcelšanas datus",
    "summary_status_select": "Izvēlieties atceļamos sertifikātus",
    "summary_status_match": "Izvēlieties sertifikātus kopā {mwh} MWh",
    "summary_status_insufficient": "Nepietiek atbilstošu krājumu",
    "no_data_short": "—",
    "summary_build_title": "Izveidojiet savu pasūtījumu",
    "summary_step_beneficiary": "Pievienojiet saņēmēju un patēriņu",
    "summary_step_certificates": "Izvēlieties atceļamos sertifikātus",
    "summary_step_review": "Pārskatiet un apstipriniet pasūtījumu",
    "private_pill": "Privāta deklarācija",
    "statement_options_button_aria": "Deklarācijas {index} iestatījumi",
    "statement_options_button_private_aria": "Deklarācijas {index} iestatījumi — tiek saglabāta privāta",
    "statement_private_tooltip": "Atcelšanas deklarācija tiek saglabāta privāta",
    "carried_selection_summary": "No jūsu pārskata atlases netika pārņemta neviena rinda. | No jūsu pārskata atlases pārņemta {count} rinda ({mwh} MWh). | No jūsu pārskata atlases pārņemtas {count} rindas ({mwh} MWh).",
    "carried_selection_summary_partial": "No jūsu pārskata atlases netika pārņemta neviena rinda. | No jūsu pārskata atlases pārņemta {count} rinda ({mwh} MWh, {partial}). | No jūsu pārskata atlases pārņemtas {count} rindas ({mwh} MWh, {partial}).",
    "carried_selection_partial": "neviena nav daļēja | {count} daļēja | {count} daļējas",
    "carried_selection_paused": "Automātiskā atlase ir apturēta, lai tā tās neaizstātu.",
    "carried_selection_use_amount": "Izmantot {mwh} MWh kā apjomu",
    "carried_selection_clear": "Notīrīt un izvēlēties automātiski",
    "table_hint": "Uzskaitīti tikai atcelšanai pieejamie sertifikāti. Atzīmētās rindas tiek atceltas pilnībā; noklikšķiniet uz apjoma, lai atceltu tikai daļu no rindas.",
    "filter_shortfall": "Jūsu filtriem atbilst tikai {available} no {needed} MWh. Noņemiet kādu filtru, lai redzētu vairāk sertifikātu.",
    "filter_shortfall_unavailable": "Jūsu filtriem neatbilst neviens sertifikāts, nepieciešami {needed} MWh. Noņemiet sarkanā krāsā atzīmēto filtru, lai redzētu savus sertifikātus.",
    "summary_status_filter_shortfall": "Jūsu filtriem neatbilst pietiekami daudz sertifikātu"
  },
  "go_send": {
    "insufficient_inventory_warning": "Brīdinājums: Krājumos nav pietiekami daudz GO sertifikātu, lai segtu sūtīšanas pieprasījumā norādīto MWh daudzumu. Jums ir pieejami {availableMwh} MWh, bet nepieciešami {neededMwh} MWh.",
    "recipient_hosted_badge": "MITINĀTS",
    "recipient_hosted_helper": "Piegādā uz šī uzņēmuma mitināto kontu Soldera",
    "recipient_hosted_region_note": "Reģionu nosaka katram sertifikātam sūtīšanas laikā",
    "recipient_search_placeholder": "Meklēt pēc uzņēmuma nosaukuma, reģistrācijas koda vai EECS…",
    "recipient_no_results": "Nav atbilstošu uzņēmumu",
    "hosted_delivery_info": "Piegādes informāciju pārvalda Soldera, un tā tiks automātiski noteikta katram sertifikātam sūtīšanas laikā.",
    "mixed_registry_selection_error": "Dažādu reģistru sertifikātus nevar nosūtīt vienā pasūtījumā. Lūdzu, nosūtiet tos kā atsevišķus pasūtījumus.",
    "unit_price_pln_label": "Vienības cena (PLN/MWh)",
    "unit_price_pln_help": "Līguma vienības cena PLN/MWh. Polijas reģistrs (TGE) to pieprasa un ieraksta pašā pārvedumā.",
    "account_invalid_unknown_registry": "Ievadiet EECS konta numuru (piem., 23X1234567) vai Ofgem konta numuru, lai varētu noteikt reģistra valsti"
  },
  "portfolio_instructions": {
    "description": "Apraksts",
    "ppa_name": "PPA nosaukums",
    "configuration": "Konfigurācija",
    "allocation_configuration": "Sadalījuma konfigurācija",
    "delivery_configuration": "Piegādes konfigurācija",
    "allocation_mode": "Piešķiršanas režīms",
    "allocate_all": "Visa ražošana",
    "allocate_percentage": "Procentuāla daļa",
    "whole_production_info": "Visa izvēlēto iekārtu produkcija tiks piešķirta šim PPA.",
    "allocate_fixed_amount": "Piešķirt fiksētu summu",
    "allocate_fixed_amounts": "Fiksētas summas",
    "total_mwh_label": "Kopā MWh",
    "allocate_fixed_amounts_per_year": "Piešķirt fiksētas summas gadā",
    "granularity_yearly": "Gada",
    "granularity_quarterly": "Ceturkšņa",
    "granularity_monthly": "Mēneša",
    "granularity": "Precizitāte",
    "leap_year_badge": "Garais gads",
    "current_period_limit": "Piešķirt fiksētu summu ({amount} {unit}) periodā {periodLabel}",
    "apply_to_all_years": "Piemērot visiem gadiem",
    "apply_to_all_years_tooltip": "Kopēt šīs vērtības uz visiem citiem gadiem (daļējie ceturkšņi tiek izlaisti)",
    "reset_year": "Atiestatīt",
    "partial_quarter_badge": "Daļējs",
    "partial_period_badge": "Daļējs",
    "contract_range_required_for_granularity": "Iestatiet PPA sākuma un beigu datumus izpildes konfigurācijā zemāk, lai konfigurētu mēneša/ceturkšņa limitus.",
    "start_date_required_for_granularity": "Mēneša un ceturkšņa limitiem nepieciešams PPA sākuma datums.",
    "end_date_must_follow_start": "Līguma beigu datumam jābūt sākuma datumā vai pēc tā.",
    "invalid_limit_durations_for_granularity": "Limitu ilgumi neatbilst izvēlētajai precizitātei. Izveidojiet limitus vēlreiz vai konvertējiet tos izvēlētajai precizitātei.",
    "partial_period_hint_single": "Viens periods ir daļējs: {firstRange}.",
    "partial_period_hint_multiple": "{count} periodi ir daļēji: {firstRange} → {lastRange}.",
    "confirm_granularity_switch_title": "Mainīt piešķiršanas precizitāti?",
    "confirm_granularity_switch_body": "Jums ir vērtības, kas nav nulle. Mainot tās tiks pārdalītas atbilstoši jaunajai precizitātei. Turpināt?",
    "granularity_switch_title": "Pārdalīt esošās vērtības?",
    "granularity_switch_body": "Esat ievadījis vērtības {from} līmenī. Pārslēdzot uz {to}, tās tiks pārdalītas atbilstoši jaunajai precizitātei.",
    "granularity_switch_from": "No",
    "granularity_switch_to": "Uz",
    "granularity_buckets": "{count} lauciņi/gadā",
    "granularity_switch_note": "Gada kopsummas tiek saglabātas.",
    "granularity_switch_confirm": "Pārdalīt",
    "matrix_year_total": "Gada kopā: {total}",
    "year_issues_badge": "{count} problēmas",
    "matrix_grand_total": "Kopējais: {total} MWh ({count} ieraksti)",
    "percentage_to_allocate": "Piešķiramā procentuālā daļa",
    "select_devices": "Izvēlēties ierīces",
    "search_devices_placeholder": "Meklēt {count} pieejamas ierīces...",
    "search_more_devices_placeholder": "{selected} izvēlētas • Meklēt {available} pieejamas ierīces",
    "loading_devices": "Ielādē ierīces...",
    "all_devices_selected": "Visas ierīces izvēlētas",
    "devices_blocked_by_other_ppas": "Atlikušās iekārtas tiek izmantotas citos PPA portfeļos",
    "no_devices_available": "Nav pieejamas ierīces",
    "selected_devices": "Izvēlētās ierīces",
    "selected_devices_summary": "{count} izvēlētas",
    "add_devices": "Pievienot ierīces",
    "allocate_percentage_display": "Piešķirt {percent}%",
    "devices_count_display": "{count} ierīce(s) izvēlēta(s)",
    "from_all": "No visām ierīcēm",
    "no_instructions_set": "Nav iestatītas instrukcijas.",
    "editing_title": "Rediģē: {name}",
    "upload_ppa_document": "Augšupielādēt PPA dokumentu",
    "ppa_document_formats": "Atbalstīti PDF, DOC, DOCX faili",
    "ppa_document_upload_error": "Nederīgs PPA dokumenta formāts",
    "fixed_amounts_per_year": "Fiksētas summas gadā",
    "period_limits": "Perioda ierobežojumi",
    "add_period_limit": "Pievienot perioda ierobežojumu",
    "remove_period_limit": "Noņemt perioda ierobežojumu",
    "select_year": "Izvēlēties gadu",
    "mwh_placeholder": "Ievadiet MWh ierobežojumu",
    "fixed_amount_must_be_gt_zero": "Katrai fiksētajai summai jābūt lielākai par 0 MWh",
    "update_success": "Portfeļa instrukcijas veiksmīgi atjauninātas.",
    "update_success_title": "Veiksme",
    "remove_device": "Noņemt ierīci {deviceName}",
    "device_assigned_to_100_percent_ppa": "Ierīce '{deviceId}' ir piešķirta 100% PPA un tai jābūt ekskluzīvi piešķirtai",
    "device_used_in_fixed_limit_ppa": "Ierīce '{deviceId}' tiek izmantota PPA ar fiksētiem perioda ierobežojumiem un nevar tikt piešķirta nevienai citai PPA",
    "device_exceeds_100_percent": "Ierīce '{deviceId}' pārsniedz 100% visos PPA (kopā: {totalPercentage}%)",
    "device_cannot_mix_with_exclusive_mode": "Ierīci '{deviceId}' nevar izmantot {currentMode} režīmā, jo tā jau ir piešķirta citiem PPA",
    "fixed_amounts_mode": "fiksēto daudzumu režīms",
    "all_mode": "visas ražošanas režīms"
  },
  "hold_strategy": {
    "customize_strategy_title": "Pielāgot pašpārvaldīto sertifikātu stratēģiju",
    "about_hold_strategy": "Par pašpārvaldīto sertifikātu stratēģiju",
    "no_hold_instructions": "Nav konfigurēta pašpārvaldīto sertifikātu stratēģija",
    "create_hold_portfolio": "Izveidot pašpārvaldīto sertifikātu stratēģiju",
    "hold_portfolio": "Pašpārvaldītie sertifikāti",
    "percentage_to_hold": "Procents, ko nosūtīt pašpārvaldībā",
    "scope_all_label": "Globāla paturēšana (visas iekārtas)",
    "scope_all_description": "Attiecas uz visiem neizdalītajiem sertifikātiem.",
    "scope_specific_label": "Mērķēta paturēšana (konkrētas iekārtas)",
    "scope_specific_description": "Attiecas tikai uz izvēlētajām iekārtām. Pārējie nonāk spotā.",
    "targeted_allocation_badge": "{percentage}% no {deviceCount} iekārtām"
  },
  "ppa_strategy": {
    "customize_strategy_title": "Pielāgot PPA rezervi",
    "creating_new_ppa_instructions": "Veido jaunas PPA rezerves instrukcijas",
    "about_ppa_strategy": "Par PPA rezervi",
    "no_ppa_instructions": "Nav konfigurētas PPA rezerves instrukcijas",
    "ppa_agreement": "PPA Līgums",
    "projected_total": "Prognozētais kopējais apjoms",
    "delivered": "Piegādāts",
    "no_documents": "Nav pievienotu dokumentu",
    "fixed_yearly_allocation": "Fiksēta gada sadale",
    "percentage_allocation": "{percentage}% no ražošanas",
    "next_delivery": "Nākamā piegāde"
  },
  "go_buy": {
    "volume_to_buy": "Pērkamais apjoms",
    "procurement_fee": "Iepirkuma maksa",
    "purchase_summary": "Pirkuma kopsavilkums",
    "price_breakdown_title": "Cenu sadalījums",
    "price_breakdown_description": "Cenas seko tirgus trešo pušu indeksiem, lai nodrošinātu jums labāko cenu tirgū. Apjomi tiek iegūti no vairāk nekā 3000 elektrostacijām visā Eiropā. Agregēta automatizēta iepirkšana nodrošina labāko vērtību.",
    "premiums": "Atribūtu piemaksas",
    "upload_description": "Augšupielādējiet dokumentu, kas apraksta jūsu pirkšanas vajadzības",
    "ask_for_quote_button": "Pieprasīt cenas piedāvājumu",
    "send_purchase_request_button": "Nosūtīt pirkšanas pieprasījumu",
    "purchase_request_submitted": "Pirkuma pieprasījums nosūtīts",
    "purchase_request_submitted_detail": "{volume} MWh pieprasījums veiksmīgi nosūtīts.",
    "agent_quote_prompt": "Iesniedziet pirkuma pieprasījumu, un Soldera veiks cenu aptauju (RFQ) — indikatīvu piedāvājumu saņemsiet parasti vienas darba dienas laikā",
    "modes": {
      "re100": "RE100",
      "cheapest": "Lētākais",
      "advanced": "Paplašināts",
      "re100_help": "RE100: vējš + saule, COD ≤ 15 gadi, optimizēta cena",
      "cheapest_help": "Lētākais: optimizētas zemākās izmaksas, vienlaikus ievērojot atbilstību",
      "advanced_help": "Paplašināts: pielāgo visus atribūtus"
    },
    "form": {
      "volume": {
        "label": "Pērkamais apjoms (MWh)"
      },
      "operation_notes": {
        "label": "Papildu piezīmes (neobligāti)",
        "placeholder": "Ievadiet jebkādas īpašas prasības vai piezīmes šim pirkumam..."
      }
    },
    "certificate_scheme": "Sertifikātu shēma"
  },
  "issuance_reporting": {
    "upload_file": "Augšupielādēt failu",
    "export": "Eksportēt",
    "add_new": "@:common.add",
    "filters": {
      "period_start": "No mēneša",
      "period_end": "Līdz mēnesim",
      "all_devices": "Visas iekārtas",
      "all_statuses": "Visi statusi"
    },
    "status": {
      "pending": "@:common.pending",
      "accepted": "Pieņemts",
      "rejected": "Noraidīts",
      "completed": "Pabeigts"
    },
    "table": {
      "device": "Iekārta",
      "device_code": "Iekārtas kods",
      "total_production": "Kopējā ražošana",
      "date": "Datums",
      "actions": "Darbības"
    },
    "file_upload": {
      "import_summary": "Importēti ieraksti: {imported}. Noraidīti ieraksti: {rejected}.",
      "rejected_records": "Noraidītie ieraksti",
      "rejected_record": "Ieraksts {index} · {device}",
      "country_label": "Valsts",
      "select_country": "Izvēlēties valsti",
      "title": "Augšupielādēt ražošanas datu atskaiti",
      "description": "Lūdzu augšupielādējiet ražošanas datu atskaiti tabulas formātā (Excel, CSV u.c.)",
      "upload_prompt": "Ievelciet failu šeit vai noklikšķiniet, lai pārlūkotu",
      "upload_another": "Augšupielādēt citu failu",
      "supported_formats": "Atbalstītie formāti: .xlsx, .xls, .csv. Lieliem Excel failiem var būt jānoņem neizmantotās lapas un formatējums vai tie jāsadala mazākos failos.",
      "analyzing": "Analizē failu...",
      "countries": {
        "ES": {
          "label": "Spānija"
        },
        "PL": {
          "label": "Polija"
        }
      }
    },
    "no_data_for_period": "Nav datu periodam",
    "delete_record": "Dzēst ierakstu",
    "confirm_delete_record": "Vai tiešām vēlaties dzēst šo ierakstu? Šo darbību nevar atsaukt.",
    "delete_success": "Ieraksts veiksmīgi dzēsts",
    "update_success": "Ražošanas datu atjaunināšana veiksmīga",
    "create_success": "Ražošanas datu ieraksts veiksmīgi izveidots",
    "export_success": "Datu eksports veiksmīgs",
    "file_upload_success": "Fails veiksmīgi augšupielādēts. Izveidoti {created} ieraksti no {total} apstrādātajiem.",
    "no_data": "Ražošanas dati nav pieejami",
    "no_data_description": "Augšupielādējiet ražošanas datus, lai sāktu ar izsniegšanas ziņošanu.",
    "pl_status": {
      "title": "Izsniegšanas procesa statuss",
      "production_data_received": "Ražošanas dati saņemti",
      "waiting_for_quarterly_application_submission": "Ceturkšņa pieteikums gaida iesniegšanu",
      "application_submitted_to_tge_registry": "Pieteikums iesniegts",
      "tge_registry_overdue_submission_deadline": "Ceturkšņa pieteikuma iesniegšana kavējas",
      "goos_issued_successfully": "Izcelsmes apliecinājumi veiksmīgi izsniegti"
    },
    "pl_status_flags": {
      "application_fee_paid": "Pieteikuma maksa samaksāta",
      "application_fee_not_paid": "Pieteikuma maksa nav samaksāta",
      "communication_with_tge_initiated": "Saziņa uzsākta",
      "automatic_written_notice": "Automātisks rakstisks paziņojums",
      "telephone_call": "Telefona zvans"
    },
    "import_not_trusted": "Failu imports ir pieejams pēc konta aktivizēšanas. Lai saņemtu palīdzību, rakstiet uz support@soldera.org.",
    "company_required": "Izvēlieties uzņēmumu, lai skatītu izsniegšanas pārskatus."
  },
  "links": {
    "trading_procedure": "https://www.soldera.org/lv/atbilstiba/tirdzniecibas-kartiba",
    "trading_procedure_text": "Soldera tirdzniecības kārtība"
  },
  "company_orders": {
    "rfq_timeline": {
      "submitted": "Cenu aptauja (RFQ) iesniegta",
      "quote_expected": "Indikatīvs piedāvājums gaidāms līdz {date}",
      "approval_gate": "Nekas netiek pirkts bez jūsu apstiprinājuma"
    },
    "title": "Darījumi",
    "order_type": "Pasūtījuma veids",
    "portfolio": "Portfelis",
    "total_selected_mwh": "Apjoms",
    "order_starter": "Pasūtījuma uzsācējs",
    "initiated_by": "Iniciators",
    "order_date": "Pasūtījuma datums",
    "date": "Datums",
    "export_csv": "Eksportēt pasūtījumus CSV",
    "created": "Izveidots",
    "updated": "Atjaunināts",
    "confirm_order": "Apstiprināt pasūtījumu",
    "edit_order": "Rediģēt pasūtījumu",
    "edit_order_title": "Rediģēt uzņēmuma pasūtījumu",
    "edit_order_success": "Pasūtījums veiksmīgi atjaunināts.",
    "edit_order_error": "Neizdevās atjaunināt pasūtījumu.",
    "edit_order_load_error": "Neizdevās ielādēt pasūtījuma informāciju rediģēšanai.",
    "mwh_mismatch_warning": "Kopējais MWh apjoms atcelšanas paziņojumos ({statementsMwh}) neatbilst atlasītajām portfeļa pozīcijām ({portfolioMwh}). Pielāgojiet MWh vērtības vai portfeļa izvēli, lai tās sakristu.",
    "order_details": "Pasūtījuma detaļas",
    "order_information": "Pasūtījuma informācija",
    "portfolio_items_summary": "Portfeļa vienumu kopsavilkums",
    "total_mwh": "Kopā MWh",
    "support_status": "Atbalsta statuss",
    "associated_portfolio_items": "Saistītie portfeļa vienumi",
    "no_portfolio_items": "Šim pasūtījumam nav pievienotu portfeļa vienumu.",
    "processing_result": "Apstrādes rezultāts",
    "order_type_details": "{type} pasūtījuma informācija",
    "order_types": {
      "SEND": "@:common.actions.send",
      "RECEIVE": "Saņemt",
      "BUY": "Pirkt",
      "SELL": "Pārdot",
      "CANCEL": "Atcelt",
      "BUY_AND_CANCEL": "Pirkt un atcelt"
    },
    "loading_portfolio_items": "Notiek portfeļa vienumu ielāde...",
    "view": "Skatīt",
    "confirm": "Apstiprināt",
    "reject": "Noraidīt",
    "confirm_all": "Apstiprināt visus",
    "confirm_all_message": "Vai tiešām vēlaties apstiprināt visus {count} gaidošos pasūtījumus? Apstrāde sāksies automātiski.",
    "confirm_order_message": "Vai tiešām vēlaties apstiprināt šo pasūtījumu? Apstrāde sāksies automātiski.",
    "reject_all": "Noraidīt visus",
    "batch_confirm_success": "Veiksmīgi apstiprināti {count} pasūtījumi",
    "batch_confirm_partial": "Apstiprināti {success} pasūtījumi, neizdevās {failed}",
    "batch_reject_success": "Veiksmīgi noraidīti {count} pasūtījumi",
    "batch_reject_partial": "Noraidīti {success} pasūtījumi, neizdevās {failed}",
    "status": {
      "waiting_confirmation": "Gaida apstiprinājumu",
      "pending": "Gaida",
      "pending_agent": "Manuāla apstrāde",
      "processing": "Apstrādē",
      "completed": "Pabeigts",
      "failed": "Neizdevies",
      "cancelled": "Atcelts"
    },
    "send": {
      "recipient_information": "Saņēmēja informācija",
      "company_name": "Uzņēmuma nosaukums",
      "registry_country": "Reģistra valsts",
      "eecs_account_id": "EECS konta ID",
      "internal_account_id": "Reģistra iekšējā konta numurs",
      "unit_price_pln": "Vienības cena (PLN/MWh)",
      "operation_notes": "Darbības piezīmes",
      "portfolio_items_title": "Izvēlieties portfeļa vienumus nosūtīšanai"
    },
    "cancel": {
      "total_statements": "Kopā deklarācijas",
      "total_mwh_cancelled": "Kopā atcelts MWh",
      "statement": "Deklarācija",
      "address": "@:common.address",
      "period": "@:cancellation.table.period",
      "purpose": "Mērķis"
    },
    "sell": {
      "sale_summary": "Pārdošanas sagatavošana",
      "hold_to_spot_description": "Šis pasūtījums pārvieto atlasītos izcelsmes apliecinājumus no jūsu pašpārvaldītā portfeļa uz portfeli „@:{'charts.values.portfolio_type.SPOT_MARKET_PRICE'}“ pārdošanai tirgū.",
      "hold_to_min_price_description": "Šis pasūtījums pārvieto atlasītos izcelsmes apliecinājumus no jūsu pašpārvaldītā portfeļa uz portfeli „@:{'charts.values.portfolio_type.SPOT_MIN_PRICE'}“ (minimālā cena €{minimumPrice}/MWh).",
      "process_information": "Procesa informācija",
      "source_portfolio": "Avota portfelis",
      "destination_portfolio": "Mērķa portfelis",
      "operation_type": "Operācijas veids",
      "internal_portfolio_transfer": "Iekšējais portfeļa pārsūtījums"
    },
    "buy": {
      "purchase_summary": "Pirkuma kopsavilkums",
      "volume": "Apjoms",
      "total_price": "Kopējā cena",
      "go_specifications": "EAC specifikācija",
      "eac_source": "EAC avots",
      "technology": "Tehnoloģija",
      "ecolabel": "Ekomarķējums",
      "vintage": "Ražošanas gads",
      "support": "Atbalsts",
      "operation_notes": "Darbības piezīmes",
      "purchase_mode": "Pirkšanas režīms",
      "cod_requirement": "COD prasība",
      "matching": "Saskaņošana",
      "order_summary": "Pasūtījuma kopsavilkums",
      "total_price_per_mwh": "Kopējā cena par MWh",
      "uploaded_contract": "Augšupielādēts līgums",
      "contract": "Līgums"
    },
    "generic": {
      "no_additional_details": "Papildu informācija nav pieejama."
    },
    "transactions": {
      "no_portfolio_items": "Par šī darījuma izcelsmes apliecinājumiem nav portfeļa vienību ierakstu.",
      "transaction_type": "Darījuma veids",
      "awaiting_confirmation": "{count} pasūtījums gaida apstiprinājumu | {count} pasūtījumi gaida apstiprinājumu",
      "in_progress": "{count} apstrādē",
      "no_transactions": "Nav attēlojamu darījumu",
      "load_more": "Ielādēt vairāk",
      "more_transactions": "vēl {count} darījumi",
      "registry_transaction": "Reģistra darījums",
      "registry_transactions": "Reģistra darījumi",
      "not_yet_in_registry": "Reģistrā vēl nav redzams",
      "occurred": "Notika",
      "connection": "Reģistra savienojums",
      "volume": "Apjoms",
      "certificates": "Sertifikāti",
      "volume_in_registry": "Apjoms reģistrā",
      "certificates_in_registry": "Sertifikāti reģistrā",
      "counterparty": "Darījuma partneris",
      "counterparty_account": "Darījuma partnera konts",
      "counterparty_eecs": "Darījuma partnera EECS",
      "event_group": "Reģistra darījumu grupa",
      "events": "Reģistra darījumi",
      "event_count": "Darījumi",
      "from": "No",
      "to": "Līdz",
      "total": "Kopā",
      "showing": "{shown} no {total}",
      "technology": "Tehnoloģija",
      "production_month": "Ražošanas mēnesis",
      "production_device": "Ražošanas iekārta",
      "production_device_count": "Iekārtas: {count}",
      "event_group_label": "{label} · {count}",
      "event_types": {
        "ISSUANCE": "Izsniegšana",
        "INCOMING_TRANSFER": "Ienākošais pārskaitījums",
        "OUTGOING_TRANSFER": "Izejošais pārskaitījums",
        "CANCEL": "Dzēšana",
        "EXPIRY": "Derīguma beigas",
        "REVOCATION": "Atsaukšana"
      },
      "event_row_types": {
        "ISSUANCE": "Reģistra izsniegšana",
        "INCOMING_TRANSFER": "Reģistra ienākošais pārskaitījums",
        "OUTGOING_TRANSFER": "Reģistra izejošais pārskaitījums",
        "CANCEL": "Reģistra dzēšana",
        "EXPIRY": "Reģistra derīguma beigas",
        "REVOCATION": "Reģistra atsaukšana",
        "ALLOCATION": "Portfeļa sadalījums",
        "RETURN": "Portfeļa atgriešana"
      },
      "event_group_types": {
        "ISSUANCE": "Reģistra izsniegšanas",
        "INCOMING_TRANSFER": "Reģistra ienākošie pārskaitījumi",
        "OUTGOING_TRANSFER": "Reģistra izejošie pārskaitījumi",
        "CANCEL": "Reģistra dzēšanas",
        "EXPIRY": "Reģistra derīguma beigas",
        "REVOCATION": "Reģistra atsaukšanas",
        "ALLOCATION": "Portfeļa sadalījumi",
        "RETURN": "Portfeļa atgriešanas"
      }
    }
  },
  "hosted_accounts": {
    "receive_new_gos_title": "Saņemt jaunas izcelsmes garantijas",
    "receive_new_gos_description": "Iestatiet nodomu saņemt izcelsmes apliecinājumus uz Soldera mitinātu reģistra kontu. Mēs to izmantojam ienākošo pārskaitījumu saskaņošanai.",
    "select_country": "Izvēlieties valsti, kurā vēlaties saņemt izcelsmes apliecinājumus",
    "select_country_placeholder": "Izvēlieties valsti...",
    "select_country_first": "Lūdzu, izvēlieties valsti, lai turpinātu",
    "hosted_account": "Mitināts konts",
    "account_details_heading": "Kopīgojiet šos datus ar sūtītāju",
    "transfer_identification_heading": "Identificējiet ienākošo pārvedumu",
    "description": "Norādiet šos Soldera reģistra datus pusei, kas sūta izcelsmes apliecinājumus, lai pārvedums nonāktu pareizajā kontā.",
    "company_name": "Uzņēmuma nosaukums",
    "eecs_account": "EECS konts",
    "amount_mwh": "Apjoms (MWh)",
    "sender_company_name": "Sūtītāja uzņēmuma nosaukums",
    "sender_eecs_account": "Sūtītāja EECS konts",
    "counterparty_email": "Sūtītāja e-pasts",
    "counterparty_email_hint": "Mēs nosūtām sūtītājam e-pastu ar konta datiem, uz kuru veikt pārskaitījumu.",
    "counterparty_email_optional_hint": "Nav obligāts, ja norādīta ražošanas iekārta. Ja norādīts, mēs nosūtām sūtītājam e-pastu ar konta datiem, uz kuru veikt pārskaitījumu.",
    "optional_notes_on_email": "Piezīmes paziņojuma e-pastam",
    "operation_notes_placeholder": "Pievienojiet īpašas norādes vai piezīmes...",
    "operation_notes_hint": "Tiek parādīts sūtītājam pārskaitījuma instrukciju e-pastā un Soldera komandai.",
    "production_device_codes": "Ražošanas iekārtu kodi",
    "production_device_codes_placeholder": "piem., 643XXXXXXXXXXXXXXX",
    "production_device_codes_hint": "Šim pasūtījumam tiek piesaistīti tikai šo iekārtu izcelsmes apliecinājumi. Atstājiet daudzumu tukšu, lai saņemtu visu, ko šīs iekārtas piegādā; ar atkārtotu grafiku pasūtījums to turpina darīt katrā periodā. Vairākus kodus atdaliet ar komatiem.",
    "production_device_codes_too_many": "Ievadiet ne vairāk kā {max} iekārtu kodus",
    "production_device_code_too_long": "Katrs iekārtas kods var būt ne garāks par {max} rakstzīmēm",
    "receive_order_created": "Saņemšanas pasūtījums ir izveidots. Ienākošos pārskaitījumus piesaistīsim šim pasūtījumam.",
    "receive_order_created_sender_notified": "Saņemšanas pasūtījums ir izveidots. Mēs nosūtījām sūtītājam e-pastu ar pārskaitījuma instrukcijām.",
    "create_receive_order": "Izveidot saņemšanas pasūtījumu",
    "create_order": "Izveidot saņemšanas pasūtījumu",
    "advanced_options": "Papildu iespējas",
    "company_name_copied": "Uzņēmuma nosaukums nokopēts starpliktuvē!",
    "eecs_account_copied": "EECS konts nokopēts starpliktuvē!",
    "copy_fallback": "Nokopēts starpliktuvē (rezerves metode)",
    "copy_failed": "Neizdevās kopēt. Lūdzu, kopējiet manuāli.",
    "no_regions_unlocked": "Jūsu organizācijai vēl nav konfigurēti mitinātie konti.",
    "contact_us_cta": "Sazinieties ar mums",
    "contact_us_title": "Vai vēlaties saņemt citā valstī?",
    "contact_us_title_no_accounts": "Gatavs saņemt izcelsmes apliecinājumus?",
    "contact_us_description": "Sazinieties ar mums, lai iegādātos vairāk mitinātu kontu.",
    "contact_us_description_no_accounts": "Sazinieties ar mums, lai iestatītu savu pirmo mitināto kontu.",
    "contact_us_button": "Sazinieties ar mums",
    "no_accounts_configured": "Mitinātie konti nav konfigurēti. Lai sāktu, sazinieties ar mums.",
    "company_id_missing": "Uzņēmuma ID nav norādīts"
  },
  "receive_order": {
    "repeating_label": "Atkārtošanās grafiks",
    "repeating_options": {
      "none": "Vienreizējs",
      "monthly": "Ikmēneša",
      "quarterly": "Ceturkšņa",
      "half_yearly": "Pusgada",
      "yearly": "Ikgadējs"
    },
    "at_least_one_required": "Aizpildiet vismaz vienu no šiem laukiem, lai palīdzētu mums identificēt pārvedumu"
  },
  "portfolios": {
    "title": "Portfeļi",
    "description": "Skatiet un pārvaldiet visus savus portfeļu sadalījumus. Pārdēvējiet, sadaliet, apvienojiet vai pārvietojiet ierakstus starp portfeļiem.",
    "show_items": "Nav ierakstu | Rādīt {count} ierakstu | Rādīt {count} ierakstus",
    "merge": "Apvienot",
    "split": "Sadalīt",
    "merge_modal_title": "Apvienot portfeļus",
    "source_portfolio": "Avota portfelis",
    "target_portfolio": "Mērķa portfelis",
    "select_target_placeholder": "Izvēlieties mērķa portfeli...",
    "merge_confirm_warning": "Visi ieraksti no {source} tiks pārvietoti uz {target}. Avota portfelis tiks neatgriezeniski dzēsts.",
    "merge_info": "Izvēlieties mērķa portfeli, lai redzētu apvienošanas detaļas. Avota portfelis tiks dzēsts pēc apvienošanas.",
    "volume_and_items": "{volume} MWh • {count} ieraksti",
    "split_modal_title": "Sadalīt portfeli",
    "split_select_items": "Izvēlieties sertifikātus pārvietošanai",
    "split_new_name_label": "Jaunā portfeļa nosaukums",
    "split_new_name_placeholder": "piem., Partija B",
    "split_default_name": "Sadalīts no {name} {date}",
    "items_selected": "Nav izvēlētu ierakstu | {count} ieraksts izvēlēts | {count} ieraksti izvēlēti",
    "confirm_merge": "Apstiprināt apvienošanu",
    "confirm_split": "Apstiprināt sadalīšanu",
    "section_inventory": "Krājumi",
    "section_inventory_desc": "IA pieejami darbībām, piemēram, nosūtīšanai, atcelšanai un citām.",
    "section_spot": "Spot pārdošana",
    "section_spot_desc": "IA rindā pārdošanai spot tirgū.",
    "section_ppa": "PPA",
    "section_ppa_desc": "Rezervēts turpmākajām saistībām.",
    "section_forwards": "Nākotnes darījumi",
    "section_forwards_desc": "Rezervēts nākotnes pārdošanai.",
    "volume_label_inventory": "Pieejams",
    "volume_label_spot": "Rindā pārdošanai",
    "volume_label_ppa": "Rezervēts",
    "volume_label_forwards": "Rezervēts",
    "badge_own_registry": "Savienots",
    "badge_soldera_account": "Mitināts",
    "badge_spot_market": "Tirgus cena",
    "badge_spot_min": "Min {price} EUR",
    "badge_spot_min_default": "Minimālā cena",
    "badge_stx": "STX",
    "badge_ppa": "PPA",
    "badge_forward": "Nākotnes darījums",
    "badge_default": "Noklusējuma",
    "tooltip_own_registry": "Izcelsmes apliecinājumi uzņēmuma savienotajā EECS reģistra kontā",
    "tooltip_soldera_account": "Izcelsmes apliecinājumi Soldera mitinātajā kontā uzņēmuma vārdā",
    "tooltip_spot_market": "Pārdots par pašreizējo tirgus cenu",
    "tooltip_spot_min": "Pārdots tikai tad, ja tirgus cena sasniedz minimālo slieksni",
    "tooltip_default": "Noklusējuma portfelis sadalei. Nevar sapludināt.",
    "view_ppa_config": "Konfigurēt",
    "view_forwards": "Skatīt nākotnes darījumus",
    "move_items": "Pārvietot",
    "move_modal_title": "Pārvietot ierakstus",
    "move_modal_desc": "Izvēlieties mērķa portfeli un atzīmējiet ierakstus, kurus vēlaties pārvietot.",
    "move_target": "Mērķa portfelis",
    "select_move_target": "Izvēlieties mērķi...",
    "confirm_move": "Apstiprināt pārvietošanu",
    "no_portfolios": "Šajā sadaļā portfeļi nav atrasti.",
    "empty_inventory": "Pašlaik krājumos nav IA. IA parādīsies šeit pēc saņemšanas vai iegādes.",
    "empty_portfolio": "Šajā portfelī nav ierakstu.",
    "show_empty": "Rādīt {count} tukšus portfeļus",
    "hide_empty": "Slēpt tukšos portfeļus",
    "badge_own_use": "Nav tirgojams",
    "tooltip_own_use": "Izcelsmes apliecinājumi, kas reģistrā atzīmēti pašpatēriņam. Tos nevar pārdot, pārvest vai atcelt."
  },
  "production_strategy": {
    "title": "Ražošanas stratēģija",
    "overview": "Pārskats",
    "ppa_settings": "PPA iestatījumi",
    "self_managed_settings": "Pašpārvaldītie iestatījumi",
    "spot_settings": "Spot pārdošanas iestatījumi",
    "issuance_report": "Izsniegšanas atskaite",
    "forward_commitments": "Nākotnes saistības",
    "whole_year": "Viss gads",
    "from_this_month_onward": "No šī mēneša",
    "bulk_issuance_report": "TSO deklarācija Excel",
    "generating_report": "Ģenerē...",
    "generating_report_progress": "Ģenerē... {current}/{total}",
    "report_duration_hint": "Katra uzņēmuma dati tiek iegūti no reģistra pēc kārtas, tāpēc tas var aizņemt laiku. Jūs varat pamest šo lapu un atgriezties vēlāk.",
    "download_report": "Lejupielādēt atskaiti",
    "generate_new_report": "Ģenerēt jaunu",
    "report_generated_at": "Ģenerēta {time}",
    "report_failed": "Neizdevās - Noklikšķiniet, lai mēģinātu vēlreiz",
    "bulk_issuance": {
      "button_text": "Izsniegt visus izcelsmes apliecinājumus",
      "title": "Izsniegt visus izcelsmes apliecinājumus",
      "description": "Izvēlieties ražošanas periodu un uzņēmumus izsniegšanai:",
      "production_period": "Ražošanas periods",
      "period_error": "Sākuma mēnesim jābūt mazākam vai vienādam ar beigu mēnesi",
      "companies_label": "@:common.companies",
      "no_companies": "Šim kontam nav atrasti HKNR uzņēmumi.",
      "confirm_all": "Apstiprināt visas deklarācijas",
      "confirm_title": "Apstiprināt masveida izsniegšanu",
      "confirm_message": "Tiek izsniegti izcelsmes apliecinājumi {count} uzņēmumiem. Ja uzņēmumam nav iekārtu, tas tiks izlaists.\n\n\"Proof of origin/Herkunftsnachweis\" teksts formā tiks atstāts tukšs.\n\"Subsidy for electricity generation/Förderung der Stromerzeugung\" formā tiks atstāts tāds, kāds tas ir.\n\nVai tiešām vēlaties turpināt?",
      "cancel_title": "Atcelt masveida izsniegšanu",
      "cancel_message": "Vai tiešām vēlaties atcelt? Jau izsniegtos sertifikātus nevar atsaukt.",
      "already_processed": "Jau apstrādātie uzņēmumi:",
      "in_progress": "Notiek",
      "status": {
        "pending": "@:common.pending",
        "in_progress": "Apstrādā...",
        "completed": "{count} iekārta(s) iesniegtas",
        "skipped": "Izlaists (nav ko izsniegt)",
        "error": "Kļūda"
      }
    },
    "yearly_allocations": "Gada sadalījumi",
    "production_allocations": "Ražošanas sadalījumi",
    "company_production": "Uzņēmuma ražošana",
    "show_all_companies": "Rādīt visus uzņēmumus",
    "not_available_consolidated": "Nav pieejams konsolidētajā skatā",
    "next_year": "Nākamais gads",
    "ppa": "PPA",
    "agreements": "līgumi",
    "ppa_agreements": "PPA līgumi",
    "documents": "@:common.documents",
    "display_name": "Parādāmais nosaukums",
    "no_display_name": "Nav pieejams parādāmais nosaukums",
    "display_name_help": "Automātiski ģenerēts no darījuma detaļām",
    "action_instructions": "Darbību instrukcijas",
    "execution_configuration": "Izpildes konfigurācija",
    "delivery_method": "Piegādes metode",
    "automatic": "Izpildīt automātiski",
    "manual": "Pieprasīt apstiprinājumu",
    "automatic_explainer": "sistēma automātiski veic darījumu plānotajā datumā — nav nepieciešams manuāls apstiprinājums.",
    "manual_explainer": "plānotajā izpildes laikā sistēma izveido uzņēmuma pasūtījumu, kas pirms izpildes jāapstiprina manuāli.",
    "execution_method": "Izpildes metode",
    "execution_method_aria": "Izpildes metode",
    "delivery_method_aria": "Piegādes metode",
    "delivery_timing": "Piegādes biežums",
    "execution_timing": "Izpildes biežums",
    "yearly": "Reizi gadā",
    "half_year": "Reizi pusgadā",
    "quarterly": "Reizi ceturksnī",
    "monthly": "Reizi mēnesī",
    "fixed_dates": "Fiksētie datumi",
    "fixed_dates_count": "{count} fiksēti datumi",
    "fixed_delivery_dates": "Fiksētie piegādes datumi",
    "add_date": "Pievienot datumu",
    "end_date": "Beigu datums",
    "ppa_contract_end_date": "PPA līguma beigu datums",
    "end_date_help": "Kad PPA līgums beidzas",
    "ppa_contract_start_date": "PPA līguma sākuma datums",
    "start_date_help": "Kad sākas PPA līgums (nepieciešams mēneša/ceturkšņa limitiem)",
    "transaction_type": "Darījuma veids",
    "send": "Nosūtīt",
    "cancel": "@:common.cancel",
    "send_help": "Pārnest GO sertifikātus saņēmējam",
    "cancel_help": "Atcelt (norakstīt) GO sertifikātus saņēmēja labā",
    "counterparty_details": "Pretpuses dati",
    "transaction_type_aria": "Darījuma veids",
    "q4_production_execution_date": "Q4 izpildes datums:",
    "q1_production_execution_date": "Q1 izpildes datums:",
    "q2_production_execution_date": "Q2 izpildes datums:",
    "q3_production_execution_date": "Q3 izpildes datums:",
    "h1_production_delivery_date": "H1 ražošanas piegādes datums:",
    "h2_production_delivery_date": "H2 ražošanas piegādes datums:",
    "h3_production_delivery_date": "H3 ražošanas piegādes datums:",
    "h4_production_delivery_date": "H4 ražošanas piegādes datums:",
    "allocation_mode_aria": "Sadalījuma veids",
    "remove_recurring_date": "Noņemt atkārtojošos datumu",
    "send_details": "Nosūtīšanas detaļas",
    "cancel_details": "Atcelšanas detaļas",
    "notes": "Piezīmes",
    "notes_placeholder": "Papildu piezīmes šim PPA (neobligāti)",
    "analyze_files": "Analizēt failus",
    "yearly_delivery_day": "Datums 1 (Gada piegāde)",
    "half_year_delivery_days": "Pusgada piegādes datumi",
    "quarterly_delivery_days": "Ceturkšņa piegādes datumi",
    "monthly_delivery_day": "Mēneša piegādes datums",
    "last_day_of_month": "Pēdējā diena",
    "recurring_delivery_dates": "Atkārtotie piegādes datumi",
    "recurring_execution_dates": "Atkārtotie izpildes datumi",
    "recurring_dates_description": "Izvēlieties dienas+mēneša kombinācijas, kas atkārtosies katru gadu līdz PPA beigu datumam",
    "recurring_dates_description_monthly": "Izvēlieties dienu katrā mēnesī, kad notiks izpilde.",
    "recurring_dates_description_quarterly": "Norādiet izpildes datumus katram ceturksnim (parādīts darbības secībā).",
    "recurring_dates_description_half_year": "Izvēlieties izpildes datumus gada pirmajai un otrajai pusei.",
    "recurring_dates_description_yearly": "Izvēlieties vienu gada izpildes datumu.",
    "recurring_dates_description_fixed_dates": "Pievienojiet izpildes datumus, kas atkārtosies secīgi visā līgumā.",
    "add_recurring_date": "Pievienot atkārtotu datumu",
    "first_half": "Datums 1 - Pirmā puse",
    "second_half": "Datums 2 - Otrā puse",
    "date_1_q1": "Datums 1 - Q1",
    "date_2_q2": "Datums 2 - Q2",
    "date_3_q3": "Datums 3 - Q3",
    "date_4_q4": "Datums 4 - Q4",
    "quarter_range_q1": "(Jan-Marts)",
    "quarter_range_q2": "(Apr-Jūn)",
    "quarter_range_q3": "(Jūl-Sept)",
    "quarter_range_q4": "(Okt-Dec)",
    "thinking": "Domāju ...",
    "forward_sales": "Nākotnes pārdošana",
    "forward_sales_overview": {
      "title": "Nākotnes pārdošanas pārskats"
    },
    "forward_mandates_list": {
      "title": "Jūsu aktīvie nākotnes pārdošanas mandāti",
      "empty": "Jūsu uzņēmumi nav nevienā aktīvā nākotnes pārdošanas mandātā.",
      "load_failed": "Nākotnes pārdošanas mandātus neizdevās ielādēt."
    },
    "forward_materials": {
      "description": "Soldera nākotnes pārdošanas pakalpojums ir izstrādāts, lai palīdzētu jums nodrošināt paredzamus ieņēmumus un samazināt cenu svārstību risku, neuztraucoties par ikdienas nākotnes pārdošanas pārvaldību.",
      "outlook_info_1": "Uzziniet par galvenajām tirgus tendencēm un redziet, kā cenas ir mainījušās vēsturiski.",
      "outlook_info_2": "Izprotiet, kā Soldera nākotnes pārdošanas pakalpojums var palīdzēt jums nodrošināt ieņēmumus.",
      "strategy_title": "Soldera nākotnes pārdošanas tirdzniecības stratēģija",
      "strategy_info": "Iegūstiet detalizētu informāciju par to, kā mēs veicam nākotnes pārdošanas jūsu vārdā.",
      "framework_title": "Nākotnes pārdošanas ietvars",
      "framework_info": "Pārskatiet visu caur Soldera veikto nākotnes pārdošanu juridiskos noteikumus un nosacījumus."
    },
    "of_projected_production_per_quarter": "no prognozētās ražošanas ceturksnī",
    "hedged": "Iedalīts",
    "already_committed": "Jau saistīts",
    "for_upcoming_sales": "Gaidāmajām pārdošanām",
    "self_managed_certificates": "Pašpārvaldītie sertifikāti",
    "self_manage": "Pašpārvaldība",
    "allocation": "Sadalījums",
    "allocated": "Sadalīts",
    "spot_sale": "Spot pārdošana",
    "sell_at_highest_bid": "Pārdot par augstāko piedāvājumu",
    "reserved_for_ppas": "Rezervēts PPA",
    "hedged_for_forward_sales": "Nodrošināts nākotnes pārdošanai",
    "committed_forward": "Saistīts forward",
    "forward_estimate": "aplēse",
    "forward_estimate_note": "Aplēstā daļa no kopīgā mandāta",
    "to_be_sold": "Pārdos",
    "to_be_sold_description": "Nākotnes pārdošanai piedāvātais, vēl nepārdotais apjoms, izvietots mēnešos, kuros pēc esošajām saistībām vēl atliek ražošanas apjoms.",
    "sell_all_remaining_spot": "Pārdot visu atlikušo spot tirgū",
    "ppa_allocation_card": "PPA sadalījuma karte",
    "forward_allocation_card": "Nākotnes pārdošanas sadalījuma karte",
    "self_managed_allocation_card": "Pašpārvaldīto sertifikātu sadalījuma karte",
    "spot_allocation_card": "Spot pārdošanas sadalījuma karte",
    "wizard_step_action": "Darbība",
    "wizard_step_allocation": "@:production_strategy.allocation",
    "wizard_step_execution": "Izpilde un pārskatīšana",
    "wizard_step_1_hint": "Nometiet līgumu automātiskai aizpildei vai turpiniet manuāli",
    "show_all_as_one_form": "Rādīt visu kā vienu veidlapu",
    "new_ppa_portfolio": "Jauns PPA portfelis",
    "edit_ppa_portfolio": "Rediģēt PPA portfeli",
    "ppa_modal_crumb": "Ražošanas stratēģija · PPA",
    "step_x_of_y": "{current}. solis no {total}",
    "save_ppa": "Saglabāt PPA",
    "prefill_from_document": "Aizpildīt no dokumenta",
    "portfolio_name_title": "Portfeļa nosaukums",
    "portfolio_name_desc": "Kā šis PPA tiek parādīts jūsu informācijas paneļos.",
    "contract_dates_title": "Līguma datumi",
    "contract_dates_desc": "Kad PPA līgums sākas un beidzas.",
    "action_title": "Darbība",
    "action_desc": "Kas notiks ar šī PPA GO.",
    "allocation_title": "@:production_strategy.allocation",
    "allocation_desc": "Cik daudz produkcijas ir iekļauts.",
    "devices_title": "Iekārtas",
    "devices_desc": "Kuras stacijas nodrošina enerģiju.",
    "execution_title": "Izpilde",
    "execution_desc": "Kad un kā darbības notiek.",
    "review_title": "Pārskats",
    "review_desc": "Kas notiks, kad saglabāsiet.",
    "notes_title": "Piezīmes",
    "notes_desc": "Pievienojiet iekšējo kontekstu šim PPA.",
    "upload_ppa_to_auto_fill": "Augšupielādējiet PPA dokumentu automātiskai aizpildei",
    "upload_ppa_auto_fill_subtitle": "Nometiet PDF, DOC vai DOCX — mēs izvilksim, ko varēsim. Visu var rediģēt vēlāk.",
    "or_skip_and_continue": "vai izlaist un turpināt zemāk",
    "what_is_this_ppa_for": "Kam šis PPA ir paredzēts?",
    "send_certificates": "Sūtīt sertifikātus",
    "cancel_on_behalf": "Atcelt kāda vārdā",
    "send_label": "@:common.actions.send",
    "send_explainer": "pārnes sertifikātus uz partnera reģistra kontu — viņi tos saņem un var izmantot vai atcelt paši.",
    "cancel_on_behalf_label": "Atcelt kāda vārdā",
    "cancel_on_behalf_explainer": "atceļ sertifikātus partnera vārdā — nekas netiek pārnests, sertifikāti tiek patērēti viņu vārdā.",
    "not_set": "Nav iestatīts",
    "no_devices_selected": "Nav atlasītu iekārtu",
    "review_cancel_for": "Atcelts {name} vārdā",
    "review_cancel_generic": "Atcelt kāda vārdā",
    "review_n_periods": "{count} periodi",
    "review_devices_summary": "{count} atlasīti · {mw} MW",
    "review_counterparty_label": "Partneris",
    "review_allocation_label": "@:production_strategy.allocation",
    "review_devices_label": "Iekārtas",
    "review_execution_label": "Izpilde",
    "automatic_short": "Automātisks",
    "manual_short": "Manuāls"
  },
  "ecolabels": {
    "documents_modal": {
      "title": "Dokumenti — {name}",
      "open_hint": "Skatīt un lejupielādēt sākotnēji augšupielādētos dokumentus",
      "empty": "Šai iekārtai nav jums redzamu dokumentu.",
      "download": "Lejupielādēt"
    },
    "fuzzy_search_placeholder": "Meklēt iekārtas pēc nosaukuma, reģistrācijas ID vai adreses…",
    "renewable_types": {
      "solar": "Saule",
      "wind": "Vējš",
      "hydro": "Hidro",
      "geothermal": "Ģeotermālā",
      "bioenergy": "Bioenerģija",
      "marine": "Jūras enerģija",
      "other": "Cits"
    },
    "statuses": {
      "pending_review": "Gaida pārskatīšanu",
      "pre_approved": "Iepriekš apstiprināta",
      "rejected": "Noraidīta",
      "approved": "Apstiprināta",
      "not_approved": "Nav apstiprināta"
    },
    "upload": {
      "add_manually": "Pievienot iekārtu manuāli",
      "pending_hint": "Lieli faili var aizņemt dažas minūtes — pa to laiku varat turpināt rediģēt rindas.",
      "wait_for_ai": "Pirms iesniegšanas pagaidiet, līdz asistents pabeidz",
      "duplicate_of_row_named": "Rinda {row} (“{name}”) šajā augšupielādē",
      "open_in_catalog": "Atvērt katalogā",
      "back_to_catalog": "Atpakaļ uz iekārtu katalogu",
      "title": "Iesniegt iekārtas iepriekšējai apstiprināšanai",
      "subtitle": "Augšupielādējiet iekārtu sarakstu (tabulu, reģistra izrakstu, e-pastu vai PDF) un pārskatiet rindas pirms iesniegšanas.",
      "seller_company": "Pārdevēja uzņēmums",
      "no_seller_company": "Jūsu kontam nav piesaistīts neviens pilnvarots pārdevēja uzņēmums. Lai iegūtu piekļuvi, sazinieties ar EKOenergy.",
      "chat_title": "Augšupielādējiet iekārtu sarakstu",
      "review_title": "Pārskatiet izgūtās iekārtas",
      "review_counts": "{total} rindas, {selected} atlasītas",
      "select_all": "Atlasīt visu",
      "select_all_without_duplicates": "Atlasīt visas bez dublikātiem",
      "check_and_next": "Atzīmēt un tālāk",
      "irec_relaxed_hint": "Identificēta kā I-REC iekārta pēc Evident saites / iekārtas koda. Tehnoloģija un atrašanās vieta šeit nav obligātas — pārbaudītāji tās verificē Evident sistēmā.",
      "irec_lookup_loading": "Meklējam iekārtu Evident iekārtu reģistrā…",
      "irec_lookup_found": "Iekārtas dati aizpildīti no Evident iekārtu reģistra — pārbaudiet tos un, ja nepieciešams, labojiet. Tehnoloģija un atrašanās vieta šeit nav obligātas; pārbaudītāji tās verificē Evident sistēmā.",
      "irec_lookup_not_found": "Šis kods Evident iekārtu reģistrā nav atrasts. Lūdzu, ievadiet iekārtas nosaukumu un valsti paši; tehnoloģija un atrašanās vieta paliek neobligātas.",
      "irec_lookup_unavailable": "Neizdevās sazināties ar Evident iekārtu reģistru. Lūdzu, ievadiet iekārtas nosaukumu un valsti paši; tehnoloģija un atrašanās vieta paliek neobligātas.",
      "deselect_all": "Noņemt atlasi",
      "empty_state": "No augšupielādes izgūtās iekārtas parādīsies šeit pārskatīšanai.",
      "flags": "Pārbaudes",
      "flag_ok": "OK",
      "flag_incomplete": "Trūkst lauku",
      "all_fields": "Visi lauki",
      "flag_duplicate": "{count} dublikāts?",
      "flag_duplicate_hint": "Atrasti iespējami dublikāti — noklikšķiniet, lai redzētu atbilstības",
      "flag_reg_id": "ID: {quality}",
      "flag_reg_id_hint": "Reģistrācijas ID neizdevās validēt pret zināmajiem reģistru formātiem",
      "blocked_row_hint": "Aizpildiet trūkstošos obligātos laukus, lai iespējotu šo rindu",
      "blocked_rows_note": "{count} rinda(s) bloķētas trūkstošu obligāto lauku dēļ",
      "field_address_or_coordinates": "Adrese vai koordinātas",
      "missing_fields": "Trūkst: {fields}",
      "duplicate_details": "Iespējamie dublikāti",
      "duplicate_what_to_do": "Ja tās tiešām ir dažādas stacijas, vienkārši iesniedziet — pārskatītāji redz tās pašas atzīmes. Ja rinda tiešām ir dublikāts, izdzēsiet vienu no tām (✕).",
      "show_row": "Rādīt rindu",
      "duplicate_of_catalog": "Esoša iekārta “{name}” ({status})",
      "duplicate_of_row": "Rinda {row} šajā augšupielādē",
      "submit_selected": "Iesniegt {count} iekārtu(-as) pārskatīšanai",
      "submitted_title": "{count} iekārta(s) iesniegtas pārskatīšanai",
      "submitted_flagged": "{count} iespējami dublikātu pāri tika atzīmēti pārskatītājiem.",
      "view_submissions": "Skatīt iesniegumus",
      "upload_more": "Augšupielādēt vēl"
    },
    "submissions": {
      "collapse_all": "Sakļaut visu",
      "title": "Iesniegumi",
      "subtitle_admin": "Pārskatiet iesniegtās iekārtas: pārbaudiet atzīmes, tad apstipriniet vai noraidiet.",
      "subtitle_seller": "Jūsu iesniegtās iekārtu partijas un to pārskatīšanas statuss.",
      "submit_devices": "Iesniegt iekārtas",
      "empty": "Iekārtu iesniegumu vēl nav.",
      "submitted_on": "Iesniegts",
      "seller": "Pārdevējs",
      "devices": "Iekārtas",
      "status": "Statuss",
      "pending_badge": "{count} gaida",
      "approved_badge": "{count} apstiprinātas",
      "rejected_badge": "{count} noraidītas",
      "flagged_badge": "{count} atzīmētas",
      "duplicates_column": "Dublikāti",
      "details": "Detaļas",
      "duplicates_badge": "{count} iespējami",
      "duplicates_hint": "Iespējami dublikāti — noklikšķiniet, lai pārskatītu un atrisinātu",
      "actions": "Darbības",
      "approve": "Apstiprināt",
      "reject": "Noraidīt",
      "rejection_reason_placeholder": "Noraidīšanas iemesls (redzams pārdevējam)…",
      "no_duplicates": "Šai iekārtai nav neatrisinātu dublikātu kandidātu.",
      "approved_toast": "{name} apstiprināta",
      "override_confirm": "Šai iekārtai ir neatrisināti augstas ticamības dublikāti. Vai tomēr apstiprināt?",
      "approve_anyway": "Tomēr apstiprināt",
      "filter_pending": "Jāizskata",
      "filter_all": "Visi",
      "no_pending": "Nav iesniegumu, kas gaida izskatīšanu.",
      "show_all": "Rādīt visus iesniegumus",
      "merged_badge": "{count} apvienoti",
      "internal_notes": "Iekšējās piezīmes",
      "internal_notes_hint": "Redzamas tikai EKOenergy komandai — pārdevēji tās neredz.",
      "note_placeholder": "Pievienot piezīmi komandai…",
      "add_note": "Pievienot piezīmi",
      "save_changes": "Saglabāt izmaiņas",
      "device_saved": "Iekārta atjaunināta",
      "invalid_number_fields": "Platums, garums vai jauda nav derīgs skaitlis. Nekas netika saglabāts."
    },
    "duplicates": {
      "title": "Dublikāti",
      "subtitle": "{pending} kandidātu pāri gaida pārskatīšanu. Lēmumi ir galīgi.",
      "filter_pending": "Gaida",
      "scan": "Meklēt dublikātus",
      "scan_started": "Dublikātu meklēšana sākta — jauni pāri drīz parādīsies.",
      "empty": "Šajā skatā nav dublikātu kandidātu. Tīrs darbs!",
      "load_more": "Rādīt vairāk ({shown} no {total})",
      "device_a": "Iekārta A",
      "device_b": "Iekārta B",
      "this_submission": "Šis iesniegums",
      "existing_device": "Esošā kataloga iekārta",
      "newer_entry": "Jaunāks ieraksts",
      "older_entry": "Vecāks ieraksts",
      "coordinates": "Koordinātas",
      "not_duplicate": "Nav dublikāts",
      "keep_a": "Apvienot, paturēt A",
      "keep_b": "Apvienot, paturēt B",
      "merge_confirm": "Apvienot šo pāri un paturēt “{name}”? Otrs ieraksts tiks arhivēts un tā dokumenti pārcelti.",
      "confirm_merge": "Apstiprināt apvienošanu",
      "resolved_toast": "Pāris atrisināts",
      "ask_ai": "Jautāt AI",
      "ai": {
        "duplicate": "AI: dublikāts",
        "not_duplicate": "AI: nav dublikāts",
        "unsure": "AI: nav pārliecināts"
      },
      "statuses": {
        "not_duplicate": "Nav dublikāts",
        "merged": "Apvienots"
      },
      "reasons": {
        "registration_id_exact": "Vienāds reģistrācijas ID",
        "registration_id_overlap": "Reģistrācijas ID pārklājas",
        "registration_id_suspect_overlap": "ID pārklājas (zema uzticamība)",
        "name_exact": "Vienāds nosaukums",
        "name_exact_distinct_ids": "Vienāds nosaukums, atšķirīgi reģistra ID",
        "name_fuzzy": "Līdzīgs nosaukums {detail}",
        "coords_within_250m": "250 m attālumā"
      }
    },
    "title": "Ekomarķējumi",
    "description": "Pārvaldiet ar ekomarķējumu sertificētas atjaunīgās enerģijas iekārtas",
    "add_device": "Pievienot iekārtu",
    "edit_device": "Rediģēt iekārtu",
    "ai_upload": "AI augšupielāde",
    "devices_selected": "iekārtas atlasītas",
    "bulk_delete": "Dzēst atlasītās",
    "export_csv": "Eksportēt CSV",
    "no_access_title": "Nav piekļuves EKOenergy reģistram",
    "no_access_contact": "Lai iegūtu piekļuvi, sazinieties ar {0}.",
    "no_devices": "Netika atrastas ekomarķējuma iekārtas. Lai sāktu, pievienojiet pirmo iekārtu.",
    "showing_count": "Rāda: {filtered} no {total}",
    "total_count": "Iekārtu kopskaits: {total}",
    "devices_heading": "Ekomarķējuma iekārtas",
    "device_saved": "Iekārta veiksmīgi saglabāta",
    "device_deleted": "Iekārta veiksmīgi dzēsta",
    "devices_created": "Iekārtas veiksmīgi izveidotas",
    "confirm_delete": "Vai tiešām vēlaties dzēst {name}?",
    "confirm_bulk_delete": "Vai tiešām vēlaties dzēst {count} iekārtas?",
    "bulk_deleted": "{count} iekārtas veiksmīgi dzēstas",
    "columns_selected": "{count} kolonnas",
    "select_columns": "Kolonnas",
    "add_devices": "Pievienot iekārtas",
    "add_devices_description": "Augšupielādējiet dokumentu AI automātiskai aizpildei vai pievienojiet iekārtas manuāli zemāk.",
    "save_devices": "Saglabāt visas iekārtas",
    "add_row": "Pievienot rindu",
    "no_rows": "Vēl nav pievienota neviena iekārta. Augšupielādējiet dokumentu vai pievienojiet rindas manuāli.",
    "devices_saved": "{count} iekārtas veiksmīgi saglabātas",
    "filters": {
      "standard": "Standarts",
      "status": "Statuss",
      "country": "Valsts",
      "search": "Meklēt",
      "search_placeholder": "Meklēt pēc nosaukuma...",
      "capacity_placeholder": "piem. 50",
      "cod_placeholder": "piem. 2020"
    },
    "table": {
      "name": "@:common.name",
      "plant_ecolabel_id": "Reģistrācijas ID",
      "standard": "Standarts",
      "status": "Statuss",
      "country": "Valsts",
      "address": "@:common.address",
      "type": "Tips",
      "renewable_type": "Tehnoloģija",
      "latitude": "Platums",
      "longitude": "Garums",
      "capacity": "Jauda",
      "cod": "COD",
      "date_reviewed": "Pārskatīšanas datums",
      "valid_from": "Apstiprināts no",
      "valid_through": "Apstiprinājums derīgs līdz",
      "registration_authority": "Reģistrs",
      "technology_code": "Tehn. kods",
      "public_notes": "Piezīmes",
      "relevant_link": "Saite",
      "link": "Saite",
      "documents": "@:common.documents",
      "actions": "@:common.actions.title"
    },
    "form": {
      "status": "Statuss",
      "name": "Iekārtas nosaukums",
      "plant_id": "Stacijas ekomarķējuma ID",
      "country": "Valsts kods",
      "address": "@:common.address",
      "latitude": "@:ecolabels.table.latitude",
      "longitude": "@:ecolabels.table.longitude",
      "renewable_type": "Atjaunīgās enerģijas tips",
      "marine": "Jūras enerģija",
      "nuclear": "Kodolenerģija",
      "technology_code": "Tehnoloģijas kods",
      "technology_code_placeholder": "piem., T010000",
      "registration_authority": "Reģistrācijas iestāde",
      "relevant_link": "Saistītā saite",
      "capacity": "Jauda",
      "capacity_units": "Vienības",
      "cod": "Komercdarbības sākuma datums",
      "public_notes": "Publiskās piezīmes",
      "rejection_reason": "Noraidīšanas iemesls",
      "location_hint": "Obligāta ir vai nu adrese, vai koordinātas.",
      "errors": {
        "name_required": "Nosaukums ir obligāts.",
        "country_required": "Valsts ir obligāta.",
        "renewable_type_required": "Atjaunojamās enerģijas veids ir obligāts.",
        "latitude_range": "Platumam jābūt skaitlim no -90 līdz 90.",
        "longitude_range": "Garumam jābūt skaitlim no -180 līdz 180.",
        "capacity_invalid": "Jaudai jābūt skaitlim.",
        "location_required": "Norādiet vai nu adresi, vai koordinātas (platumu un garumu).",
        "registration_authority_required": "Reģistrācijas iestāde ir obligāta, ja ir norādīts reģistrācijas ID.",
        "rejection_reason_required": "Noraidīšanas iemesls ir obligāts, ja statuss ir Noraidīts."
      },
      "registry_device_id": "Reģistra iekārtas ID",
      "date_reviewed": "Pārskatīšanas datums",
      "valid_from": "Apstiprināts no",
      "valid_through": "Apstiprinājums derīgs līdz"
    },
    "ai_autofill": "AI automātiskā aizpilde no dokumenta",
    "autofill_btn": "Automātiski aizpildīt",
    "autofill_confidence": "Pārliecība: {value}%",
    "upload_wizard": {
      "title": "Augšupielādēt anulēšanas paziņojumu",
      "ekoenergy_logo_alt": "EKOenergy logotips",
      "no_authorized_seller_title": "Kļūstiet par autorizētu EKOenergy pārdevēju",
      "no_authorized_seller_description": "Lai augšupielādētu anulēšanas paziņojumus, ir nepieciešams vismaz viens autorizēts pārdevēja uzņēmums.",
      "no_authorized_seller_cta": "Apmeklēt EKOenergy",
      "step1_label": "Augšupielāde",
      "step2_label": "Anulēšanas detaļas",
      "step1_title": "Augšupielādēt anulēšanas dokumentu",
      "step1_description": "Augšupielādējiet anulēšanas paziņojumu. Mūsu AI to analizēs un sasaistīs ar reģistrētām ekomarķējuma iekārtām.",
      "cancellation_source": "Anulēšanas avots",
      "upload_new_statement": "Augšupielādēt jaunu anulēšanas paziņojumu",
      "using_existing_cancellation": "Tiek izmantota esoša anulēšana. Faila augšupielāde un paziņojuma detaļu lauki ir paslēpti.",
      "step2_title": "Pārskatīt un piešķirt iekārtas",
      "step2_description": "Pārskatiet AI atrastās iekārtas, manuāli pievienojiet vai noņemiet iekārtas un pielāgojiet MWh sadalījumu.",
      "drop_file": "Ievelciet failu šeit vai noklikšķiniet, lai pārlūkotu",
      "seller_company": "Pārdevēja uzņēmums",
      "new_company_placeholder": "Jaunā uzņēmuma nosaukums",
      "new_company_email_placeholder": "Īpašnieka e-pasts",
      "company_created": "Autorizēts pārdevēja uzņēmums izveidots",
      "ai_matching_failed_warning": "Šai augšupielādei AI saskaņošana neizdevās. Paziņojums tika saglabāts, bet lauki / iekārtas netika aizpildīti automātiski.",
      "upload_and_match": "Augšupielādēt un sasaistīt iekārtas",
      "analyze": "Analizēt dokumentu",
      "analyzing": "Dokuments tiek analizēts ar AI...",
      "ai_applied": "AI analīze ir piemērota. Pārskatiet un pielāgojiet iepriekš aizpildītos laukus zemāk.",
      "ai_found_matches": "AI jūsu paziņojumā atrada {count} atbilstošu(-as) iekārtu(-as).",
      "matching_devices": "Tiek meklētas atbilstošas ekomarķējuma iekārtas...",
      "no_matches": "Atbilstošas iekārtas automātiski netika atrastas. Jūs varat manuāli piešķirt iekārtas zemāk.",
      "assigned_devices": "Piešķirtās iekārtas",
      "add_device_manually": "Pievienot iekārtu",
      "no_devices_assigned": "Pagaidām nav piešķirta neviena iekārta. Pievienojiet iekārtas manuāli vai augšupielādējiet paziņojumu vēlreiz.",
      "select_device": "Izvēlēties iekārtu",
      "search_devices": "Meklēt pēc nosaukuma vai valsts...",
      "no_devices_found": "Atbilstošas iekārtas netika atrastas.",
      "save_and_submit": "Saglabāt un iesniegt",
      "beneficiary_name": "Saņēmēja nosaukums",
      "registry_code": "Reģistra kods",
      "country_region": "Valsts / reģions",
      "period_start": "Perioda sākums",
      "period_end": "Perioda beigas",
      "mwh_cancelled": "Anulētās MWh",
      "purpose": "Anulēšanas mērķis",
      "notes": "Piezīmes",
      "confirm_proceed": "Apstiprināt un sasaistīt iekārtas",
      "mwh": "@:common.mwh",
      "confidence": "Pārliecība",
      "total_mwh": "Kopējais MWh dokumentā",
      "selected_mwh": "Izvēlētais MWh",
      "generate_certificates": "Ģenerēt sertifikātus",
      "success": "Anulēšanas paziņojums veiksmīgi augšupielādēts un iekārtas piešķirtas"
    },
    "certificates": {
      "heading": "EKOenergy sertifikāti",
      "upload_statement": "Augšupielādēt anulēšanas paziņojumu",
      "no_statements": "Anulēšanas paziņojumu vēl nav. Lai sāktu, augšupielādējiet savu pirmo paziņojumu.",
      "file_name": "Paziņojums",
      "uploaded": "Augšupielādēts",
      "period_col": "@:cancellation.table.period",
      "total_mwh_col": "Kopā MWh",
      "devices_col": "Iekārtas",
      "status_col": "Statuss",
      "actions_col": "@:common.actions.title",
      "download_statement": "Lejupielādēt paziņojumu",
      "edit_statement": "Rediģēt paziņojumu",
      "manage_devices": "Pārvaldīt sasaistītās iekārtas",
      "approve": "Apstiprināt",
      "reject": "Noraidīt",
      "generate": "Ģenerēt sertifikātu",
      "download_certificate": "Lejupielādēt sertifikātu",
      "approved_success": "Paziņojums veiksmīgi apstiprināts",
      "rejected_success": "Paziņojums noraidīts",
      "confirm_reject": "Vai tiešām vēlaties noraidīt šo paziņojumu?",
      "certificate_generated": "Sertifikāts ģenerēts un lejupielādēts",
      "statement_uploaded": "Anulēšanas paziņojums veiksmīgi augšupielādēts"
    },
    "manage_devices": {
      "title": "Rediģēt anulēšanas paziņojumu",
      "statement_details": "Paziņojuma detaļas",
      "documents_section": "@:common.documents",
      "statement_document": "Anulēšanas paziņojums",
      "certificate_document": "Sertifikāta PDF",
      "no_certificate_document": "Nav sertifikāta faila",
      "add_document": "@:common.add",
      "statement_document_updated": "Paziņojuma dokuments atjaunināts",
      "certificate_document_updated": "Sertifikāta dokuments atjaunināts",
      "statement_document_deleted": "Paziņojuma dokuments noņemts",
      "certificate_document_deleted": "Sertifikāta dokuments noņemts",
      "linked_devices": "Sasaistītās iekārtas",
      "add_device": "Pievienot iekārtu",
      "no_devices": "Šim paziņojumam nav sasaistīta neviena iekārta.",
      "select_device": "Izvēlēties iekārtu",
      "saved": "Iekārtu piešķīrumi veiksmīgi atjaunināti"
    },
    "ekoenergy": {
      "title": "EKOenergy ecolabel",
      "description": "Iekārtas, kuras pilnvarotie pārdevēji var izmantot EKOenergy vajadzībām"
    }
  },
  "documents_table": {
    "no_documents": "Nav dokumentu, ko attēlot",
    "columns": {
      "id": "@:common.id",
      "name": "@:common.name",
      "type": "Tips",
      "category": "Kategorija",
      "company": "@:common.company",
      "status": "Statuss",
      "created": "Izveidots",
      "actions": "@:common.actions.title"
    },
    "filters": {
      "search_name": "Meklēt pēc nosaukuma",
      "search_company": "Meklēt pēc uzņēmuma"
    },
    "type": {
      "custom_upload": "Augšupielāde",
      "dokobit_document": "Parakstīts dokuments"
    },
    "category": {
      "sending_gos_file_upload": "IA sūtīšana",
      "buy_contract_analysis": "Pirkuma līgums",
      "cancel_contract_analysis": "Anulēšanas līgums",
      "ppa_contract_analysis": "PPA līgums",
      "bulk_buy_analysis": "Vairumpirkums",
      "ppa_instructions": "PPA instrukcijas",
      "ppa_creation": "PPA izveide",
      "cancellation_statement": "Anulēšanas paziņojums",
      "issuance_data_import": "Emisijas dati",
      "arbitrary_file_upload": "Failu augšupielāde",
      "portfolio_documentation": "Portfeļa dokumentācija",
      "other": "Cits",
      "unknown": "Nezināms"
    },
    "status": {
      "uploaded": "Augšupielādēts",
      "completed": "Parakstīts",
      "awaiting_signature": "Gaida parakstu",
      "canceled": "Atcelts"
    },
    "actions": {
      "archive": "Arhivēt",
      "sign": "Parakstīt",
      "view_details": "Detaļas"
    },
    "details_modal": {
      "title": "Dokumenta detaļas",
      "contract_details": "Līguma detaļas",
      "source": "Avots"
    },
    "confirm_archive": "Vai esat pārliecināts, ka vēlaties arhivēt šo dokumentu? Tas tiks noņemts no saraksta.",
    "archive_success_title": "Dokuments arhivēts",
    "archive_success_message": "Dokuments ir veiksmīgi arhivēts.",
    "linked_cancellations": "Saistītie anulējumi",
    "cancellation_id": "Anulējums #{id}"
  },
  "ppa_summary": {
    "heading": "Gaidāmās izpildes",
    "loading": "Aprēķinam prognozētos apjomus...",
    "no_data": "Prognožu dati pagaidām nav pieejami.",
    "no_data_short": "—",
    "mwh_value": "{amount} MWh",
    "next_delivery": "Nākamā piegāde",
    "following_delivery": "Sekojošā piegāde",
    "contract_ends": "Līgums beidzas",
    "send": "Plānota piegāde {date} (prognoze {amount} MWh).",
    "cancel": "Plānots atcelt periodu {start} -> {end} {date} (prognoze {amount} MWh)."
  },
  "ai_chat": {
    "certificate_criteria_conflict": "{context} satur pretrunīgas sertifikātu prasības ({criterion}). Augšupielādējiet dokumentus atsevišķi.",
    "conflict_contexts": {
      "excel_rows": "Excel rindas",
      "uploaded_documents": "Augšupielādētie dokumenti",
      "draft_and_document": "Pašreizējais melnraksts un augšupielādētais dokuments"
    },
    "shared_setting_conflict": {
      "intro": "Nekas netika importēts. Atcelšanas pasūtījumam var būt tikai viens saņēmēja tips, patēriņa periods un atcelšanas mērķis, bet šīs deklarācijas atšķiras:",
      "other_statements": "Pārējās deklarācijas ({count})",
      "more_statements": "…un vēl {count}",
      "outro": {
        "uploaded_documents": "Izlabojiet šīs deklarācijas dokumentā un augšupielādējiet to vēlreiz, augšupielādējiet tās atsevišķos failos vai pievienojiet augšupielādei piezīmi ar vērtību, kas attiecas uz visām deklarācijām.",
        "draft": "Melnraksts netika mainīts. Pasakiet man, kura vērtība attiecas uz visām deklarācijām, vai pabeidziet šo pasūtījumu un sāciet jaunu sarunu pārējām deklarācijām."
      }
    },
    "document_irrelevant": "Šķiet, ka šis dokuments neatbilst tam, ko šeit sagatavojam, tāpēc nekas netika importēts. Augšupielādējiet citu dokumentu vai pajautājiet man, kāpēc tas neatbilda.",
    "title": "AI asistents",
    "input_placeholder": "Rakstiet ziņojumu…",
    "send": "Sūtīt",
    "attach": "Pievienot dokumentu",
    "drop_files": "Nometiet failus, lai tos pievienotu",
    "drop_files_hint": "PDF, Word, Excel, CSV vai TXT · līdz {maxMb} MB",
    "drop_busy": "Pievienojiet failus, kad būs saņemta atbilde",
    "new_chat": "Sākt jaunu sarunu",
    "thinking": "Strādāju pie tā…",
    "error_reply": "Diemžēl apstrādes laikā radās kļūda. Lūdzu, mēģiniet vēlreiz.",
    "greetings": {
      "cancel": "Sveiki! Augšupielādējiet anulēšanas dokumentu (PDF, Word, Excel vai CSV), un es sagatavošu paziņojumu melnrakstus. Ja trūks būtiskas informācijas, es to pajautāšu šeit. Varat arī vienkārši aprakstīt vajadzīgo ziņojumā.",
      "buy": "Sveiki! Augšupielādējiet iepirkuma dokumentu vai aprakstiet, ko vēlaties pirkt (apjoms, tehnoloģija, gads…), un es aizpildīšu pirkuma iestatījumus.",
      "send": "Sveiki! Augšupielādējiet pārsūtīšanas dokumentu vai pasakiet, kam jāsaņem izcelsmes apliecinājumi (saņēmējs, EECS konts, MWh apjoms), un es sagatavošu pārsūtīšanu.",
      "bulk_buy": "Sveiki! Augšupielādējiet patēriņa pārskatus vai objektu sarakstus, un es izgūšu uzņēmumus, apjomus un pirkuma iestatījumus. Ja trūks būtiskas informācijas, es to pajautāšu šeit.",
      "ppa": "Sveiki! Augšupielādējiet PPA līgumu vai aprakstiet piegādes grafiku, un es aizpildīšu piegādes norādījumus. Ja trūks būtiskas informācijas, es to pajautāšu šeit.",
      "ecolabels": "Sveiki! Augšupielādējiet savu anulēšanas paziņojumu (PDF, Word, Excel vai CSV) vai aprakstiet to, un es sagatavošu paziņojuma datu melnrakstu un sasaistīšu ierīces jūsu vietā. Ja trūks būtiskas informācijas, es to pajautāšu šeit.",
      "ecolabel_devices": "Sveiki! Augšupielādējiet savu iekārtu sarakstu (tabulu, reģistra izrakstu, e-pastu vai PDF), un es izgūšu katru iekārtu ar tās datiem, pārbaudīšu trūkstošos laukus un atzīmēšu iespējamos dublikātus. Iekārtas vai labojumus varat aprakstīt arī ziņā."
    }
  },
  "branding": {
    "powered_by": "Nodrošina",
    "registry_infrastructure": "Reģistra infrastruktūra",
    "powered_by_soldera": "Darbojas ar Soldera reģistra infrastruktūru"
  },
  "cnmc": {
    "workflow_intro": "Iesniedziet mēneša ražošanu, sagatavojiet CNMC izsniegšanas failus un sekojiet PPA pārvedumiem un eksportam.",
    "filing_details": "Pieteikuma dati",
    "prepare_issuance": "Sagatavot izsniegšanu",
    "recipient_name": "Saņēmēja juridiskais nosaukums",
    "destination_registry": "Galamērķa reģistrs",
    "choose_registry": "Izvēlieties reģistru",
    "domestic_transfer": "Spānija · iekšzemes pārvedums",
    "recipient_r2": "CNMC piegādātāja identifikators (R2)",
    "eecs_account": "EECS konts",
    "market_destination": "Tirgus apjomu eksporta galamērķis",
    "change_destination": "Mainīt galamērķi",
    "confirm_representation": "Man ir tiesības iesniegt pieteikumus šī ražotāja vārdā, un esmu apstiprinājis pārstāvības prasību izpildi.",
    "accept_declarations": "Apstiprinu, ka šie rādījumi ir pieejami izsniegšanai, pret tiem nav citu atvērtu pieprasījumu un ražotājs piekrīt CNMC pieteikuma deklarācijām un datu apstrādes noteikumiem.",
    "fields": {
      "producer_name": "Ražotāja juridiskais nosaukums",
      "street": "Iela",
      "street_number": "Mājas numurs",
      "staircase": "Kāpņu telpa (neobligāti)",
      "postal_code": "Pasta indekss",
      "municipality": "Pašvaldība",
      "province": "Province",
      "country": "Valsts",
      "phone": "Tālrunis",
      "email": "E-pasts",
      "place": "Parakstīšanas vieta",
      "representative_name": "Pārstāvja vārds (ja attiecināms)"
    },
    "production": "Ražošana",
    "allocation": "Sadalījums",
    "review": "Pārskatīšana",
    "monthly_breakdown": "Ievadiet katru iekārtu un mēnesi atsevišķi. Izcelsmes apliecinājumu izsniegšanā daļas netiek ņemtas vērā; dažādu mēnešu apjomi netiek apvienoti.",
    "device": "Ražošanas iekārta",
    "month": "Ražošanas mēnesis",
    "production_mwh": "Ražošana (MWh)",
    "whole_go_total": "{count} veseli izcelsmes apliecinājumi pirms esošo saistību atskaitīšanas",
    "allocation_explanation": "Sadalījumu nosaka PPA norādījumi. Lai mainītu sadalījumu, atjauniniet PPA norādījumus un šo melnrakstu.",
    "route": "Piegādes veids",
    "market": "Tirgus",
    "routes": {
      "DOMESTIC": "Iekšzemes",
      "EXPORT": "AIB eksports"
    },
    "issuance_split": "{domestic} iekšzemes izcelsmes apliecinājumi · {exported} izcelsmes apliecinājumi AIB eksportam",
    "saved_draft_explanation": "Melnraksts ir saglabāts. Apstipriniet partiju, lai rezervētu apjomus un izveidotu izsniegšanas failus.",
    "open_batch": "Atvērt partiju",
    "batch_number": "CNMC partija Nr. {id}",
    "needs_attention_explanation": "Soldera jāpārbauda šis pieteikums. Iesniegto pieteikumu uzraudzība turpinās; ietekmētie apjomi paliek rezervēti.",
    "edit_draft": "Rediģēt melnrakstu",
    "delete_draft": "Dzēst melnrakstu",
    "delete_draft_confirmation": "Vai dzēst CNMC partiju Nr. {id}? Melnraksts, tā sadalījums un ražošanas rādījumi tiks neatgriezeniski dzēsti. Šo darbību nevar atsaukt.",
    "confirm_and_generate": "Apstiprināt sadalījumu un izveidot failus",
    "stacking_instructions": "Augšupielādējiet katru izsniegšanas ZIP failu CNMC un zemāk ievadiet tā reģistrācijas numuru. Pārveduma un eksporta failus var sagatavot pēc izsniegšanas pieteikuma iesniegšanas, arī gaidot apstiprinājumu. Katru piegādes ZIP failu augšupielādējiet atsevišķi un ievadiet tā reģistrācijas numuru.",
    "prepare_ppa_delivery": "Sagatavot {name} piegādi",
    "ppa_delivery_issuance_required": "Iesniedziet šī PPA izsniegšanas failu CNMC, pēc tam augstāk ievadiet tā Número de Registro un reģistrējiet iesniegšanu.",
    "market_export_issuance_required": "Iesniedziet AIB eksporta izsniegšanas failu CNMC, pēc tam augstāk ievadiet tā Número de Registro un reģistrējiet iesniegšanu.",
    "prepare_market_export": "Sagatavot eksportu tirgum",
    "kinds": {
      "DOMESTIC_ISSUANCE": "Iekšzemes izsniegšana",
      "EXPORT_ISSUANCE": "Izsniegšana AIB eksportam",
      "TRANSFER": "Iekšzemes pārvedums",
      "EXPORT": "Eksports"
    },
    "statuses": {
      "DRAFT": "Melnraksts",
      "CONFIRMED": "Apstiprināts",
      "PREPARED": "Sagatavots",
      "SUBMITTED": "Iesniegts · nepārbaudīts",
      "PENDING": "Gaida",
      "APPROVED": "Apstiprināts · gaida apliecinājumus",
      "COMPLETED": "Pabeigts",
      "COMPLETE": "Pabeigts",
      "IN_PROGRESS": "Procesā",
      "NEEDS_ATTENTION": "Nepieciešama uzmanība",
      "ABANDONED": "Atcelts",
      "SUPERSEDED": "Aizstāts"
    },
    "source_receipts": "Sākotnējā izsniegšana · Nº Registro Origen",
    "outdated_file": "Šajā failā izmantota vecāka veidne. Pirms augšupielādes aizstājiet vēl neiesniegtu failu; iesniegtos failus saglabājiet saviem ierakstiem.",
    "lookup_retry": "CNMC pārbaude īslaicīgi nav pieejama. Atkārtots mēģinājums ir ieplānots; pēdējais zināmais statuss tiek saglabāts.",
    "filing_deadline": "Pieteikuma termiņš",
    "go_expiry": "Izcelsmes apliecinājuma derīguma termiņš",
    "last_checked": "Pēdējoreiz pārbaudīts",
    "not_checked": "Vēl nav pārbaudīts",
    "company_order": "Uzņēmuma pasūtījums",
    "download_zip": "Lejupielādēt ZIP",
    "check_status": "Pārbaudīt statusu",
    "record_submission": "Reģistrēt iesniegšanu",
    "correction_reason": "Labojuma vai atsaukšanas iemesls",
    "abandon_batch": "Atcelt partiju",
    "abandonment_reason": "Šīs partijas atcelšanas iemesls",
    "abandon_explanation": "Ražošanu var atbrīvot tikai neiesniegtas vai pārbaudīti noraidītas/atsauktas izsniegšanas gadījumā. Neveiksmīga piegāde neatbrīvo izsniegtos apjomus.",
    "connection": "CNMC savienojums",
    "preparation_disabled": "Šim savienojumam nav iespējota jaunu pieteikumu sagatavošana. Esošo pieteikumu vēsture paliek pieejama.",
    "profile_required": "Pirms izsniegšanas sagatavošanas apstipriniet pieteikuma datus.",
    "template_updated": "CNMC ir atjauninājusi šo veidlapu. Pirms jauna faila izveides mums jāatjaunina atbalsts. Jūsu ievadītie dati ir saglabāti.",
    "checking_templates": "Notiek CNMC veidlapu pārbaude. Failu izveide būs pieejama pēc pārbaudes.",
    "no_batches": "Vēl nav izsniegšanas partiju.",
    "batch": "Partija",
    "progress": "Progress",
    "filing_order": "Šo pasūtījumu pārvalda ar CNMC pieteikumu veidlapām. Atveriet izsniegšanas partiju, lai lejupielādētu failus, ievadītu reģistrācijas numurus un pārbaudītu progresu.",
    "pending_ppa": "Rezervēts CNMC PPA piegādei",
    "cnmc_transferred": "Apstiprināta PPA piegāde",
    "ppa_progress": "{reserved_go_count} IA rezervēti · {ready_go_count} gatavi iesniegšanai · {transferred_go_count} pārvesti",
    "linked_filings": "CNMC pieteikumi",
    "order_instructions": "Augšupielādējiet failus CNMC un ievadiet katru reģistrācijas numuru saistītajā partijā. Reģistra pārbaudes apstiprina pabeigšanu.",
    "awaiting_delivery_form": "Izsniegšana ir rezervēta. Pēc izsniegšanas reģistrācijas numura ievadīšanas sagatavojiet pārveduma vai eksporta failu izsniegšanas pārskatā.",
    "inventory_accepted": "Apliecinājumi saņemti un piešķirti",
    "arrival_review": "Spānijas eksporta saņemšana",
    "arrival_review_help": "Pārbaudiet precīzu saņēmēja kontu, pilnus iekārtu apjomus un ražošanas mēnešus. Sadalītai saņemšanai un iekārtu nosaukumu aizstāšanai nepieciešams pamatojums. Pieņemšana vienlaikus piešķir īpašumtiesības un portfeļus.",
    "export_verified": "Eksports pārbaudīts",
    "awaiting_verification": "Gaida CNMC pārbaudi",
    "receiving_account": "Saņēmēja konts",
    "imported_at": "Importēts",
    "production_months": "Ražošanas mēneši",
    "reviewed_name": "Pārskatītais iekārtas nosaukums",
    "use_registry_name": "Izmantot reģistra nosaukumu",
    "accept_inventory": "Pieņemt apliecinājumus",
    "replace_file": "Aizstāt failu",
    "replace_file_help": "Izveidojiet saistītu aizstājēju ar pašreiz atbalstīto veidni. Vispirms jāpārbauda, ka iesniegtie pieteikumi ir noraidīti vai atsaukti. Vēsturiskie faili paliek pieejami.",
    "awaiting_issuance_receipt": "Gaida izsniegšanas pieteikuma numuru",
    "next_action": "Nākamais solis",
    "actions": {
      "REVIEW": "Pārskatīt un apstiprināt sadalījumu",
      "SUBMIT_ISSUANCE": "Augšupielādēt izsniegšanas failus un ievadīt katru Número de Registro | Augšupielādēt izsniegšanas failu un ievadīt tā Número de Registro | Augšupielādēt izsniegšanas failus un ievadīt katru Número de Registro",
      "SUBMIT_DELIVERY": "Augšupielādēt piegādes failus un ievadīt katru Número de Registro",
      "PREPARE_DELIVERY": "Sagatavot piegādes failus",
      "WAIT_CNMC": "Gaida CNMC apstiprinājumu",
      "WAIT_INVENTORY": "Gaida apliecinājumu saņemšanu saņēmēja kontā",
      "CONTACT_SOLDERA": "Nepieciešama Soldera pārbaude",
      "COMPLETE": "Pabeigts",
      "ABANDONED": "Atcelts"
    },
    "staff_review": "Soldera pārbaude",
    "staff_review_help": "Pēc lietas atrisināšanas norādiet izmaiņas un pārbaudiet jaunus CNMC apliecinājumus. Esošie faili, rezervācijas un piegādes ieraksti paliek audita vēsturē.",
    "resume_verification": "Atsākt pārbaudi",
    "load_more": "Ielādēt vairāk",
    "replacement_draft": "Izveidot aizstājošu melnrakstu",
    "replacement_draft_help": "Aizstājošs melnraksts saglabā sākotnējās ražošanas saistības. Pirms pārklājošās ražošanas apstiprināšanas atrisiniet un atbrīvojiet vecos pieteikumus.",
    "template_check_failed": "CNMC veidlapas pārbaude neizdevās. Atkārtots mēģinājums ir ieplānots; jūsu dati ir saglabāti.",
    "next_check": "Nākamā pārbaude",
    "registry_evidence": "CNMC apliecinājumi",
    "net_production": "Faktiskā neto ražošana",
    "domestic_volume": "Iekšzemes",
    "export_volume": "AIB eksports",
    "unallocated_fraction": "Nepiešķirtā daļa",
    "application_number": "Pieteikums Nr. {id}",
    "requested": "Pieprasīts",
    "approved": "Apstiprināts",
    "delivered": "Piegādāts",
    "zip_package": "Oriģinālā darbgrāmata ZIP failā",
    "issuance_receipt": "Número de Registro · Expedición",
    "receipt_format": "20 cipari bez atstarpēm: iesniegšanas gads + 03 + 14 cipari. Izmantojiet iesniegšanas, nevis ražošanas gadu.",
    "receipt_example": "piem., 20260300000045887410",
    "transfer_receipt": "Número de Registro · Transferencia",
    "export_receipt": "Número de Registro · Exportación",
    "issuance_receipt_help": "Pēc šī izsniegšanas ZIP faila iesniegšanas nokopējiet CNMC piešķirto Número de Registro. Tas ir atrodams sadaļā Consultas por Solicitante vai procesa informācijas augšdaļā laukā Nº registro.",
    "delivery_receipt_help": "Pēc šī pārveduma vai eksporta ZIP faila iesniegšanas nokopējiet jauno Nº registro no CNMC procesa informācijas augšdaļas. Neizmantojiet Nº Registro Origen (sākotnējā izsniegšana) vai eksporta Message ID.",
    "correct_receipt": "Labot reģistrācijas numuru",
    "delivery_due": "Piegādes gatavība",
    "issuance_stage": "1. posms · Izsniegšanas veidlapas",
    "delivery_stage": "2. posms · Pārveduma un eksporta veidlapas",
    "download_notice": "Pakotnes lejupielāde to neiesniedz. Reģistrējiet katru CNMC pieteikuma numuru partijā, lai iespējotu saistītās veidlapas un uzraudzību.",
    "enter_manually": "Ievadīt manuāli",
    "upload_with_ai": "Augšupielādēt ar MI",
    "upload_readings_help": "MI nolasa iekārtu CIL kodus, ražošanas mēnešus un MWh no Excel vai CSV failiem (līdz 25 MB). Pārskatiet un labojiet zemāk esošās rindas. Lieliem Excel failiem var būt jānoņem neizmantotās lapas un formatējums vai tie jāsadala mazākos failos.",
    "readings_uploaded": "Faila {filename} rādījumi ir redzami zemāk. Pirms turpināt, pārskatiet tos.",
    "upload_readings_conflict": "Šajā failā norādītajai iekārtai un mēnesim tabulā jau ir atšķirīgs rādījums. Pirms atkārtotas augšupielādes noņemiet šo rindu.",
    "invalid_readings_file": "Izvēlieties Excel (.xlsx, .xls) vai CSV failu līdz 25 MB.",
    "add_production_help": "Ievadiet mēneša rādījumu manuāli vai augšupielādējiet failu ar MI.",
    "ppa_reserves": "Izsniegšanas rezervācijas",
    "no_ppa_reserves": "Nav PPA rezervāciju. Pieejamie veselie IA tiek piešķirti eksportam pārdošanai tirgū.",
    "filing_snapshot_help": "Kopīgie noklusējuma dati CNMC pieteikumiem. Katrā partijā tiek saglabāti tās sagatavošanā izmantotie iesniegšanas dati.",
    "producer": "Ražotājs",
    "contact_address": "Kontaktinformācija un adrese",
    "representation": "Pārstāvība",
    "declarations": "Apliecinājumi",
    "connection_identity": "No atlasītā CNMC savienojuma",
    "saved_for_connection": "Saglabāts nākamajām šī savienojuma partijām",
    "eecs_recipient": "EECS reģistra konts",
    "domestic_recipient": "Spānijas piegādātājs · CNMC",
    "recipient_type": "Saņēmēja veids",
    "domestic_delivery_help": "Iekšzemes piegāde caur CNMC. Soldera rezervē šo daļu izsniegšanas laikā un sagatavo pārveduma veidlapu. Failus CNMC iesniedzat jūs.",
    "export_delivery_help": "Eksporta piegāde caur CNMC uz saņēmēja EECS reģistra kontu. Soldera rezervē šo daļu izsniegšanas laikā un sagatavo eksporta veidlapu. Failus CNMC iesniedzat jūs.",
    "ppa_execution_desc": "Sadalījums un piegāde caur CNMC.",
    "ppa_execution_help": "PPA daļa un saņēmējs tiek fiksēti, apstiprinot izsniegšanu. Ievadiet izsniegšanas reģistrācijas numuru, lai izsniegšanas pārskatā sagatavotu pārveduma vai eksporta failu. Augšupielādējiet katru failu CNMC un ievadiet tā reģistrācijas numuru. Soldera seko apstiprināšanai un piegādei.",
    "ppa_execution_summary": "Ar CNMC izsniegšanu",
    "r2_help": "Saņēmēja reģistrācija CNMC kā atbilstošam piegādātājam.",
    "ready_for_filing": "Gatavs iesniegšanai",
    "template_verification_pending": "CNMC veidlapas gaida pārbaudi. Failu ģenerēšana būs pieejama pēc jaunāko veidlapu pārbaudes.",
    "validation": {
      "r2": "Ievadiet CNMC piegādātāja reģistrācijas numuru, kas sākas ar R2-.",
      "eecs_region": "EECS kontam jābūt izvēlētajā reģistrā.",
      "month": "Ievadiet derīgu ražošanas mēnesi.",
      "production_precision": "Ievadiet MWh ar ne vairāk kā 3 zīmēm aiz komata."
    },
    "connection_required": "Lai sagatavotu CNMC pieteikumus, pievienojiet Spānijas ražotāja kontu. Lai saņemtu palīdzību, rakstiet uz support@soldera.org."
  },
  "forwards": {
    "common": {
      "mwh": "MWh",
      "mwh_value": "{value} MWh",
      "committed": "Saistīts",
      "escrowed": "Deponēts",
      "available": "Pieejams",
      "planned": "Plānots",
      "delivered": "Piegādāts",
      "shortfall": "Nav segts",
      "fill_of_total": "{filled} no {total} MWh",
      "no_window_end": "piegādes termiņa nav",
      "not_priced": "Cena vēl nav noteikta",
      "price_per_mwh": "{price} €/MWh",
      "price_range_per_mwh": "{min} – {max} €/MWh",
      "retry": "Mēģināt vēlreiz",
      "unknown": "Nezināms",
      "not_backed": "Vēl nav nodrošināts",
      "yes": "Jā",
      "no": "Nē",
      "none": "Nav",
      "actions": "Darbības",
      "status": {
        "draft": "Melnraksts",
        "confirmed": "Apstiprināts",
        "completed": "Pabeigts",
        "cancelled": "Atcelts",
        "archived": "Arhivēts",
        "escrow_remaining": "Atlikušais depozīts",
        "pay_as_produced": "Pēc saražotā"
      },
      "super_admin_only_create": "Darījumus var izveidot tikai superadministrators.",
      "support": {
        "mixed": "Jaukts: ar atbalstu vai nezināms",
        "unsupported": "Bez atbalsta"
      },
      "period_width": {
        "month": "Mēneši",
        "quarter": "Ceturkšņi",
        "half_year": "Pusgadi",
        "year": "Gadi"
      },
      "device_count": "{count} iekārtu | {count} iekārta | {count} iekārtas",
      "deal_badges": {
        "under_committed": "{mwh} MWh bez seguma",
        "volume_over": "{mwh} MWh virs darījuma apjoma",
        "volume_under": "{mwh} MWh zem darījuma apjoma"
      },
      "deal_text": {
        "description_help": "Tiek drukāts ražotāju rēķinos un rādīts ražotājiem viņu pārdošanas sarakstā.",
        "internal_notes": "Iekšējās piezīmes",
        "internal_notes_help": "Tikai darbiniekiem: nekad netiek rādītas ražotājiem vai pircējiem un nekad netiek drukātas."
      }
    },
    "overview": {
      "title": "Nākotnes pārdošana",
      "description": "Uzmanību prasošie punkti, pa ražošanas gadiem pārdotais nākotnes apjoms, gaidāmās piegādes un jūsu pārvaldītie darījumi.",
      "year_totals": {
        "title": "Nākotnes pārdošana pa ražošanas gadiem",
        "description": "Katra ražošanas gada pārdotais nākotnes apjoms un tā vidējā pircēja cena.",
        "loading": "Ielādē gada kopsummas",
        "empty": "Nākotnes pārdošanas vēl nav.",
        "load_failed": "Gada nākotnes pārdošanas kopsummas neizdevās ielādēt.",
        "volume": "{mwh} MWh",
        "average": "vid. {price} €/MWh",
        "no_average": "vēl nav apjoma ar cenu",
        "unpriced": "{mwh} MWh bez cenas",
        "contents": {
          "intro": "Apjomā ieskaitīti apstiprinātie un pabeigtie darījumi, kā arī tas, ko atceltie darījumi jau bija nosūtījuši, bet ne melnraksti. Pa darījumu veidiem:",
          "fixed_volume": "Fiksēta apjoma darījumi: to piegādes plāns, katrs periods ieskaitīts gadā, kurā tas sākas, neatkarīgi no tā, vai tas ir nosūtīts.",
          "pay_as_produced": "Līgumi pēc saražotā: katra mēneša nosūtītais apjoms vai līdz nosūtīšanai tā nominētais apjoms."
        }
      },
      "attention": {
        "title": "Nepieciešama uzmanība",
        "description": "Šī konta mandātu un darījumu punkti. Tie pazūd paši, tiklīdz problēma ir atrisināta.",
        "loading": "Notiek punktu ielāde",
        "empty": "Nekas neprasa jūsu uzmanību.",
        "load_failed": "Uzmanību prasošos punktus neizdevās ielādēt.",
        "status": {
          "stale_draft": "Novecojis melnraksts",
          "open_slices": "Nesegts",
          "escrow_shortfall": "Iztrūkums",
          "producer_price_missing": "Nav ražotāja cenas",
          "price_conflict": "Cenu konflikts",
          "delivery_unpriced": "Trūkst cenas",
          "free_escrow": "Atdodams depozīts",
          "infeasible": "Pārpārdots",
          "mandate_escrow_missing": "Trūkst",
          "other": "Cits",
          "coarse_issuance": "Izsniegšana",
          "allocation_not_ready": "Netiek sadalīts",
          "contango_discouraged": "Contango 20%"
        },
        "reason": {
          "stale_draft": "Darījuma melnraksts, {days} dienas neapstiprināts. Tā saistības joprojām rezervē krājumus, bet nekas netiek piešķirts.",
          "open_slices": "{mwh} MWh no šī darījuma nesedz neviens mandāts.",
          "escrow_shortfall": "{mwh} MWh no saistītā apjoma vēl nav depozītā.",
          "producer_price_missing": "Mijmaiņas darījuma piegāde līdz {date}: ražotāja cena nav norādīta, tāpēc ražotāji izraksta rēķinus pēc pārdošanas cenas.",
          "price_conflict": "Piegāde līdz {date}: {company} pārdod caur mandātiem ar atšķirīgām cenām ({mandates}), tāpēc piegādi nevar nosūtīt.",
          "delivery_unpriced": "Nevienai piegādei netrūkst pircēja cenas. | {count} piegādei ({mwh} MWh) nav pircēja cenas, tāpēc gada nākotnes pārdošanas kopsummās tā netiek ieskaitīta. | {count} piegādēm ({mwh} MWh) nav pircēja cenas, tāpēc gada nākotnes pārdošanas kopsummās tās netiek ieskaitītas.",
          "free_escrow": "{mwh} MWh ir depozītā, bet neviena piegāde tos vairs neizmanto. Atdodiet tos īpašnieku uzņēmumiem.",
          "infeasible": "Paredzamā izstrāde periodā {period} par {mwh} MWh atpaliek no mandāta saistībām.",
          "infeasible_periods": "Paredzamā izstrāde atpaliek no mandāta saistībām periodos {periods}.",
          "mandate_escrow_missing": "Periodam {period} saistītie {mwh} MWh trūkst depozītā; reģistram tie jau bija jāizsniedz.",
          "coarse_issuance": "Sertifikāti tiek izsniegti {issued}, bet mandāts piedāvā {listed}: šīs iekārtas nevar piegādāt tā piedāvātos apjomus. Piedāvājiet {widest} vai ilgāk.",
          "allocation_not_ready": "Nakts sadale izlaiž {companies} (nav gatavi sadalei), tāpēc to ražošana nekad nenonāk depozītā šī mandāta darījumiem.",
          "contango_discouraged": "Šis mandāts pārdod tikai vismaz 20% virs tūlītējās cenas, kas notiek reti, tāpēc tā apjoms tiek pārdots reti. Apsveriet iespēju izvēlēties „Pārdot tikai contango gadījumā”."
        },
        "issued_in_region": "{width} ({region})",
        "period_mwh": "{period} ({mwh} MWh)",
        "width_adverb": {
          "month": "reizi mēnesī",
          "quarter": "reizi ceturksnī",
          "half_year": "reizi pusgadā",
          "year": "reizi gadā"
        }
      },
      "deliveries": {
        "title": "Gaidāmās piegādes",
        "description": "Jūsu pārvaldīto darījumu plānotās piegādes, sākot ar tuvāko termiņu. Trūkstošais apjoms ir tas, kā piegādes depozītam vēl pietrūkst, grupēts pēc to mandātu iekārtu valstīm, kas to sedz. Mēnesis pēc saražotā tiek rādīts pret nominēto mērķa apjomu, kas tiek uzraudzīts, bet nav saistība.",
        "loading": "Notiek piegāžu ielāde",
        "empty": "Nav piegāžu, kas atbilst šiem filtriem.",
        "load_failed": "Gaidāmās piegādes neizdevās ielādēt.",
        "download_xlsx": "Lejupielādēt xlsx",
        "transaction": "Darījums",
        "window": "Piegādes logs",
        "deal": "Darījums",
        "escrowed_of_planned": "Deponēts / plānots · trūkst pa valstīm",
        "open_transaction": "Atvērt pārdošanas darījumu",
        "open_deal": "Atvērt darījumu",
        "escrowed_of_target": "{escrowed} no mērķa {target} MWh",
        "on_or_before": "līdz {date}",
        "short": "trūkst",
        "due_today": "termiņš šodien",
        "due_tomorrow": "termiņš rīt",
        "due_in_days": "pēc {days} dienām",
        "overdue_one_day": "nokavēts par 1 dienu",
        "overdue_days": "nokavēts par {days} dienām",
        "transaction_status": {
          "draft": "Melnraksts",
          "pending_buyer_details": "Gaida pircēja datus",
          "pending_contracts": "Gaida līgumus",
          "ready_to_transfer": "Gatavs pārskaitīšanai",
          "delivered": "Piegādāts",
          "completed": "Pabeigts"
        },
        "delivered_awaiting_completion": "piegādāts, gaida maksājumu",
        "filters": {
          "status": "Darījuma statuss",
          "window_end": "Piegādes loga beigas",
          "window_end_any": "Jebkurš datums",
          "deal_name": "Darījuma nosaukums"
        }
      },
      "deals": {
        "title": "Jūsu pārvaldītie darījumi",
        "description": "Pilna informācija (piegādes plāns, saistības, depozīta sadalījums) ir darījuma lapā.",
        "loading": "Notiek darījumu ielāde",
        "empty": "Neviens darījums neatbilst šiem filtriem.",
        "load_failed": "Darījumus neizdevās ielādēt.",
        "new_deal": "Jauns nākotnes darījuma melnraksts",
        "new_pap_deal": "Jauns darījums pēc saražotā",
        "no_buyer": "Nav norādīts",
        "no_price": "Nav norādīta",
        "price_range": "{min} - {max}",
        "deliveries_of": "{done} no {total}",
        "stale": "{days} d. vecs",
        "infeasible": "Neizpildāms",
        "filters": {
          "status": "Statuss",
          "status_all": "Visi statusi",
          "name": "Darījuma nosaukums",
          "name_placeholder": "Jebkurš nosaukums",
          "mandate": "Satur mandātu",
          "mandate_placeholder": "Mandāta nosaukums",
          "company": "Satur uzņēmumu",
          "company_placeholder": "Uzņēmuma nosaukums"
        },
        "columns": {
          "deal": "Darījums",
          "buyer": "Pircējs",
          "quarters": "Ražošana",
          "volume": "Darījuma apjoms (MWh)",
          "price": "Cena (€/MWh)",
          "deliveries": "Piegādes pabeigtas",
          "status": "Statuss"
        }
      }
    },
    "mandates": {
      "intro": {
        "title": "Pārdodiet savu nākotnes ražošanu iepriekš",
        "body": "Ar nākotnes pārdošanu jūs pārdodat izcelsmes apliecinājumus par ražošanu, kurai apliecinājumi vēl nav izsniegti, par šodien saskaņotu cenu. Soldera nākotnes pārdošanas pakalpojums palīdz jums nodrošināt paredzamus ieņēmumus un samazināt cenu svārstību risku, neuztraucoties par nākotnes pārdošanas ikdienas pārvaldību. Lai sāktu, izveidojiet nākotnes pārdošanas mandātu: izvēlieties, kuri jūsu uzņēmumi piedalās un cik daudz tie piedāvā katrā periodā. Soldera pārdod šo apjomu pircējiem savā tīklā, un apliecinājumi tiek piegādāti, tiklīdz reģistrs tos izsniedz. Ja kāds uzņēmums saražo mazāk, nekā gaidīts, pārējie mandāta uzņēmumi var segt iztrūkumu ar savu papildu ražošanu.",
        "cta": "Izveidot savu pirmo mandātu"
      },
      "guide": {
        "title": "Par nākotnes pārdošanu"
      },
      "loading": "Notiek mandātu ielāde",
      "empty": "Neviens mandāts neatbilst šiem filtriem.",
      "load_failed": "Mandātu laika joslu neizdevās ielādēt.",
      "attention": {
        "description": "Ko mainīt jūsu mandātos. Ieraksti pazud, tiklīdz tie ir atrisināti."
      },
      "restricted_access": "Jūsu uzņēmums ir iekļauts šajā mandātā. Lai skatītu detalizētu informāciju, nepieciešama piekļuve visiem dalībuzņēmumiem.",
      "status_filter": "Statuss",
      "status_filter_all": "Visi statusi",
      "company_filter": "Uzņēmumi",
      "company_filter_all": "Visi uzņēmumi",
      "name_filter": "Mandāta nosaukums",
      "name_filter_placeholder": "Meklēt pēc nosaukuma",
      "name_filter_no_matches": "Neviens mandāts neatbilst šim nosaukumam.",
      "status": {
        "active": "Aktīva",
        "archived_open": "Arhivēta, saistības nav izpildītas",
        "archived_settled": "Arhivēta un norēķināta"
      },
      "year_previous": "Iepriekšējais gads",
      "year_next": "Nākamais gads",
      "band_title": "Visi mandāti",
      "band_column": "{quarter}: piedāvāts {listed} MWh, saistīts {committed} MWh, deponēts {escrowed} MWh, pieejams {available} MWh",
      "band_available": "{quarter}: pieejams {value} MWh no piedāvātajiem {listed} MWh",
      "band_committed": "{quarter}: saistīts, vēl nedeponēts {value} MWh (kopā saistīts {committed} MWh)",
      "band_escrowed": "{quarter}: deponēts {value} MWh",
      "infeasible_periods": "Šis mandāts ir pārdevis vairāk, nekā tā iekārtām paredzēts saražot periodā {periods}.",
      "row_subtitle": "{companies} · {devices} · {shape}",
      "row_companies": "{count} uzņēmumu | {count} uzņēmums | {count} uzņēmumi",
      "pap_window": "Līguma periods · deponēts {escrowed} MWh · piegādāts {delivered} MWh",
      "cell_figure": "{committed} no {listed}",
      "cell_escrowed_figure": "{value} deponēts",
      "cell_available": "{mandate}, {quarter}: vēl pieejams {value} MWh",
      "available_help": "Katram periodam — lielākais apjoms, ko viens jauns darījums vēl varētu paņemt. Plašāku periodu saistības ir kopīgas vairākiem periodiem, tāpēc šos skaitļus nevar saskaitīt.",
      "cell_committed": "{mandate}, {quarter}: saistīts {value} MWh, no tā deponēts {escrowed} MWh",
      "cell_stranded": "{mandate}, {quarter}: deponēts {value} MWh bez spēkā esošas saistības",
      "cell_empty": "{mandate}, {quarter}: nekas nav piedāvāts",
      "cell_deal_tooltip": "{deal} · {value} MWh, deponēts {escrowed} MWh · {status} · piegāde līdz {window}",
      "entry_width": {
        "quarter": "Ceturkšņa",
        "month": "Mēneša",
        "half_year": "Pusgada",
        "half_year_recommended": "Pusgada (ieteicams)",
        "year": "Gada"
      },
      "listing_kind": {
        "one_off": "Vienreizēja",
        "recurring": "Atkārtota",
        "pay_as_produced": "Pēc saražotā"
      },
      "options": {
        "title": "Iestatījumi",
        "minimum_price": "Minimālā cena",
        "minimum_price_placeholder": "Nav ierobežojuma",
        "minimum_price_hint": "Darījums nedrīkst šī mandāta apjomu novērtēt zemāk.",
        "minimum_price_negative": "Minimālā cena nevar būt negatīva.",
        "minimum_price_too_precise": "Minimālajai cenai var būt ne vairāk kā {decimals} decimālzīmes.",
        "contango": {
          "label": "Contango",
          "help": "Contango nozīmē, ka nākotnes cena ir augstāka par tūlītējo cenu pārdošanas dienā.",
          "none": "Pārdot neatkarīgi no tūlītējās cenas",
          "any": "Pārdot tikai contango gadījumā",
          "at_least_20_percent": "Pārdot tikai contango gadījumā, vismaz 20% virs tūlītējās cenas (nav ieteicams)",
          "discouraged": "20% prēmija virs tūlītējās cenas ir reta, tāpēc šī mandāta apjoms tiek pārdots reti. Apsveriet iespēju izvēlēties „Pārdot tikai contango gadījumā”."
        },
        "archive_on_delivery": "Arhivēt mandātu, kad pēdējā saistība ir piegādāta",
        "archive_on_delivery_hint": "Piemērota mandātam, kas izveidots vienam līgumam."
      },
      "advanced_listing": {
        "label": "Rādīt papildu piedāvājuma iespējas",
        "hint": "Ikviens, kas rediģē šo mandātu, redz visus piedāvājuma veidus: vienreizēju, citus perioda garumus un pēc saražotā. Bez tā redaktors piedāvā tikai atkārtota piedāvājuma ceturkšņus.",
        "locked": "Paliek ieslēgts, kamēr piedāvājums nav atkārtots un ceturkšņa vai kamēr mandāts pārdod uz priekšu."
      },
      "volumes": {
        "title": "Piedāvātais apjoms",
        "intro": "Ievadiet, cik daudz šis mandāts piedāvā nākotnes pārdošanai katrā periodā. Apjoms attiecas uz visu mandātu, nevis uz katru uzņēmumu atsevišķi. Piedāvātais apjoms nav saistošs, un to var mainīt jebkurā laikā. Tas kļūst saistošs, kad tiek piesaistīts darījumam, un piesaistītais apjoms ir jāpiegādā arī tad, ja vēlāk piedāvāto apjomu samazināt. Varat ievadīt MWh vai % no prognozētās ražošanas. % tiek saglabāts kā MWh.",
        "previewing": "Notiek atjaunināšana",
        "mode": "Kā apjomi tiek norādīti",
        "entry_width": "Perioda garums",
        "entry_width_hint": "Katra piedāvātā perioda garums. Jūsu apjomu var pārdot kopā ar citiem jūsu periodiem kā garāku periodu, bet nekad nesadalītu īsākos.",
        "month_note": "Izmantojams tikai reģistros, kuros izcelsmes apliecinājumus izsniedz katru mēnesi.",
        "month_warning": "Šī ir papildu funkcija. Mēneša piedāvājumi neatbalsta balansēšanu: viena mēneša pārprodukcija nevar segt cita mēneša nepietiekamo ražošanu.",
        "half_year_note": "Pusgada mandāts piegādēs var segt tikai pusgada un pilna gada ražošanas periodus.",
        "year_note": "Gada mandāts piegādēs var segt tikai pilna gada ražošanas periodus.",
        "pay_as_produced_note": "Mandāts pēc saražotā pārdod visu savu iekārtu produkciju, tāpēc apjomus nepiedāvā, un tā iekārtas nedrīkst piederēt nevienam citam mandātam.",
        "period": "Periods",
        "share_of_estimate": "% no prognozes",
        "feedback": "Saistīts · brīvs · prognoze",
        "mwh_for": "Periodam {period} piedāvātās MWh",
        "share_for": "Daļa no prognozes periodam {period}",
        "remove_period": "Noņemt {period}",
        "no_rows": "Neviens periods vēl nav piedāvāts.",
        "add_period": "Pievienot periodu",
        "whole_year": "Viss gads",
        "no_estimate": "Prognozes nav",
        "feedback_line": "saistīts {committed} · brīvs {free} · prognoze {estimated}",
        "free_hint": "Brīvs ir tas, ko vēl var pārdot šodien: nekas, kad perioda ražošana ir beigusies, nekas, ko pārdošanas stratēģija vēl nav atbrīvojusi, un ne vairāk, cik atlicis to aptverošajam ceturksnim, pusgadam un gadam.",
        "over_committed_note": "Šīs esošās saistības paliek nemainīgas:",
        "over_committed_period": "{period}: saistīts {committed} MWh",
        "over_estimate": "{percent}% no prognozes",
        "errors": {
          "period_duplicate": "Šis periods jau ir norādīts citā rindā."
        },
        "how_it_works": "Kā darbojas piedāvājums"
      },
      "production_range": {
        "limited": "Ierobežot piedāvājumu ar noteiktu ražošanas periodu",
        "first_month": "Pirmais ražošanas mēnesis",
        "last_month": "Pēdējais ražošanas mēnesis",
        "hint": "Jauni darījumi var ietvert tikai šajos mēnešos saražoto. Atkārtots piedāvājums ārpus tiem neko nepiedāvā; pēc saražotā līgumam jāietilpst to robežās. Atstājiet mēnesi tukšu, ja šajā pusē nav ierobežojuma.",
        "no_limit": "Bez ierobežojuma",
        "last_before_first": "Pēdējais mēnesis nevar būt pirms pirmā."
      },
      "members": {
        "title": "Uzņēmumi",
        "description": "Kuru produkciju šis mandāts pārdod.",
        "placeholder": "Izvēlieties uzņēmumus",
        "not_enabled": "Nākotnes pārdošana nav ieslēgta. Sazinieties ar atbalstu.",
        "not_allocation_ready": "Nakts sadale nav iestatīta, tāpēc nekas netiks deponēts.",
        "no_candidates": "Neviens uzņēmums neatbilst.",
        "at_least_one": "Mandātā jābūt vismaz vienam uzņēmumam.",
        "manage_account": "Lai mainītu šī mandāta uzņēmumus, pārvaldiet kontu, kam tie pieder.",
        "own_companies_only": "Tiek piedāvāti tikai jūsu konta uzņēmumi. Lai izveidotu mandātu no klienta uzņēmumiem, pārvaldiet klienta kontu."
      },
      "devices": {
        "title": "Iekārtas",
        "description": "Visas augstāk norādīto uzņēmumu reģistrētās iekārtas. Prognozēs PPA daļa jau ir atskaitīta.",
        "use_allowlist": "Pārdot tikai no izvēlētajām iekārtām",
        "empty": "Iekārtu nav.",
        "loading": "Ielādē uzņēmumu iekārtas…",
        "include": "Iekļaut {device}",
        "device": "Iekārta",
        "company": "Uzņēmums",
        "obligations": "Saistības",
        "mandate_count": "{n} mandātu | {n} mandāts | {n} mandāti",
        "ppa_count": "{n} PPA līgumu | {n} PPA līgums | {n} PPA līgumi",
        "obligations_note": "Viss, kas jau pieprasa šo iekārtu: nākotnes pārdošanas mandāti, kuriem tā pieder (pārklāšanās ir atļauta, konkurē piedāvātie apjomi), un PPA līgumi, kas to aptver. PPA tiek apkalpots pirms nākotnes darījumiem, tāpēc tā apjoms nekad nenonāk līdz saistībām. Iekārta, kas ir mandātā pēc saražotā, pieder tikai tam un šeit nav pievienojama.",
        "country": "Valsts",
        "technology": "Tehnoloģija",
        "cod": "Ekspluatācijas sākums",
        "support": "Atbalsts",
        "ecolabels": "Ekomarķējumi",
        "estimate": "Prognoze (MWh)",
        "estimate_note": "Prognoze aptver mandāta piedāvātos periodus un jau izslēdz katras iekārtas PPA daļu.",
        "unnamed": "Iekārta {id}",
        "stale_deleted_by_registry": "Reģistrs to ir dzēsis. Noņemiet atzīmi, lai to izņemtu no mandāta.",
        "stale_not_registered": "Vairs nav reģistrēta. Noņemiet atzīmi, lai to izņemtu no mandāta.",
        "include_all": "Iekļaut visas iekārtas"
      },
      "eligibility": {
        "title": "Atbilstība darījumam",
        "description": "Ko šeit atrastu darījums, kas ierobežo katru dimensiju. Katru vērtību nosaka vājākā iekārta.",
        "country_tier": "Valstis",
        "tier": {
          "standard_aib_gc": "Standarta AIB GC",
          "aib_outside_standard": "AIB, ārpus standarta kopuma",
          "pl_be": "Polija / Beļģija",
          "non_aib": "Ārpus AIB",
          "unknown": "Nav noteikts"
        },
        "technology_mix": "Tehnoloģijas",
        "oldest_cod": "Vecākais ekspluatācijas sākuma datums",
        "cod_claim_year": "Pārskata gadam {year} vēlamais ekspluatācijas sākuma datums ir {cutoff} vai vēlāk. Tiek pārbaudīts tikai vecums.",
        "cod_preferred": "Visas iekārtas atbilst šim vēlamajam vecumam.",
        "cod_not_preferred": "Mandāts neatbilst šim vēlamajam vecumam vai trūkst ekspluatācijas sākuma datumu.",
        "cod_standards_note": "Daži ziņošanas standarti ierobežo iekārtas vecumu: piemēram, RE100 pieņem tikai iekārtas, kas nodotas ekspluatācijā vai modernizētas pēdējo 15 gadu laikā.",
        "supported": "Ražošanas atbalsts",
        "ecolabels": "Ekomarķējumi",
        "through_year": "līdz {year}. gadam",
        "ecolabel_requirements": {
          "ekoenergy": "Prasa, lai katru iekārtu būtu iepriekš apstiprinājis EKOenergy.",
          "okpower": "Soldera novērtējums pēc OK-power kritērijiem: katru iekārtu iepriekš apstiprinājis EKOenergy, tā ir bez atbalsta un ir vēja vai saules elektrostacija.",
          "okpower_new": "Soldera novērtējums pēc OK-power kritērijiem: katru iekārtu iepriekš apstiprinājis EKOenergy, tā ir bez atbalsta un ražošanas gadā ir ne vecāka par 5 gadiem saules vai ne vecāka par 4 gadiem vēja elektrostacija."
        },
        "failing_device_count": "neatbilst {count} no {total} iekārtām",
        "failing_device_count_named": "neatbilst {count} no {total} iekārtām: {devices}",
        "blocker_device_count": "{count} no {total} iekārtām",
        "blocker_device_count_named": "{count} no {total} iekārtām: {devices}",
        "no_issues": "Šim kritērijam problēmas nav konstatētas. Joprojām ir spēkā konkrētā darījuma ierobežojumi.",
        "no_devices": "Šajā mandātā nav iekārtu.",
        "all_qualify": "Visas iekārtas atbilst prasībām",
        "guide": {
          "title": "Atbilstības uzlabošana",
          "intro": "Apvienojiet iekārtas, kuras pieņemtu vieni un tie paši pircēji, lai neviena atsevišķa iekārta neliegtu mandātam piedalīties darījumā:",
          "unsupported": "Neatbalstītas hidro, saules un vēja iekārtas no vienas valsts — vienā mandātā. Lielākā daļa pircēju tās pieņem.",
          "biomass": "Biomasa un biogāze — atsevišķā mandātā, jo daudzi pircēji tās izslēdz.",
          "issuance": "Iekārtas reģistros, kuros izcelsmes apliecinājumus neizsniedz katru mēnesi, — atsevišķā mandātā ar perioda garumu, kas atbilst tam, cik bieži reģistrs tos izsniedz.",
          "several_mandates": "Uzņēmums var būt vairākos mandātos. Lai šajā mandātā iekļautu tikai daļu tā iekārtu, sadaļā {section} ieslēdziet “{option}” un atzīmējiet iekļaujamās iekārtas."
        }
      },
      "commitments": {
        "title": "Šī mandāta saistības",
        "description": "Kas no tās ir pārdots.",
        "loading": "Notiek saistību ielāde",
        "empty": "No šī mandāta nekas nav pārdots.",
        "all_completed": "Visas šī mandāta saistības ir pabeigtas.",
        "show_completed": "Rādīt pabeigtās ({count})",
        "period": "Ražošanas periods",
        "escrowed": "Deponēts",
        "window": "Piegādes logs",
        "status": "Statuss",
        "deal": "Darījums",
        "open_deal": "Atvērt darījumu",
        "committed_on": "Saistības uzņemtas",
        "on_or_before": "ne vēlāk kā {date}"
      },
      "escrow_remaining": {
        "description": "Jūsu uzņēmumi vairs nav šajā mandātā, taču zemāk norādītie sertifikāti paliek depozītā, līdz ar tiem segtās piegādes ir nosūtītas vai atgrieztas. Nekas cits par mandātu netiek rādīts.",
        "empty": "Šajā mandātā jums nekas nav palicis.",
        "period": "Periods",
        "escrowed": "Depozītā",
        "status": "Darījuma statuss",
        "window_end": "Piegāde līdz"
      },
      "editor": {
        "loading": "Notiek mandāta ielāde",
        "not_found_title": "Šis nākotnes pārdošanas mandāts nav pieejams",
        "not_found_body": "Tā neeksistē vai pieder uzņēmumiem, kuriem jums nav piekļuves.",
        "title": "Nākotnes pārdošanas mandāts",
        "new_title": "Jauns nākotnes pārdošanas mandāts",
        "description": "Nākotnes pārdošanas mandāts nosaka, kādu apjomu tā uzņēmumi piedāvā nākotnes pārdošanai un no kurām iekārtām.",
        "name": "Nosaukums",
        "name_hint": "Redzams ikvienam, kas redz šo mandātu, tostarp dalībuzņēmuma īpašniekiem, kuri to nevar atvērt, un Soldera, veidojot darījumus. Nosauciet grupu un to, ko tā pārdod, piem., “Acme vējš 2027”. Neiekļaujiet pircēju nosaukumus un cenas.",
        "mandate_description": "Apraksts",
        "mandate_description_hint": "Piezīmes dalībuzņēmumiem, piemēram, par grupas vienošanos, kontaktpersonu vai citu, kas jāņem vērā, pārdodot šo mandātu. To var lasīt ikviens, kas var atvērt mandātu. Tas ir tikai informatīvs: to, ko var pārdot, nosaka piedāvātie apjomi un iestatījumi.",
        "delete": "Dzēst",
        "confirm_delete": "Dzēst šo mandātu? Pret to nekad nav uzņemtas saistības, tāpēc nekas netiek zaudēts.",
        "archive": "Arhivēt",
        "unarchive": "Atjaunot no arhīva",
        "discard": "Atmest izmaiņas",
        "save": "Saglabāt",
        "save_anyway": "Tomēr saglabāt",
        "save_failed": "Mandātu neizdevās saglabāt. Pārbaudiet veidlapu un mēģiniet vēlreiz.",
        "unsaved_changes": "Jums ir nesaglabātas izmaiņas.",
        "close_confirm": "Aizvērt mandātu un atmest nesaglabātās izmaiņas?",
        "read_only": "Šo mandātu varat skatīt, bet ne mainīt.",
        "details_title": "Nosaukums un apraksts",
        "name_required": "Ievadiet mandāta nosaukumu."
      },
      "wizard": {
        "step_members": "Uzņēmumi un iekārtas",
        "step_listing": "Piedāvājums",
        "step_confirm": "Apstiprināšana",
        "create": "Izveidot mandātu"
      },
      "summary": {
        "title": "Kopsavilkums",
        "companies": "Uzņēmumi",
        "devices": "Iekārtas",
        "devices_all": "Visas iekārtas ({count})",
        "devices_allowlisted": "Nav izvēlēta neviena iekārta | {count} izvēlēta iekārta | {count} izvēlētas iekārtas",
        "listing": "Piedāvājums",
        "obligation_note": "Tie ir precīzi apjomi, nevis ražošanas aplēses. To piedāvāšana nav saistoša, bet, kad darījums ņem apjomu no šī mandāta, tā uzņēmumiem ir juridisks pienākums piegādāt tieši darījuma paņemto apjomu neatkarīgi no tā, cik saražo to iekārtas.",
        "obligation_note_pay_as_produced": "Kad darījums ņem apjomu no šī mandāta, tā uzņēmumiem ir juridisks pienākums piegādāt visu, ko to iekārtas saražo darījuma periodā."
      },
      "cell_sellable_now": "Pārdodams tagad: {value} MWh"
    },
    "sales_strategy": {
      "title": "Pārdošanas stratēģija",
      "help": "Kā šī mandāta piedāvātais apjoms laika gaitā tiek laists pārdošanā. Ražošanas gada pārdošana pa daļām, dažādos laikos, izkliedē tā cenas risku.",
      "split": {
        "asap": "Pēc iespējas ātrāk",
        "half_yearly": "Pārdot divreiz gadā",
        "quarterly": "Pārdot četrreiz gadā"
      },
      "split_help": {
        "asap": "laiž pārdošanā visu uzreiz",
        "half_yearly": "laiž apjomu pārdošanā divās vienādās daļās",
        "quarterly": "laiž apjomu pārdošanā četrās vienādās daļās (ieteicams)"
      },
      "sell_ahead": {
        "label": "Pārdot uz priekšu",
        "help": "Cik liela daļa no katra ražošanas gada tiek pārdota divus gadus pirms ražošanas. Pārējais tiek pārdots gadu pirms ražošanas.",
        "next_year_only": "Tikai nākamais gads",
        "two_years_ahead": "Divus gadus iepriekš",
        "preset": "{percent}%",
        "share_of": "no katra ražošanas gada",
        "lead_next_year": "Katrs ražošanas gads tiek pārdots gadu pirms tā.",
        "lead_ahead": "Katrs ražošanas gads tiek pārdots divu gadu laikā: {early}% divus gadus pirms ražošanas un atlikušie {rest}% gadu pirms tās.",
        "cadence": {
          "asap": "Viss tiek laists pārdošanā 1. janvārī.",
          "half_yearly": "To laiž pārdošanā divās vienādās daļās — 1. janvārī un 1. jūlijā.",
          "quarterly": "To laiž pārdošanā četrās vienādās daļās — 1. janvārī, 1. aprīlī, 1. jūlijā un 1. oktobrī."
        },
        "cadence_ahead": {
          "asap": "Katru daļu laiž pārdošanā uzreiz, 1. janvārī.",
          "half_yearly": "Katru daļu laiž pārdošanā divās vienādās daļās — 1. janvārī un 1. jūlijā.",
          "quarterly": "Katru daļu laiž pārdošanā četrās vienādās daļās — 1. janvārī, 1. aprīlī, 1. jūlijā un 1. oktobrī."
        },
        "bar_caption": "Piemērs: kā tiek pārdota {year}. gada ražošana",
        "bar_segment": "{year} · {percent}%",
        "release_more": "Saglabājot uzreiz tiks laisti pārdošanā vēl {mwh} MWh no {year}. gada ražošanas, jo tās agrākie pārdošanas logi jau ir atvērušies.",
        "release_less": "Saglabājot tiks aizturēti {mwh} MWh no {year}. gada ražošanas, kas šodien ir laisti pārdošanā."
      },
      "summary": "{split}, {horizon}",
      "summary_split": {
        "asap": "pēc iespējas ātrāk",
        "half_yearly": "divreiz gadā",
        "quarterly": "četrreiz gadā"
      },
      "summary_next_year": "nākamā gada ražošana",
      "summary_ahead": "{percent}% divus gadus uz priekšu",
      "future_only": "Izmaiņas attiecas tikai uz turpmākajiem pārdevumiem. Jau saistītais apjoms paliek spēkā.",
      "schedule_title": "Pārdošanas grafiks",
      "schedule_open": "Rādīt pārdošanas grafiku",
      "schedule_pending": "Pārdošanas grafiks parādīsies šeit, kad mandāta priekšskatījums būs pieejams.",
      "schedule_empty": "Nākamajiem ražošanas gadiem vēl nekas nav piedāvāts.",
      "schedule_timeline": "{year}. gada pārdošanas grafiks",
      "schedule_production": "Ražošana",
      "schedule_auction": "Q{quarter} izsole",
      "schedule_total": "Kopā",
      "schedule_opens_on": "Atveras {date}",
      "schedule_group_early": "{year}. gada ražošana · agrā daļa {percent}%",
      "schedule_group_early_note": "(atlikušie {percent}% {year}. gadā)",
      "schedule_group_rest": "{year}. gada ražošana · atlikušie {percent}%",
      "schedule_group_rest_note": "({percent}% laisti pārdošanā {year}. gadā)",
      "commitments_stand_inline": "Dažas saistības pārsniedz to, ko šī stratēģija šodien laiž pārdošanā. Tās paliek spēkā; stratēģija attiecas uz jauniem pārdošanas darījumiem.",
      "held_back": "Pārdošanas stratēģija ({strategy}) aiztur {mwh} MWh.",
      "held_back_next_release": "Pārdošanas stratēģija ({strategy}) aiztur {mwh} MWh; vēl {next} MWh tiks laisti pārdošanā {date}.",
      "held_back_reason": "aiztur pārdošanas stratēģija",
      "held_back_reason_until": "aiztur pārdošanas stratēģija līdz {date}",
      "override": {
        "label": "Ignorēt visas pārdošanas stratēģijas (BĪSTAMI)",
        "banner_title": "Pārdošana pārsniedz ražotāja pārdošanas stratēģiju",
        "subject": "{mandate}: {period}",
        "beyond_line": "{subject} — {mwh} MWh pāri pārdošanas stratēģijai ({strategy}).",
        "beyond_line_next_release": "{subject} — {mwh} MWh pāri pārdošanas stratēģijai ({strategy}); nākamā laišana pārdošanā {date}.",
        "ignored_nothing_beyond": "Pārdošanas stratēģija tiek ignorēta — neviens paņemtais apjoms to vēl nepārsniedz",
        "ignored_figures_unknown": "Pārdošanas stratēģija tiek ignorēta — tās rādītājus neizdevās nolasīt; saglabāšana norādīs apjomu, kas to pārsniedz"
      }
    },
    "picker": {
      "mode": {
        "existing_inventory": "Esošie krājumi",
        "future_inventory": "Nākotnes ražošana"
      },
      "new_pap_deal": "Jauns darījums pēc saražotā →",
      "deal": {
        "title": "Darījums",
        "description": "Pircēju, cenas un piegāžu plānu nosaka darījuma lapā, kad šis melnraksts ir izveidots."
      },
      "filters": {
        "title": "Ražošanas periods un ātrie filtri"
      },
      "mandates": {
        "title": "Izvēlieties mandātus"
      },
      "cancel": "Atcelt",
      "confirm": "Izveidot darījuma melnrakstu",
      "confirming": "Veido…",
      "footer_note": "Darījuma izveide saglabā melnrakstu ar vienu saistību katram mandātam un piegāžu sagatavi. Pircēja dati, cenas un piegāžu plāns tiek noteikti darījuma lapā.",
      "criteria": {
        "description": "Ar ko pircējs uzņemas saistības. Darījumam šie kritēriji ir saistoši visu tā darbības laiku.",
        "name": "Darījuma nosaukums",
        "name_placeholder": "piem., Nordic buyer 2026",
        "description_label": "Apraksts",
        "description_placeholder": "Neobligāts teksts rēķina rindai",
        "countries": "Valstis",
        "countries_all": "Jebkura valsts",
        "countries_hint": "Iepriekš aizpildīts ar standarta AIB GC valstīm. Notīriet lauku, lai atļautu jebkuru valsti.",
        "technologies": "Tehnoloģijas",
        "technologies_all": "Jebkura tehnoloģija",
        "technologies_advanced": "Papildu",
        "cod_from": "Ekspluatācijā no",
        "cod_until": "Ekspluatācijā līdz",
        "cod_hint": "Ierobežo darījumu ar iekārtām, kuru ekspluatācijas sākuma datums ir šajā diapazonā.",
        "cod_calculator": "COD kalkulators",
        "cod_calculator_modal": {
          "title": "COD kalkulators",
          "description": "Iestata ekspluatācijas sākuma datumu tā, lai piegādes dienā neviena iekārta nebūtu vecāka par maksimālo vecumu.",
          "delivery_date": "Piegādes datums",
          "max_age": "Iekārtas maksimālais vecums piegādes brīdī",
          "years": "gadi",
          "result": "Ekspluatācijā no {date}",
          "apply": "Piemērot"
        },
        "support": "Ražošanas atbalsts",
        "support_any": "Jebkurš",
        "support_no": "Tikai bez atbalsta",
        "ecolabels": "Ekomarķējumi",
        "ecolabels_all": "Ekomarķējuma prasību nav",
        "ecolabels_hint": "OK-power new beidzas līdz ar iekārtas vecumu, tāpēc mandāts var atbilst agrākam ražošanas gadam un neatbilst vēlākam.",
        "min_price_filter": "Slēpt mandātus ar cenu virs",
        "min_price_filter_hint": "Tikai skata filtrs. Tas netiek saglabāts kopā ar darījumu.",
        "quick_filters": "Ātrie filtri",
        "quick_aib_gc": "Standarta AIB GC",
        "quick_hsw": "HSW",
        "quick_biomass": "@:common.technology.biomass",
        "quick_nuclear": "Kodolenerģija",
        "name_required": "Norādiet darījuma nosaukumu."
      },
      "ecolabel": {
        "ekoenergy": "EKOenergy iepriekš apstiprināts",
        "okpower": "Saderīgs ar OK-power",
        "okpower_new": "Saderīgs ar OK-power new"
      },
      "period": {
        "title": "Ražošanas ceturkšņi",
        "from": "No",
        "until": "Līdz",
        "invalid_range": "Diapazons beidzas pirms sākuma.",
        "selected": "{count} ceturkšņi: {periods}",
        "cover_note": "Katrs mandāts pārdod diapazonu savā platumā: pa ceturkšņiem, ja to ļauj tā piedāvājumi un reģistrs, citādi pa pusgadiem vai gadiem. Mandāts, kas nevar segt visu diapazonu, netiek iekļauts. Katra daļa tiek piegādāta pēc ceturkšņa, ar kuru tā beidzas."
      },
      "take": {
        "filter_mandate": "Mandāts vai uzņēmums",
        "auto_distribute": "Sadalīt automātiski",
        "spread": "Izlīdzināt starp mandātiem",
        "target": "MWh",
        "target_label": "Mērķa apjoms",
        "clear": "Notīrīt",
        "hidden_takes": "Filtru paslēptie izvēlētie mandāti: {count} ({mwh} MWh).",
        "show_hidden_takes": "Rādīt tās",
        "remove_hidden_takes": "Noņemt to apjomus",
        "mandate": "Mandāts",
        "technology": "Tehnoloģija",
        "country": "Valsts",
        "cod": "Vecākā ekspluatācija",
        "ecolabels": "Ekomarķējumi",
        "support": "Atbalsts",
        "conditions": "Nosacījumi",
        "take": "Ņemt (MWh)",
        "no_floor": "Nav zemākās robežas",
        "floor_value": "{value} €/MWh",
        "contango": {
          "any": "pārdod tikai contango gadījumā",
          "at_least_20_percent": "pārdod tikai ≥ 20% virs tūlītējās cenas"
        },
        "contango_filter": {
          "none": "Bez contango nosacījuma",
          "any": "Jebkāds contango",
          "at_least_20_percent": "Contango ≥ 20%"
        },
        "cadence": "Šīs iekārtas izdod sertifikātus platākos periodos nekā mandāta daļas šajā diapazonā.",
        "allocation_not_ready": "Sadale ir izslēgta: {companies}. Viņu vārdā nekas netiks deponēts.",
        "capacity_cap": "Izvēlētajā diapazonā ne vairāk kā {value} MWh.",
        "capacity_period": "{period}: {value}",
        "row_subtitle": "{companies} · {devices}",
        "empty": "Neviens mandāts nevar segt šo produktu šajā diapazonā.",
        "loading": "Meklē mandātus",
        "refreshing": "Atjaunina",
        "refresh_pending": "Pirms darījuma izveides uzgaidiet, kamēr mandātu tabula atjaunojas.",
        "load_failed": "Mandātu tabulu neizdevās ielādēt.",
        "hint_floor": "Šīs izvēles piegādi nedrīkst cenot zemāk par {value} €/MWh.",
        "warnings_title": "Vērts pārbaudīt",
        "contango_check": {
          "any": "Pārbaudiet spot cenu manuāli (contango)",
          "at_least_20_percent": "Pārbaudiet spot cenu manuāli (contango 20%)"
        },
        "ineligible_title": "Izslēgtās ({count})",
        "ineligible_hint": "Mandāti, kurus varētu izmantot, bet kurus šis produkts vai diapazons izslēdz."
      },
      "summary": {
        "all": "Visi mandāti",
        "taken": "Paņemts",
        "mandates_count": "{count} mandāti",
        "by_period": "Pēc ražošanas perioda",
        "by_period_estimate": "Aptuvens sadalījums. Precīzo nosaka darījuma izveidē.",
        "by_country": "Pēc valsts",
        "by_price": "Pēc cenas nosacījuma",
        "by_technology": "Pēc tehnoloģijas",
        "by_cod": "Ekspluatācijas sākuma datums",
        "re100": "RE100 atbilstība",
        "by_ecolabel": "Ekomarķējuma statuss",
        "by_support": "Atbalsta statuss",
        "cod_young": "COD ≤5 gadi",
        "cod_middle": "COD 6–15 gadi",
        "cod_old": "COD >15 gadi",
        "mandate_qualifications": "Īpašības raksturo veselus mandātus, nevis piešķirtos sertifikātus. COD izmanto vecāko iekārtu; RE100 un ekomarķējumiem visām iekārtām jāatbilst visā periodā.",
        "judged_at": "vērtēts uz {date}",
        "nothing_taken": "Vēl nekas nav paņemts."
      },
      "errors": {
        "no_takes": "Paņemiet apjomu vismaz no viena mandāta.",
        "create_failed": "Darījumu neizdevās izveidot.",
        "over_capacity": "Kāds paņemtais apjoms pārsniedz to, ko mandāts drīkst pārdot. Vispirms samaziniet to līdz mandāta robežai."
      }
    },
    "pap": {
      "title": "Jauns darījums pēc saražotā",
      "description": "Darījums pēc saražotā pērk viena mandāta visu produkciju mēnesi pēc mēneša saskaņā ar noteiktu grafiku.",
      "mandate": "Mandāts pēc saražotā",
      "mandate_hint": "Šo darījumu var segt tikai mandāti pēc saražotā; to iekārtas nepieder nevienam citam mandātam.",
      "mandate_empty": "Mandāta pēc saražotā vēl nav. Vispirms izveidojiet to ražotāja darblapā.",
      "mandate_devices": "{devices} iekārtas · {companies} uzņēmumi",
      "mandate_blocked_choose_another": "Lai izveidotu darījumu, izvēlieties citu mandātu.",
      "name": "Darījuma nosaukums",
      "name_placeholder": "piem., Hidro produkcija 2027",
      "description_label": "Apraksts",
      "description_placeholder": "Neobligāts teksts rēķina rindai",
      "unit_price": "Vienības cena",
      "unit_price_hint": "Katrs līguma mēnesis tiek rēķināts par šo cenu.",
      "window": "Līguma periods",
      "window_start": "Pirmais mēnesis",
      "window_end": "Pēdējais mēnesis",
      "window_invalid": "Periods beidzas pirms sākuma.",
      "window_missing": "Izvēlieties perioda pirmo un pēdējo mēnesi.",
      "window_too_long": "Līguma periods aptver ne vairāk kā {count} mēnešus.",
      "schedule": "Noteiktais grafiks",
      "schedule_hint": "Viens mērķis katram perioda mēnesim. Produkciju salīdzina ar to mēnesi pēc mēneša.",
      "schedule_total": "{value} MWh {count} mēnešos",
      "tolerance": "Apjoma pielaide",
      "tolerance_hint": "Cik daudz mēnesis drīkst atšķirties no mērķa, pirms tas tiek atzīmēts.",
      "context_failed": "Neizdevās ielādēt īpašnieka izvēles.",
      "create": "Izveidot darījumu",
      "creating": "Veido…",
      "cancel": "Atcelt",
      "create_failed": "Darījumu neizdevās izveidot.",
      "load_failed": "Mandātus neizdevās ielādēt.",
      "loading": "Ielādē mandātus",
      "production_range_from_until": "Šis mandāts pārdod tikai saražoto no {from} līdz {until}.",
      "production_range_from": "Šis mandāts pārdod tikai saražoto no {from}.",
      "production_range_until": "Šis mandāts pārdod tikai saražoto līdz {until}.",
      "window_outside_range": "Līguma periodam jāietilpst šī mandāta pārdodamā saražotā robežās."
    },
    "transaction_header": {
      "title": "Nākotnes piegāde",
      "deal": "Darījums",
      "window_open": "Piegāde ne vēlāk kā {date}",
      "window_range": "Piegāde no {start} līdz {end}",
      "escrowed_of_planned": "{escrowed} no {planned} MWh deponēti",
      "managed_note": "Pozīcijas, apjomi, pircēja dati un cenas nāk no darījuma, un tos maina tur.",
      "open_deal": "Atvērt darījumu",
      "deal_notes": "Darījuma iekšējās piezīmes",
      "delivery_notes": "Piegādes iekšējās piezīmes"
    },
    "deals": {
      "loading": "Ielādē darījumu…",
      "not_found_title": "Darījums nav atrasts",
      "not_found_body": "Šāda darījuma nav vai tas jums nav pieejams.",
      "load_failed_title": "Darījumu neizdevās ielādēt",
      "load_failed_body": "Mūsu pusē kaut kas nogāja greizi. Mēģiniet vēlreiz pēc brīža.",
      "draft_warning": "Darījuma melnraksts: tā piegādes netiek rādītas sadaļā “Gaidāmās piegādes”, un sertifikāti netiek piešķirti, kamēr darījums nav apstiprināts.",
      "common": {
        "cancel": "Atcelt",
        "close": "Aizvērt",
        "commitment_gone": "Šis saistītais apjoms vairs nav darījumā."
      },
      "header": {
        "back": "← Nākotnes darījumi",
        "buyer": "Pircējs: {buyer}",
        "buyer_missing": "Pircējs vēl nav ievadīts",
        "signed_at": "parakstīts {date}"
      },
      "badges": {
        "escrow_shortfall": "depozītā trūkst {mwh} MWh",
        "infeasible": "{mandate} nespēj nosegt periodu {period} — trūkst {mwh} MWh",
        "stale_draft": "Vecs melnraksts",
        "drift_report": "{count} iekārtu vairs neatbilst | {count} iekārta vairs neatbilst | {count} iekārtas vairs neatbilst",
        "drift_report_line": "{device}: {reasons}",
        "device_number": "Iekārta {id}",
        "free_escrow": "{mwh} MWh depozīta gaida atgriešanu"
      },
      "metadata": {
        "title": "Pircējs un līgums",
        "edit": "Rediģēt",
        "edit_title": "Pircēja un līguma dati",
        "save": "Saglabāt",
        "name": "Darījuma nosaukums",
        "description": "Apraksts",
        "buyer": "Pircējs",
        "emails": "Pircēja e-pasta adreses",
        "registration_authority": "Reģistra pārvaldītājs",
        "billing_country": "Norēķinu valsts",
        "deal_volume": "Darījuma apjoms",
        "signed_at": "Parakstīts",
        "created_at": "Izveidots",
        "confirmed_at": "Apstiprināts",
        "links": "Saites",
        "contract_links": "Līgums",
        "transaction_link": "Darījums",
        "offering_sheets": "Piedāvājuma lapas",
        "offering_sheets_help": "Ar komatiem atdalītas saites, vecākā pirmā. Lapas ģenerēšana pievieno saiti šeit; kad saraksts ir pilns, dzēsiet vecās šeit.",
        "transaction_link_invalid": "Ievadiet vienu saiti, kas sākas ar http:// vai https://.",
        "shipped_keep_details": "Šim darījumam ir nosūtītas {count} piegādes. To darījumi un rēķini saglabā pircēja un līguma datus, ar kuriem tās tika nosūtītas; šeit veiktās izmaiņas attiecas tikai uz vēl nenosūtītām piegādēm. | Šim darījumam ir nosūtīta {count} piegāde. Tās darījums un rēķini saglabā pircēja un līguma datus, ar kuriem tā tika nosūtīta; šeit veiktās izmaiņas attiecas tikai uz vēl nenosūtītām piegādēm. | Šim darījumam ir nosūtītas {count} piegādes. To darījumi un rēķini saglabā pircēja un līguma datus, ar kuriem tās tika nosūtītas; šeit veiktās izmaiņas attiecas tikai uz vēl nenosūtītām piegādēm.",
        "not_set": "Nav norādīts"
      },
      "criteria": {
        "title": "Atbilstības kritēriji",
        "edit": "Rediģēt",
        "save": "Saglabāt kritērijus",
        "locked": "Slēgts",
        "countries": "Valstis",
        "technologies": "Tehnoloģijas",
        "cod": "Nodošanas ekspluatācijā datums",
        "cod_from": "Ekspluatācijā no",
        "cod_until": "Ekspluatācijā līdz",
        "cod_range": "{from} — {until}",
        "any": "jebkurš",
        "support": "Ražošanas atbalsts",
        "support_any": "Jebkurš",
        "support_unsupported_only": "Tikai bez atbalsta",
        "ecolabels": "Ekomarķējumi",
        "unrestricted": "Bez ierobežojumiem",
        "conflicts_help": "Saglabājot izmaiņas vispirms tiek pārbaudītas. Izmaiņas, kas ir pretrunā ar segumu vai depozītu, ko darījums vēl piegādā, tiek noraidītas; nekas netiek atbrīvots vai atgriezts.",
        "conflicts_blocking": "Šīs izmaiņas ir pretrunā ar to, ko darījums vēl piegādā. Vispirms novērsiet šo un saglabājiet vēlreiz:",
        "conflicts_warning": "Jau piegādāts saskaņā ar pašreizējiem kritērijiem. Saglabājot tie paliek nemainīti:",
        "save_anyway": "Tomēr saglabāt",
        "ecolabel": {
          "ekoenergy": "EKOenergy iepriekš apstiprināts",
          "okpower": "OK-power saderīgs",
          "okpower_new": "OK-power new saderīgs"
        }
      },
      "plan": {
        "delivery_id": "Piegādes ID {id}",
        "profile": {
          "title": "Aplēstais profils",
          "judged_at": "Iekārtu vecums tiek vērtēts uz piegādes loga beigām, {date}."
        },
        "title": "Piegādes plāns",
        "generate_offering_sheet": "Izveidot piedāvājuma lapu",
        "offering_sheet_link": "Atvērt jaunāko piedāvājuma lapu",
        "edit_plan": "Rediģēt plānu",
        "empty": "Šim darījumam vēl nav piegāžu.",
        "delivery": "Piegāde",
        "period": "Ražošanas periods",
        "escrowed_of": "Deponēts / plānots",
        "backed_by": "Nodrošina",
        "backed_by_commitment": "Sedz saistība {id}. Sk. Saistību tabulu.",
        "open_volume": "Nesegts",
        "no_slices": "Šajā piegādē vēl nekas nav plānots.",
        "n_short": "trūkst {mwh}",
        "n_open": "nesegti {mwh}",
        "remove": "Noņemt",
        "actions": {
          "menu": "Darbības: {period}",
          "resize": "Mainīt apjomu",
          "resize_tooltip": "Mainiet šī ražošanas perioda saistīto apjomu. To nevar samazināt zem jau deponētā apjoma.",
          "split_move": "Sadalīt un pārvietot",
          "split_move_tooltip": "Pārvietojiet visu šo saistīto apjomu vai tā daļu uz citu piegādi; depozīts pārvietojas līdzi.",
          "narrow": "Sašaurināt",
          "narrow_tooltip": "Sadaliet saistīto ražošanas periodu īsākos periodos, piemēram, gadu ceturkšņos, nemainot kopējo apjomu.",
          "remove_backing": "Noņemt segumu",
          "remove_backing_tooltip": "Noņemiet mandāta segumu no šī apjoma, atstājot to atvērtu citam mandātam.",
          "remove_backing_escrowed_tooltip": "Pret šo apjomu ir deponēti {mwh} MWh. Atgrieziet tos īpašniekam, pirms noņemat segumu.",
          "pull_to_escrow": "Ievilkt depozītā…",
          "pull_to_escrow_tooltip": "Atlasiet pieejamos sertifikātus no šī mandāta un pārvietojiet tos depozītā šīm saistībām.",
          "back": "Nosegt…",
          "back_tooltip": "Nosedziet šo atvērto apjomu ar saistībām no atbilstoša mandāta."
        },
        "window_on_or_before": "Ne vēlāk kā {end}",
        "window_range": "{start} — {end}",
        "unit_price": "{price} €/MWh",
        "no_price": "Cena nav norādīta",
        "delivery_shortfall": "trūkst {mwh} MWh",
        "deliver": "Piegādāt →",
        "deliver_anyway": "Piegādāt tik un tā",
        "transaction_link": "Darījums #{id}",
        "outside_window_title": "Ārpus piegādes loga",
        "outside_window_body": "Šodiena ir ārpus šīs piegādes loga ({window}). Piegādāt tik un tā?",
        "summary_open": "{mwh} MWh nesegti",
        "summary_fully_committed": "Viss plānotais apjoms ir saistīts",
        "summary_totals": "{planned} plānoti · {committed} saistīti · {escrowed} depozītā",
        "summary_deal_volume": "darījuma apjoms {mwh} MWh",
        "summary_no_deal_volume": "darījuma apjoms nav saglabāts",
        "confirm": "Apstiprināt darījumu",
        "cancel_deal": "Atcelt darījumu",
        "cancel_title": "Atcelt šo darījumu?",
        "cancel_body": "Atcelšana atbrīvo visus saistītos apjomus un anulē visus nepiegādātos melnrakstus. Jau depozītā esošais apjoms paliek līdz atgriešanai īpašniekiem.",
        "cancel_body_pap": "Atceļot tiek anulēti visi vēl nepiegādātie mēneši. Šiem mēnešiem jau depozītā esošie sertifikāti gaidīs atgriešanu: atgrieziet tos īpašniekiem kartītē “Depozīts gaida atgriešanu”. Jau piegādātie mēneši paliek nemainīti.",
        "unconfirm": "Atpakaļ uz melnrakstu",
        "unconfirm_title": "Atgriezt šo darījumu melnrakstā?",
        "unconfirm_body": "Darījums iziet no sadales rindas, tāpēc tam vairs netiek novirzīti sertifikāti depozītā, un tā kritērijus atkal var rediģēt. Saistītie apjomi paliek, tāpēc apjoms joprojām ir rezervēts. Bez parakstīšanas datuma piegādes zaudē cenas datumu. Atkārtoti apstiprinot, darījums nonāk rindas beigās."
      },
      "editor": {
        "title": "Plāna rediģēšana",
        "discard": "Atmest",
        "save": "Saglabāt plānu",
        "window_start": "Loga sākums · neobligāts",
        "window_end": "Loga beigas",
        "unit_price": "Vienības cena",
        "remove_delivery": "Noņemt piegādi",
        "add_period": "Pievienot periodu",
        "add_delivery": "Pievienot piegādi",
        "period_placeholder": "2026-Q1, 2026-04 vai 2026",
        "planned_for": "Plānotais apjoms periodā {period}",
        "backed_caption": "{mwh} MWh segti",
        "below_backed": "Šeit ir segti {mwh} MWh. Plānojiet vismaz tik daudz.",
        "remove_row_backed": "{mwh} MWh ir segti. Vispirms noņemiet segumu plānā.",
        "duplicate_period": "Šis ražošanas periods šajā piegādē jau ir."
      },
      "correction": {
        "editor_hint": "Piegādāto un anulēto piegāžu periodi paliek nemainīgi. Kā superadministrators jūs joprojām varat labot to logu un cenu; jau izveidotie rēķini paliek nemainīgi.",
        "schedule_hint": "Piegādāta mēneša cenu var labot. Jau izveidotie rēķini saglabā veco cenu.",
        "voided_delivery": "Šī piegāde ir anulēta: izmaiņas redzamas tikai darījuma lapā, un tās nenolasa neviens rēķins vai pārskats.",
        "buyer_invoice_replaceable": "Pircēja rēķins {number} saglabā veco cenu. Izveidojiet to no jauna, ja tas vēl nav nosūtīts.",
        "buyer_invoice_sent": "Pircēja rēķins {number} ir nosūtīts un saglabā veco cenu. To vairs nevar izveidot no jauna.",
        "completion_invoices_issued": "Pabeigšanas brīdī izrakstītā ražotāja izmaksa un iespējamā komisija saglabā veco cenu.",
        "dashboard_period_moves": "Neviens rēķins nenolasa piegādes logu. Tikai finanšu pārskats pārvieto pārdošanu uz jaunā loga beigu periodu."
      },
      "commitments": {
        "title": "Saistītie apjomi",
        "empty": "Šim darījumam vēl nav seguma.",
        "description": "Katra rinda ir viena apjoma paņemšana no mandāta. Apjoms un cenas nosacījumi tika fiksēti paņemšanas brīdī; mandāta piedāvājums un cenas kopš tā laika var būt mainījušās.",
        "granularity": "Detalizācija: {width}",
        "id_header": "ID",
        "mandate_header": "Mandāts",
        "pulled_on": "Ņemts",
        "volume": "Deponēts / saistīts",
        "price_conditions": "Cenas nosacījumi",
        "released": "Atbrīvots",
        "released_tooltip": "Diena, kad šis nodrošinājums tika pilnībā noņemts: apjoms atgriezās mandāta pieejamībā un saistība vairs nepretendē uz tā krājumiem.",
        "floor": "apakšējā robeža {price} €/MWh",
        "no_floor": "bez apakšējās robežas",
        "contango": {
          "any": "tikai contango gadījumā",
          "at_least_20_percent": "tikai ≥ 20% virs tūlītējās cenas"
        },
        "show_escrow": "Deponēts…",
        "show_escrow_tooltip": "Parādīt, kuru uzņēmumu sertifikāti sedz šo saistību; galvenais administrators var tos no šejienes atgriezt īpašniekiem.",
        "contributions": "Ieguldījumi · depozīts pa uzņēmumiem",
        "escrow_title": "{mandate} · paņemts {date}",
        "company": "Uzņēmums",
        "no_escrow": "Pret šo apjomu vēl nekas nav depozītā.",
        "entry_width": {
          "quarter": "ceturkšņa",
          "month": "mēneša",
          "half_year": "pusgada",
          "year": "gada"
        },
        "pay_as_produced": "pēc saražotā",
        "strategy_overridden": "Pārdots pāri pārdošanas stratēģijai",
        "sold_beyond_strategy": "{mandate} — {mwh} MWh pārdoti pāri pārdošanas stratēģijai."
      },
      "free_escrow": {
        "title": "Depozīts gaida atgriešanu",
        "subtitle": "{mwh} MWh, kam vairs nav aktīvas piegādes",
        "return": "Atgriezt īpašniekam…",
        "company": "Uzņēmums",
        "period": "Ražošanas periods"
      },
      "add_commitment": {
        "title_back": "Nosegt {period}",
        "submit": "Pievienot apjomu",
        "search": "Meklēt mandātus",
        "search_placeholder": "Ievadiet daļu no mandāta nosaukuma",
        "searching": "Meklē mandātus…",
        "no_mandates": "Neviens jums pieejams mandāts neatbilst šai meklēšanai.",
        "listed": "piedāvāti {mwh} MWh",
        "no_availability": "{period} nav nekā pieejama",
        "takes_title": "Cik daudz ņemt no šī perioda",
        "open": "Nesegts",
        "take": "Ņemt",
        "take_for": "Ņemamais apjoms periodā {period}",
        "max": "līdz {mwh}",
        "over_max": "šeit var ņemt ne vairāk kā {mwh} MWh",
        "impact": "Nesegtais apjoms samazinās no {from} MWh līdz {to} MWh.",
        "submit_beyond_strategy": "Pievienot apjomu pāri pārdošanas stratēģijai"
      },
      "resize": {
        "title": "Mainīt saistīto apjomu",
        "submit": "Mainīt",
        "body": "{period} · {mandate} · šobrīd saistīti {mwh} MWh.",
        "new_volume": "Jaunais saistītais apjoms",
        "escrow_floor": "Pret šo daļu jau ir {mwh} MWh depozītā, tāpēc zemāk nevar iet.",
        "shrink_warning": "Atdotie {mwh} MWh kļūst atvērti un atgriežas mandāta pieejamajā apjomā. Saistības pārējam apjomam saglabā savus fiksētos cenas nosacījumus; šī apjoma atkārtota segšana vēlāk ir jaunas saistības ar tās dienas nosacījumiem.",
        "submit_beyond_strategy": "Mainīt pāri pārdošanas stratēģijai"
      },
      "move": {
        "title": "Pārvietot vai sadalīt",
        "submit": "Pārvietot",
        "body": "{period} · {mwh} MWh. Jau depozītā esošais apjoms seko līdzi.",
        "target": "Mērķa piegāde",
        "target_placeholder": "Izvēlieties piegādi",
        "volume": "Pārvietojamais apjoms",
        "volume_placeholder": "Visa daļa",
        "volume_hint": "Atstājiet tukšu, lai pārvietotu visu daļu.",
        "volume_out_of_range": "no 1 līdz {mwh} MWh, daļas apjoms"
      },
      "narrow": {
        "title": "Sašaurināt periodu",
        "submit": "Sašaurināt",
        "body": "{period} · {mwh} MWh. Apjoms tiek sadalīts pa apakšperiodiem proporcionāli tam, cik mandāts katrā no tiem piedāvā.",
        "width": "Sašaurināt līdz",
        "already_narrowest": "Šis periods jau ir šaurākais iespējamais.",
        "hint": "Jau depozītā esošais apjoms tiek piesaistīts tam apakšperiodam, kuram katrs sertifikāts pieder."
      },
      "remove_backing": {
        "title": "Vai noņemt šī mandāta segumu?",
        "pull": "Ņemts {date} · {conditions}",
        "released_whole": "{mwh} MWh atgriežas mandāta {mandate} pieejamajā apjomā, un šīs saistības tiek atbrīvotas pilnībā, jo šis ir to pēdējais segtais apjoms.",
        "released_part": "{mwh} MWh atgriežas mandāta {mandate} pieejamajā apjomā, un šīs saistības tiek atbrīvotas daļēji, jo to pārējais segtais apjoms paliek.",
        "snapshot_lost": "Ņemšanas brīdī saglabātie cenas nosacījumi tiek zaudēti. Šī apjoma atkārtota segšana vēlāk ir jaunas saistības ar tās dienas mandāta nosacījumiem un tikai tad, ja apjoms vēl ir pieejams.",
        "confirm": "Noņemt segumu"
      },
      "return_escrow": {
        "section_title": "Atgriezt īpašniekam",
        "title": "Atgriezt depozītu īpašniekam",
        "submit": "Atgriezt atlasīto",
        "loading": "Ielādē depozītā esošos sertifikātus…",
        "body": "Atlasītie sertifikāti paliek Soldera reģistra kontā un tiek piešķirti katra īpašnieka jaunam virtuālajam portfelim. Katru rindu var atgriezt arī daļēji.",
        "nothing": "Šim darījumam nekas nav depozītā.",
        "company": "Uzņēmums",
        "device": "Iekārta",
        "month": "Ražošanas mēnesis",
        "escrowed": "Depozītā",
        "return_count": "Atgriezt",
        "select_all": "Atlasīt visas rindas",
        "select_row": "Atlasīt {device}",
        "count_for": "Atgriežamais daudzums no {device}",
        "over_count": "šajā rindā deponēts ne vairāk kā {mwh} MWh",
        "summary_title": "Tiek atgriezts",
        "results_title": "Atgriezti {moved} MWh, {failed} rindas neizdevās.",
        "result_line": "{count} MWh no vienības {item}"
      },
      "pull_escrow": {
        "title": "Ievilkt depozītā",
        "submit": "Ievilkt depozītā",
        "body": "Pārvietojiet sertifikātus, kas pagāja garām nākotnes darījumu solim, uz šī apjoma depozītu. Īpašnieks nemainās.",
        "company": "Uzņēmums",
        "company_placeholder": "Izvēlieties mandāta dalībnieku",
        "source_portfolio": "Avota portfelis",
        "portfolio_placeholder": "Izvēlieties portfeli",
        "allowed_sources": "Ievilkt var tikai no nesadalītajiem, aizturētajiem, spot un virtuālajiem portfeļiem.",
        "loading_items": "Ielādē sertifikātus…",
        "no_items": "Šajā portfelī nav nekā, ko varētu ievilkt.",
        "items_failed": "Sertifikātus neizdevās ielādēt. Lai mēģinātu vēlreiz, aizveriet šo formu un atveriet to no jauna.",
        "after_move": "Šī apjoma depozīts pieaug no {from} MWh līdz {to} MWh no saistītajiem {total} MWh.",
        "results_title": "Pārvietotas {moved} rindas, {failed} rindas neizdevās.",
        "result_line": "{count} MWh no vienības {item}"
      },
      "producer_prices": {
        "button": "Ražotāju cenas…",
        "title": "Ražotāju cenas · {window}",
        "body": "Cik katra mandāta ražotāji izraksta par šo piegādi. Šīs ir Soldera pirkuma cenas, un darījuma īpašniekam tās nekad netiek rādītas.",
        "amount": "MWh",
        "price": "Vienības cena",
        "price_for": "Mandāta {mandate} vienības cena",
        "delivery_price_note": "Tukši atstāts mandāts maksā pašas piegādes cenu: {price}.",
        "trade_owner": "Darījuma starpnieks",
        "trade_owner_help": "Saņem komisijas maksu no mijmaiņas darījuma maržas.",
        "trade_owner_placeholder": "Izvēlieties darījuma starpnieku…",
        "trade_owner_none": "Nav",
        "submit": "Saglabāt",
        "shipped_meanwhile": "Kamēr jūs rediģējāt, šī piegāde tika nosūtīta. Tās cenas tagad ir vēsture, tāpēc jūsu izmaiņas netika saglabātas.",
        "delivery_gone": "Šīs piegādes darījumā vairs nav, tāpēc jūsu izmaiņas netika saglabātas.",
        "blank_price": "tukšs (piegādes cena)",
        "default_price": "Ražotāja noklusējuma cena",
        "default_price_help": "Katrs tukši atstātais mandāts maksā šo cenu. Atstājiet tukšu, lai izmantotu pašas piegādes cenu.",
        "default_price_note": "Tukši atstāts mandāts maksā ražotāja noklusējuma cenu: {price}.",
        "default_price_none": "Nav (pašas piegādes cena)",
        "blank_follows_default": "tukšs (ražotāja noklusējuma cena)",
        "no_escrow_yet": "Vēl nav escrow: ražotāju rindas parādīsies šeit, kad pienāks sertifikāti.",
        "mandate_floor": "Minimums {price}",
        "no_mandates": "Šo piegādi vēl neatbalsta neviens mandāts. Atbalstiet tās atvērto apjomu, lai noteiktu ražotāju cenas.",
        "mandate": "Mandāts",
        "mandates_removed": "{count} mandāti pa to laiku pārtrauca atbalstīt piegādi un tika izņemti | {count} mandāts pa to laiku pārtrauca atbalstīt piegādi un tika izņemts | {count} mandāti pa to laiku pārtrauca atbalstīt piegādi un tika izņemti",
        "kept_price": "Vairs neatbalsta",
        "kept_price_help": "Saglabāta no laika, kad šis mandāts atbalstīja piegādi. Tā atkal būs spēkā, ja mandāts atkal atbalstīs piegādi; noņemiet to, ja tai nevajadzētu būt spēkā.",
        "remove_mandate_price": "Noņemt mandāta {mandate} cenu",
        "conflict": "{company} pārdod caur mandātiem {mandates}, bet tā vienīgajā rindā var būt viena cena. Nosakiet šiem mandātiem vienādu cenu vai pārvietojiet viena mandāta daļas atsevišķā piegādē: līdz tam piegādi nevar nosūtīt.",
        "foreseen_conflict": "{company} var pārdot caur mandātiem {mandates}, bet tā vienīgajā rindā var būt viena cena. Pagaidām nekas netiek aizturēts: kad tā depozīts nonāks caur diviem no tiem, piegādi nevarēs nosūtīt, kamēr šiem mandātiem nebūs vienādas cenas vai viena mandāta daļas netiks pārvietotas atsevišķā piegādē.",
        "conflict_badge": "Cenu konflikts"
      },
      "price_conflict": {
        "warning": "Ražotāju cenu konflikts · {window}: {company} pārdod caur mandātiem {mandates}, bet tā vienīgajā rindā var būt viena cena. Piegādi nevar nosūtīt, kamēr šiem mandātiem nav vienādas cenas vai viena mandāta daļas nav pārvietotas atsevišķā piegādē.",
        "foreseen_warning": "Iespējams ražotāju cenu konflikts · {window}: {company} var pārdot caur mandātiem {mandates}, bet tā vienīgajā rindā var būt viena cena. Kad tā depozīts nonāks caur diviem no tiem, piegādi nevarēs nosūtīt, kamēr šiem mandātiem nebūs vienādas cenas vai viena mandāta daļas netiks pārvietotas atsevišķā piegādē.",
        "mandate_at": "{mandate} par {price}",
        "no_price": "piegādes cena (vēl nav noteikta)",
        "and": " un "
      },
      "delivery_notes": {
        "button": "Piezīmes…",
        "title": "Iekšējās piezīmes · {window}",
        "label": "Iekšējās piezīmes",
        "help": "Tikai darbiniekiem: netiek kopētas piegādes darījumā un netiek rādītas ražotājiem vai pircējiem.",
        "submit": "Saglabāt",
        "heading": "Iekšējās piezīmes",
        "default_producer_price": "Ražotāju noklusējuma cena: {price}"
      },
      "pap": {
        "schedule_title": "Nominētais grafiks un pielaide",
        "edit_schedule": "Rediģēt grafiku",
        "save_schedule": "Saglabāt grafiku",
        "window": "{start} — {end}",
        "no_window": "Līguma periods nav norādīts",
        "no_schedule": "Neviens mēnesis vēl nav nominēts.",
        "tolerance": "Pielaide ± {percent} %",
        "mandates": "Mandāti | Mandāts | Mandāti",
        "tolerance_label": "Pielaide ± %",
        "tolerance_hint": "Cik daudz mēnesis drīkst pārsniegt vai nesasniegt nominēto apjomu, pirms tas tiek atzīmēts.",
        "month": "Mēnesis",
        "nominated": "Nominēts",
        "target_for": "Nominētais apjoms mēnesim {month}",
        "monitoring_title": "Mēneša uzraudzība",
        "monitoring_loading": "Ielādē uzraudzību…",
        "monitoring_empty": "Vēl nav ko uzraudzīt.",
        "nominated_vs_escrowed": "Nominēts pret depozītā",
        "delta": "Starpība pret nominēto",
        "status": "Statuss",
        "status_pending": "Gaida",
        "status_within": "Diapazonā",
        "status_over": "Virs diapazona",
        "status_under": "Zem diapazona",
        "status_delivered": "Piegādāts",
        "ship_early_title": "Vai piegādāt šo mēnesi tagad?",
        "ship_early_body": "Šis mēnesis vēl nav noslēdzies: ražošana var turpināties, un tiks piegādāts tikai tas, kas šobrīd ir depozītā. Piegāde iesaldē mēnesi, tāpēc vēlāk par šo mēnesi izsniegtie sertifikāti kļūs par brīvu depozītu, kas jāatgriež manuāli.",
        "ship_early_confirm": "Tomēr piegādāt",
        "sell_price": "Pārdošanas cena",
        "sell_price_for": "Pārdošanas cena mēnesim {month}",
        "sell_price_invalid": "Ievadiet cenu, kas lielāka par 0, ar ne vairāk kā 3 decimāldaļām.",
        "months_shipped": "{months} pa to laiku tika nosūtīti; jūsu izmaiņas šajos mēnešos atmestas | {months} pa to laiku tika nosūtīts; jūsu izmaiņas šajā mēnesī atmestas | {months} pa to laiku tika nosūtīti; jūsu izmaiņas šajos mēnešos atmestas"
      },
      "transaction_status": {
        "DRAFT": "Melnraksts",
        "PENDING_BUYER_DETAILS": "Trūkst pircēja datu",
        "PENDING_CONTRACTS": "Trūkst līgumu",
        "READY_TO_TRANSFER": "Gatavs pārskaitīšanai",
        "DELIVERED": "Piegādāts",
        "COMPLETED": "Pabeigts",
        "voided": "Anulēts"
      },
      "merge": {
        "changed_meanwhile": "Kamēr jūs rediģējāt, kāds cits saglabāja izmaiņas. Jūsu izmaiņas ir saglabātas un apvienotas ar viņa izmaiņām. Pārbaudiet rezultātu un saglabājiet vēlreiz.",
        "unaffected": "Kamēr jūs rediģējāt, darījumu saglabāja kāds cits, taču nekas no šeit redzamā nemainījās. Saglabājiet vēlreiz, lai piemērotu savas izmaiņas.",
        "taken_over": "Pārņemtas {count} saglabātās izmaiņas | Pārņemta {count} saglabātā izmaiņa | Pārņemtas {count} saglabātās izmaiņas",
        "conflicts": "{count} lauki mainīti abās pusēs; zemāk izvēlieties katra vērtību | {count} lauks mainīts abās pusēs; zemāk izvēlieties tā vērtību | {count} lauki mainīti abās pusēs; zemāk izvēlieties katra vērtību",
        "yours": "Jūsu: {value}",
        "saved_now": "Pašlaik saglabāts: {value}",
        "keep_yours": "Paturēt jūsu",
        "use_saved": "Izmantot saglabāto"
      }
    }
  },
  "soldera_inventory": {
    "title": "Soldera krājumi",
    "description": "Izcelsmes apliecinājumi, ko Soldera var piegādāt tūlīt vai no nākotnes ražošanas. Izvēlieties apjomu un nosūtiet Soldera savu piedāvājumu.",
    "not_enabled": "Soldera krājumi jūsu kontam nav pieejami. Lai iegūtu piekļuvi, sazinieties: {email}.",
    "purchase_details": "Pirkuma informācija",
    "counterparty_emails": "Rēķinu e-pasta adreses",
    "counterparty_emails_hint": "Vairākas adreses atdaliet ar komatiem.",
    "price": "Cena",
    "price_hint": "Jūsu cena par sertifikātu (1 MWh). Sertifikāti, par kuriem ražotājs prasa vairāk, netiek rādīti.",
    "select_certificates": "Izvēlieties sertifikātus",
    "create_purchase": "Nosūtīt saistošu piedāvājumu",
    "regions": "Reģioni",
    "blocked": {
      "no_selection": "Izvēlieties sertifikātus, kurus vēlaties iegādāties.",
      "no_price": "Ievadiet cenu, kas lielāka par nulli.",
      "mixed_authorities": "Izvēlieties sertifikātus no vienas sertifikātu shēmas.",
      "no_company": "Izvēlieties uzņēmumu, kura vārdā pērkat."
    },
    "created_title": "Saistošs piedāvājums nosūtīts",
    "created_description": "Jūsu saistošais piedāvājums par {mwh} MWh nosūtīts Solderai. Mēs sazināsimies ar jums, lai to apstiprinātu.",
    "billing_country": "Norēķinu valsts",
    "generate_breakdown": "Izveidot Excel pārskatu",
    "open_breakdown": "Atvērt pārskatu",
    "breakdown_ready_title": "Pārskats gatavs",
    "breakdown_ready_description": "Pārskats atvērts jaunā cilnē un kopīgots ar {email}.",
    "tabs": {
      "spot": "Pieejams tūlīt",
      "forward": "Nākotnes ražošana"
    },
    "forward": {
      "select_mandates": "Izvēlieties nākotnes ražošanu",
      "price_hint": "Jūsu cena par MWh katrai piegādei. Ražošana, par kuru ražotāji prasa vairāk, netiek rādīta.",
      "no_mandates": "Šajos periodos par šo cenu nākotnes ražošana netiek piedāvāta.",
      "spread_over_mandates": "@:forwards.picker.take.spread",
      "by_period": "@:forwards.picker.summary.by_period",
      "all_technologies": "Visas tehnoloģijas",
      "all_countries": "Visas valstis",
      "columns": {
        "technology": "@:forwards.picker.take.technology",
        "country": "@:forwards.picker.take.country",
        "scheme": "Shēma",
        "cod_age": "Vecākais COD (gadi)",
        "support": "@:forwards.picker.take.support",
        "ecolabels": "@:forwards.picker.take.ecolabels",
        "capacity": "Pieejams MWh",
        "take": "Jūsu MWh"
      },
      "blocked": {
        "no_takes": "Ievadiet vēlamo MWh apjomu vismaz no viena mandāta."
      },
      "warnings": {
        "pl_be_mixed": "Jūsu izvēle apvieno {flagged} ar {others}, ko parasti iegādājas kā atsevišķus produktus.",
        "standard_aib_gc_mixed": "Jūsu izvēle apvieno Standard AIB GC valstis ({standard}) ar valstīm ārpus standarta saraksta ({outside}).",
        "technology_mixed": "Jūsu izvēle apvieno {advanced} ar {hsw}; HSW (hidro, saules, vēja) produkti to parasti neietver."
      }
    }
  },
  "inventory_selection": {
    "quick_filters": "@:forwards.picker.criteria.quick_filters",
    "standard_aib_gc": "@:forwards.mandates.eligibility.tier.standard_aib_gc",
    "vintage": "Ražošanas gads",
    "tech_filters": {
      "hsw": "Hidro, saule, vējš",
      "biomass": "@:common.technology.biomass",
      "nuclear": "Kodolenerģija"
    },
    "auto_select": "Automātiska atlase",
    "target": "@:forwards.picker.take.target",
    "target_label": "@:forwards.picker.take.target_label",
    "spread_over_companies": "Sadalīt starp uzņēmumiem",
    "clear": "@:forwards.picker.take.clear",
    "available": "Pieejams",
    "selected": "Izvēlēts",
    "row_count": "{count} ierakstu | {count} ieraksts | {count} ieraksti",
    "breakdowns": {
      "production_months": "Ražošanas mēneši",
      "support_status": "@:forwards.picker.summary.by_support",
      "technology": "@:forwards.picker.take.technology",
      "commercial_operations_date": "@:forwards.picker.summary.by_cod",
      "re100_applicable": "@:forwards.picker.summary.re100",
      "ecolabel_status": "@:forwards.picker.summary.by_ecolabel",
      "supported": "Ar atbalstu",
      "unsupported": "Bez atbalsta",
      "unknown": "@:common.unknown",
      "cod_le_5": "@:forwards.picker.summary.cod_young",
      "cod_6_15": "@:forwards.picker.summary.cod_middle",
      "cod_gt_15": "@:forwards.picker.summary.cod_old",
      "ekoenergy_pre_approved": "@:forwards.picker.ecolabel.ekoenergy",
      "okpower_new_compatible": "@:forwards.picker.ecolabel.okpower_new"
    }
  },
  "device_groups": {
    "group_devices": "Grupēt ierīces",
    "new_group": "Jauna grupa",
    "edit_group": "Rediģēt grupu",
    "groups_title": "Ierīču grupas",
    "all_devices": "Visas ierīces",
    "ungrouped": "Negrupētas",
    "suggested_from_address": "Ieteikts pēc adreses",
    "create_group": "Izveidot grupu",
    "save_group": "Saglabāt grupu",
    "delete_group": "Dzēst grupu",
    "delete_confirm": "Dzēst grupu \"{name}\"? Tās ierīces kļūs negrupētas.",
    "dismiss": "Paslēpt",
    "dismiss_suggestion": "Paslēpt {name}",
    "devices_count": "Nav ierīču | {count} ierīce | {count} ierīces",
    "devices_and_power": "Nav ierīču | {count} ierīce · {power} kW | {count} ierīces · {power} kW",
    "name_label": "Nosaukums",
    "name_placeholder": "Grupas nosaukums",
    "pick_devices": "Izvēlēties ierīces",
    "paste_device_ids": "Ielīmēt ierīču ID",
    "start_from_address": "Sākt no adreses",
    "search_placeholder": "Meklēt pēc ierīces ID, nosaukuma vai adreses",
    "all_technologies": "Visas tehnoloģijas",
    "select_matching": "Izvēlēties {count}",
    "deselect": "Noņemt izvēli",
    "paste_placeholder": "Viens ierīces ID katrā rindā",
    "paste_found": "Atrasti {found} no {total}",
    "paste_not_found": "{id} nav atrasts",
    "paste_in_group": "{id} ir grupā {group}",
    "add_devices": "Pievienot ierīces | Pievienot {count} ierīci | Pievienot {count} ierīces",
    "modal_hint": "Grupa parādās ierīču izvēlnēs tirdzniecības stratēģijā un portfeļa ierīču filtros.",
    "device_column": "Ierīce",
    "group_column": "Grupa",
    "in_group": "Grupā {group}",
    "selected_summary": "Izvēlētas {count} · {power} kW",
    "add_to_group": "Pievienot grupai",
    "new_group_from_selection": "Jauna grupa no izvēlētajām",
    "remove_from_group": "Izņemt no grupas",
    "clear_selection": "Notīrīt izvēli",
    "hint_select_ungrouped": "Izvēlieties negrupētas ierīces, lai pievienotu tās grupai",
    "hint_select_to_remove": "Izvēlieties ierīces, lai izņemtu tās no šīs grupas",
    "select_all_shown": "Izvēlēties visas parādītās ierīces",
    "select_device": "Izvēlēties {device}",
    "group_created": "Grupa \"{name}\" izveidota",
    "group_saved": "Grupa \"{name}\" saglabāta",
    "group_deleted": "Grupa \"{name}\" dzēsta",
    "picker": {
      "select_by_group": "Izvēlēties pēc grupas",
      "hint": "Izvēloties grupu, tiek pievienotas tās pašreizējās ierīces. Vēlāk grupai pievienotās ierīces šeit netiek pievienotas.",
      "group_partial_count": "{selected} no {count} ierīcēm",
      "other_devices": "Citas ierīces",
      "more": "+{count} vēl",
      "show_less": "Rādīt mazāk"
    },
    "filter": {
      "groups": "Grupas",
      "devices": "Ierīces",
      "n_groups": "Nav grupu | {count} grupa | {count} grupas"
    },
    "errors": {
      "name_taken": "Grupa ar šādu nosaukumu jau pastāv.",
      "limit_reached": "Uzņēmumam jau ir maksimālais ierīču grupu skaits.",
      "unknown_devices": "Dažas ierīces vairs nav pieejamas. Pārlādējiet lapu un mēģiniet vēlreiz.",
      "devices_in_other_group": "Dažas ierīces jau pieder citai grupai: {devices}"
    }
  }
}
